webpackJsonp([2,128],{

/***/ 1294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationInternRecordTable_vue__ = __webpack_require__(3052);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5def66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationInternRecordTable_vue__ = __webpack_require__(5655);
function injectStyle (ssrContext) {
  __webpack_require__(5650)
  __webpack_require__(5652)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad5def66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationInternRecordTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5def66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationInternRecordTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationTable_vue__ = __webpack_require__(3058);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cf826b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationTable_vue__ = __webpack_require__(5675);
function injectStyle (ssrContext) {
  __webpack_require__(5673)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21cf826b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExaminationTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cf826b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExaminationTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingExaminationTable_vue__ = __webpack_require__(3060);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5ccfb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingExaminationTable_vue__ = __webpack_require__(5681);
function injectStyle (ssrContext) {
  __webpack_require__(5679)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed5ccfb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingExaminationTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed5ccfb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingExaminationTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(73);

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1450), __esModule: true };

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
module.exports = __webpack_require__(12).Set;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1421)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1425)('Set') });


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1427)('Set');


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1428)('Set');


/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingInstructionSubHeading',
  props: {
    title: {
      type: String,
      required: true
    },
    entityId: {
      type: [Number, String],
      default: null
    },
    fallbackPath: {
      type: String,
      default: '/training/instruction'
    }
  },
  computed: {
    hasEntityId: function hasEntityId() {
      return this.entityId !== null && this.entityId !== undefined && this.entityId !== '';
    }
  },
  methods: {
    onBack: function onBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.fallbackPath);
    }
  }
});

/***/ }),

/***/ 1606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildDefaultColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveVisibleColumns;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadColumnConfig;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveColumnConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


var STORAGE_PREFIX = 'table-column-config:';

function buildDefaultColumnConfig(definitions) {
  return definitions.map(function (col) {
    return {
      key: col.key,
      visible: col.defaultVisible !== false
    };
  });
}

function normalizeColumnConfig(definitions, savedConfig) {
  var definitionMap = _.keyBy(definitions, 'key');

  if (!savedConfig || !Array.isArray(savedConfig.columns)) {
    return buildDefaultColumnConfig(definitions);
  }

  var savedKeys = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
  var result = [];

  savedConfig.columns.forEach(function (item) {
    var definition = definitionMap[item.key];
    if (!definition) {
      return;
    }
    savedKeys.add(item.key);
    result.push({
      key: item.key,
      visible: definition.locked ? true : item.visible !== false
    });
  });

  definitions.forEach(function (col) {
    if (!savedKeys.has(col.key)) {
      result.push({
        key: col.key,
        visible: col.defaultVisible !== false
      });
    }
  });

  return result;
}

function resolveVisibleColumns(definitions, config) {
  var definitionMap = _.keyBy(definitions, 'key');

  return config.filter(function (item) {
    return item.visible && definitionMap[item.key];
  }).map(function (item) {
    return definitionMap[item.key];
  });
}

function loadColumnConfig(storageKey) {
  if (!storageKey) {
    return null;
  }
  try {
    var raw = localStorage.getItem('' + STORAGE_PREFIX + storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function saveColumnConfig(storageKey, config) {
  if (!storageKey) {
    return;
  }
  localStorage.setItem('' + STORAGE_PREFIX + storageKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config));
}

/***/ }),

/***/ 1607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_table_column_config__ = __webpack_require__(1606);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableColumnConfigDialog',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appliedColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    definitions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      sortableDraft: [],
      lockedDraft: []
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    definitionMap: function definitionMap() {
      var map = {};
      this.definitions.forEach(function (item) {
        map[item.key] = item;
      });
      return map;
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) {
        this.initDraft();
      }
    }
  },
  methods: {
    initDraft: function initDraft() {
      var draft = this.buildDraftItems(this.appliedColumns);
      this.sortableDraft = draft.filter(function (item) {
        return !item.locked;
      });
      this.lockedDraft = draft.filter(function (item) {
        return item.locked;
      });
    },
    buildDraftItems: function buildDraftItems(columns) {
      var _this = this;

      return columns.map(function (item) {
        var definition = _this.definitionMap[item.key] || {};
        return {
          key: item.key,
          visible: definition.locked ? true : item.visible !== false,
          label: definition.label || item.key,
          locked: !!definition.locked
        };
      });
    },
    getMergedDraft: function getMergedDraft() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.sortableDraft), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.lockedDraft)).map(function (item) {
        return {
          key: item.key,
          visible: item.visible
        };
      });
    },
    onReset: function onReset() {
      var defaultConfig = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_table_column_config__["a" /* buildDefaultColumnConfig */])(this.definitions);
      var draft = this.buildDraftItems(defaultConfig);
      this.sortableDraft = draft.filter(function (item) {
        return !item.locked;
      });
      this.lockedDraft = draft.filter(function (item) {
        return item.locked;
      });
    },
    onCancel: function onCancel() {
      this.dialogVisible = false;
      this.$emit('cancel');
    },
    onSave: function onSave() {
      var _this2 = this;

      var draft = this.getMergedDraft();
      var visibleCount = draft.filter(function (item) {
        var definition = _this2.definitionMap[item.key] || {};
        return item.visible && !definition.locked;
      }).length;

      if (visibleCount === 0) {
        this.$message.warning('请至少保留一列');
        return;
      }

      this.$emit('save', draft);
      this.dialogVisible = false;
    },
    onClosed: function onClosed() {
      this.sortableDraft = [];
      this.lockedDraft = [];
    }
  }
});

/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67108e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67108e77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionSubHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSuperAdminUser;
function isSuperAdminUser(user) {
  return Number(user && user.usertype) === 1;
}

/***/ }),

/***/ 1665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 所属用户类型
  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 培训状态
  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,

  // 培训类型
  TYPE_ONLY_LEARNING: 1,
  TYPE_ONLY_EXAM: 2,
  TYPE_LEARNING_AND_EXAM: 3,

  // 考试状态
  EXAMINATION_STATUS_ONLINE: 2
};

var opts = {
  boolMaps: [{ value: consts.TRUE, label: '是' }, { value: consts.FALSE, label: '否' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }],
  typeMaps: [{ value: consts.TYPE_ONLY_LEARNING, label: '仅学习' }, { value: consts.TYPE_ONLY_EXAM, label: '仅考试' }, { value: consts.TYPE_LEARNING_AND_EXAM, label: '学习+考试' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }]
};

var TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-list';

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c279ecb4", content, true, {});

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px}.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0}.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4}.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0}.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingInstructionSubHeading.vue"],"names":[],"mappings":"AACA,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,CACpM,AACD,yDAAyD,oBAAoB,aAAa,CACzF,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,mBAAmB,eAAe,SAAS,eAAe,gBAAgB,cAAc,eAAe,CAC/R,AACD,+DAA+D,WAAW,CACzE,AACD,6DAA6D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,cAAc,gBAAgB,kBAAkB,eAAe,gBAAgB,iBAAiB,cAAc,mBAAmB,yBAAyB,iCAAiC,CACvZ","file":"TrainingInstructionSubHeading.vue","sourcesContent":["\n.training-instruction-sub-heading[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;margin-bottom:16px\n}\n.training-instruction-sub-heading__back[data-v-67108e77]{-ms-flex-negative:0;flex-shrink:0\n}\n.training-instruction-sub-heading__title[data-v-67108e77]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;font-size:20px;font-weight:600;color:#303133;line-height:1.4\n}\n.training-instruction-sub-heading__title-text[data-v-67108e77]{min-width:0\n}\n.training-instruction-sub-heading__id-badge[data-v-67108e77]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;padding:2px 8px;border-radius:4px;font-size:12px;font-weight:500;line-height:20px;color:#606266;background:#f4f4f5;border:1px solid #e9e9eb;font-variant-numeric:tabular-nums\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-instruction-sub-heading"},[_c('el-button',{staticClass:"training-instruction-sub-heading__back",attrs:{"icon":"el-icon-arrow-left","circle":""},on:{"click":_vm.onBack}}),_vm._v(" "),_c('h2',{staticClass:"training-instruction-sub-heading__title"},[_c('span',{staticClass:"training-instruction-sub-heading__title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.hasEntityId)?_c('span',{staticClass:"training-instruction-sub-heading__id-badge"},[_vm._v("ID："+_vm._s(_vm.entityId))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSE_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["k"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* harmony export (immutable) */ __webpack_exports__["i"] = getFileExtension;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseFileTypeByFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);





var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  INTERN_SCOPE_ALL: 1, // 全部实习生
  INTERN_SCOPE_SPECIFIC: 2, // 指定实习生

  KNOWLEDGE_STATUS_ACTIVE: 2
};

var COURSE_FILE_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
  PPT: 'ppt',
  WORD: 'word',
  EXCEL: 'excel'
};

var opts = {
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  InternScopeMaps: [{ value: consts.INTERN_SCOPE_ALL, label: '全部' }, { value: consts.INTERN_SCOPE_SPECIFIC, label: '指定' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineInternTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banInternTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeInternTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  label: '图片'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 0,
  maxSizeMB: 1024,
  label: '视频'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PDF, {
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PDF'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PPT, {
  accept: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  extensions: ['ppt', 'pptx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PPT'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.WORD, {
  accept: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  extensions: ['doc', 'docx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Word'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.EXCEL, {
  accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  extensions: ['xls', 'xlsx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Excel'
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseFileTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0) {
    return COURSE_FILE_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0) {
    return COURSE_FILE_TYPES.VIDEO;
  }
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_FILE_TYPES).some(function (key) {
    return COURSE_FILE_TYPES[key] === type;
  })) {
    return type;
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).find(function (fileType) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    return config.accept.includes(type) || config.extensions.includes(ext);
  }) || '';
}

function getCourseUploadConfig(fileType) {
  if (fileType && COURSE_UPLOAD_TYPE_CONFIGS[fileType]) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    var maxSizeLabel = config.maxSizeMB >= 1024 ? (config.maxSizeMB / 1024).toFixed(config.maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : config.maxSizeMB + 'MB';
    var maxFilesLabel = config.maxFiles > 0 ? '\u6700\u591A ' + config.maxFiles + ' \u4E2A' : '可上传多个';

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, {
      tip: '\u652F\u6301\u4E0A\u4F20' + config.label + '\uFF0C' + maxFilesLabel + '\uFF0C\u5355\u4E2A\u6700\u5927 ' + maxSizeLabel
    });
  }

  var configs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
    return COURSE_UPLOAD_TYPE_CONFIGS[type];
  });
  return {
    accept: configs.reduce(function (result, item) {
      return result.concat(item.accept);
    }, []),
    extensions: configs.reduce(function (result, item) {
      return result.concat(item.extensions);
    }, []),
    maxFiles: 0,
    maxSizeMB: Math.max.apply(null, configs.map(function (item) {
      return item.maxSizeMB;
    })),
    tip: '支持图片、视频、PDF、PPT、Word、Excel，可上传多个文件，单个文件大小按类型限制'
  };
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var fileType = getCourseFileTypeByFile(file);
  if (!fileType) {
    return {
      valid: false,
      fileType: fileType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(fileType);
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  var currentTypeCount = Array.isArray(currentFiles) ? currentFiles.filter(function (item) {
    return getCourseFileTypeByFile(item) === fileType;
  }).length : 0;
  if (config.maxFiles > 0 && currentTypeCount >= config.maxFiles) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  return {
    valid: true,
    fileType: fileType,
    message: '',
    replaceAll: false
  };
}

/***/ }),

/***/ 1706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_TableColumnConfigDialog_vue__ = __webpack_require__(1800);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TableColumnConfigDialog: __WEBPACK_IMPORTED_MODULE_1__core_components_TableColumnConfigDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableColumnConfigDialogVisible: false,
      tableColumnAppliedConfig: [],
      tableColumnRenderKey: 0
    };
  },
  created: function created() {
    this.initTableColumnConfig();
  },

  computed: {
    activeTableColumns: function activeTableColumns() {
      var _this = this;

      var columns = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["d" /* resolveVisibleColumns */])(this.getTableColumnDefinitions(), this.tableColumnAppliedConfig);
      return columns.filter(function (column) {
        return _this.isTableColumnContextVisible(column);
      });
    }
  },
  methods: {
    getTableColumnDefinitions: function getTableColumnDefinitions() {
      return this.fields || [];
    },
    getTableColumnStorageKey: function getTableColumnStorageKey() {
      return '';
    },
    isTableColumnContextVisible: function isTableColumnContextVisible(column) {
      if (!column.visibleWhen) {
        return true;
      }
      if (typeof column.visibleWhen === 'function') {
        return column.visibleWhen.call(this);
      }
      if (typeof column.visibleWhen === 'string') {
        return !!this[column.visibleWhen];
      }
      return true;
    },
    initTableColumnConfig: function initTableColumnConfig() {
      var definitions = this.getTableColumnDefinitions();
      var saved = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["b" /* loadColumnConfig */])(this.getTableColumnStorageKey());
      this.tableColumnAppliedConfig = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["c" /* normalizeColumnConfig */])(definitions, saved);
    },
    openTableColumnConfigDialog: function openTableColumnConfigDialog() {
      this.tableColumnConfigDialogVisible = true;
    },
    onTableColumnConfigSave: function onTableColumnConfigSave(draft) {
      this.tableColumnAppliedConfig = _.cloneDeep(draft);
      Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_table_column_config__["e" /* saveColumnConfig */])(this.getTableColumnStorageKey(), {
        columns: this.tableColumnAppliedConfig
      });
      this.tableColumnRenderKey += 1;
      this.$message.success('列配置已保存');
    }
  }
});

/***/ }),

/***/ 1800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableColumnConfigDialog_vue__ = __webpack_require__(1607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7827dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableColumnConfigDialog_vue__ = __webpack_require__(1805);
function injectStyle (ssrContext) {
  __webpack_require__(1801)
  __webpack_require__(1803)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f7827dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableColumnConfigDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7827dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableColumnConfigDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1801:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("16fd6716", content, true, {});

/***/ }),

/***/ 1802:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".table-column-config-dialog__tip[data-v-7f7827dc]{margin:0 0 12px;color:#909399;font-size:13px;line-height:1.6}.table-column-config-dialog__body[data-v-7f7827dc]{max-height:420px;overflow-y:auto;padding-right:4px}.table-column-config-dialog__list[data-v-7f7827dc],.table-column-config-dialog__locked-list[data-v-7f7827dc]{display:block}.table-column-config-dialog__item[data-v-7f7827dc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;margin-bottom:8px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc}.table-column-config-dialog__item.is-locked[data-v-7f7827dc]{background:#f5f7fa}.table-column-config-dialog__item-ghost[data-v-7f7827dc]{opacity:.6;background:#ecf5ff}.table-column-config-dialog__locked-list[data-v-7f7827dc]{margin-top:4px;padding-top:8px;border-top:1px dashed #ebeef5}.table-column-config-dialog__drag-handle[data-v-7f7827dc]{color:#c0c4cc;cursor:move;font-size:16px;-ms-flex-negative:0;flex-shrink:0}.table-column-config-dialog__drag-placeholder[data-v-7f7827dc]{width:16px;-ms-flex-negative:0;flex-shrink:0}.table-column-config-dialog__locked-tag[data-v-7f7827dc]{margin-left:auto;color:#909399;font-size:12px}", "", {"version":3,"sources":["/workspace/core/components/TableColumnConfigDialog.vue"],"names":[],"mappings":"AACA,kDAAkD,gBAAgB,cAAc,eAAe,eAAe,CAC7G,AACD,mDAAmD,iBAAiB,gBAAgB,iBAAiB,CACpG,AACD,6GAA6G,aAAa,CACzH,AACD,mDAAmD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,kBAAkB,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CACnR,AACD,6DAA6D,kBAAkB,CAC9E,AACD,yDAAyD,WAAY,kBAAkB,CACtF,AACD,0DAA0D,eAAe,gBAAgB,6BAA6B,CACrH,AACD,0DAA0D,cAAc,YAAY,eAAe,oBAAoB,aAAa,CACnI,AACD,+DAA+D,WAAW,oBAAoB,aAAa,CAC1G,AACD,yDAAyD,iBAAiB,cAAc,cAAc,CACrG","file":"TableColumnConfigDialog.vue","sourcesContent":["\n.table-column-config-dialog__tip[data-v-7f7827dc]{margin:0 0 12px;color:#909399;font-size:13px;line-height:1.6\n}\n.table-column-config-dialog__body[data-v-7f7827dc]{max-height:420px;overflow-y:auto;padding-right:4px\n}\n.table-column-config-dialog__list[data-v-7f7827dc],.table-column-config-dialog__locked-list[data-v-7f7827dc]{display:block\n}\n.table-column-config-dialog__item[data-v-7f7827dc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 12px;margin-bottom:8px;border:1px solid #ebeef5;border-radius:8px;background:#fafbfc\n}\n.table-column-config-dialog__item.is-locked[data-v-7f7827dc]{background:#f5f7fa\n}\n.table-column-config-dialog__item-ghost[data-v-7f7827dc]{opacity:0.6;background:#ecf5ff\n}\n.table-column-config-dialog__locked-list[data-v-7f7827dc]{margin-top:4px;padding-top:8px;border-top:1px dashed #ebeef5\n}\n.table-column-config-dialog__drag-handle[data-v-7f7827dc]{color:#c0c4cc;cursor:move;font-size:16px;-ms-flex-negative:0;flex-shrink:0\n}\n.table-column-config-dialog__drag-placeholder[data-v-7f7827dc]{width:16px;-ms-flex-negative:0;flex-shrink:0\n}\n.table-column-config-dialog__locked-tag[data-v-7f7827dc]{margin-left:auto;color:#909399;font-size:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1803:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1804);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13d04a60", content, true, {});

/***/ }),

/***/ 1804:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px}", "", {"version":3,"sources":["/workspace/core/components/TableColumnConfigDialog.vue"],"names":[],"mappings":"AACA,6CAA6C,iBAAiB,mBAAmB,CAChF","file":"TableColumnConfigDialog.vue","sourcesContent":["\n.table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"列配置","width":"520px","visible":_vm.dialogVisible,"close-on-click-modal":false,"append-to-body":"","custom-class":"table-column-config-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"closed":_vm.onClosed}},[_c('p',{staticClass:"table-column-config-dialog__tip"},[_vm._v("拖拽调整列顺序，勾选控制列显示。保存后生效，取消则不修改。")]),_vm._v(" "),_c('div',{staticClass:"table-column-config-dialog__body"},[_c('draggable',{staticClass:"table-column-config-dialog__list",attrs:{"tag":"div","handle":".table-column-config-dialog__drag-handle","animation":200,"ghost-class":"table-column-config-dialog__item-ghost"},model:{value:(_vm.sortableDraft),callback:function ($$v) {_vm.sortableDraft=$$v},expression:"sortableDraft"}},_vm._l((_vm.sortableDraft),function(item){return _c('div',{key:item.key,staticClass:"table-column-config-dialog__item"},[_c('i',{staticClass:"el-icon-rank table-column-config-dialog__drag-handle"}),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":item.locked},model:{value:(item.visible),callback:function ($$v) {_vm.$set(item, "visible", $$v)},expression:"item.visible"}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])],1)}),0),_vm._v(" "),(_vm.lockedDraft.length)?_c('div',{staticClass:"table-column-config-dialog__locked-list"},_vm._l((_vm.lockedDraft),function(item){return _c('div',{key:item.key,staticClass:"table-column-config-dialog__item is-locked"},[_c('span',{staticClass:"table-column-config-dialog__drag-placeholder"}),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":""},model:{value:(item.visible),callback:function ($$v) {_vm.$set(item, "visible", $$v)},expression:"item.visible"}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"table-column-config-dialog__locked-tag"},[_vm._v("固定")])],1)}),0):_vm._e()],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('el-button',{on:{"click":_vm.onReset}},[_vm._v("恢复默认")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSave}},[_vm._v("保存")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  SOURCE_TYPE_TASK: 1,
  SOURCE_TYPE_LEARNING_CENTER: 2,
  SOURCE_TYPE_ASSIGN: 3,

  STATUS_LEARNING: 1,
  STATUS_LEARN_FINISHED: 2,
  STATUS_WAIT_EXAM: 3,
  STATUS_ON_EXAM: 4,
  STATUS_PASSED: 5,
  STATUS_EXAM_NOT_PASS: 6,
  STATUS_EXAM_WAIT_RETRY: 7,

  EXAMINATION_STATUS_NOT_START: 0,
  EXAMINATION_STATUS_WAIT_SUBMIT: 1,
  EXAMINATION_STATUS_PASS: 2,
  EXAMINATION_STATUS_NOT_PASS: 3,
  EXAMINATION_STATUS_SUBMITTED: 4
};

var opts = {
  sourceTypeMaps: [{ value: consts.SOURCE_TYPE_TASK, label: '批次任务' }, { value: consts.SOURCE_TYPE_LEARNING_CENTER, label: '学习中心' }, { value: consts.SOURCE_TYPE_ASSIGN, label: '管理员分配' }],
  recordStatusMaps: [{ value: consts.STATUS_LEARNING, label: '学习中' }, { value: consts.STATUS_LEARN_FINISHED, label: '已学完' }, { value: consts.STATUS_WAIT_EXAM, label: '待考试' }, { value: consts.STATUS_ON_EXAM, label: '考试中' }, { value: consts.STATUS_PASSED, label: '通过' }, { value: consts.STATUS_EXAM_NOT_PASS, label: '考试未通过' }, { value: consts.STATUS_EXAM_WAIT_RETRY, label: '待重考' }],
  examinationStatusMaps: [{ value: consts.EXAMINATION_STATUS_NOT_START, label: '未开始' }, { value: consts.EXAMINATION_STATUS_WAIT_SUBMIT, label: '待提交' }, { value: consts.EXAMINATION_STATUS_PASS, label: '通过' }, { value: consts.EXAMINATION_STATUS_NOT_PASS, label: '不通过' }, { value: consts.EXAMINATION_STATUS_SUBMITTED, label: '已提交' }]
};

var TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-record-list';
var TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-exam-record-list';

/***/ }),

/***/ 1830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExamStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getExamStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExamStatusActions;
/* harmony export (immutable) */ __webpack_exports__["o"] = isExamStructureLocked;
/* harmony export (immutable) */ __webpack_exports__["l"] = isExamReadonly;
/* harmony export (immutable) */ __webpack_exports__["m"] = isExamScopeLocked;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExamScoreLocked;
/* harmony export (immutable) */ __webpack_exports__["j"] = isExamAnswerLocked;
/* harmony export (immutable) */ __webpack_exports__["k"] = isExamOptionStructureLocked;
/* unused harmony export createExamQuestionClientId */
/* harmony export (immutable) */ __webpack_exports__["c"] = createExamQuestion;
/* harmony export (immutable) */ __webpack_exports__["p"] = normalizeExamQuestionFromRow;
/* unused harmony export getExamQuestionSubmitPayload */
/* harmony export (immutable) */ __webpack_exports__["h"] = getExamSubmitPayload;
/* unused harmony export TRAINING_EXAM_COPY_TYPE */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExamQuestionDuplicateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);






var consts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["b" /* consts */], {
  OPEN_BOOK_EXAM_OPEN: 1,
  OPEN_BOOK_EXAM_CLOSED: 2,
  SORT_TYPE_FIXED: 1,
  SORT_TYPE_RANDOM: 2
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_constants__["i" /* opts */].statusMaps,
  openBookMaps: [{ value: consts.OPEN_BOOK_EXAM_OPEN, label: '开卷' }, { value: consts.OPEN_BOOK_EXAM_CLOSED, label: '闭卷' }],
  sortTypeMaps: [{ value: consts.SORT_TYPE_FIXED, label: '固定顺序' }, { value: consts.SORT_TYPE_RANDOM, label: '乱序' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getExamStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getExamStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getExamStatusActions(status) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{
        name: 'offline',
        label: '下架',
        type: 'warning',
        apiName: 'offlineTrainingExamination',
        successText: '下架成功'
      }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingExamination', successText: '作废成功' }, { name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingExamination', successText: '上架成功' }];
    case consts.STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingExamination', successText: '激活成功' }];
    default:
      return [];
  }
}

function isExamStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamReadonly(status) {
  return Number(status) === consts.STATUS_BANNED;
}

function isExamScopeLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_OFFLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamScoreLocked(status) {
  return Number(status) !== consts.STATUS_NEW;
}

function isExamAnswerLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamOptionStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function createExamQuestionClientId() {
  return 'examq' + Math.random().toString(16).slice(2) + Date.now();
}

function createExamQuestion() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var questionType = Number(type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    client_id: createExamQuestionClientId(),
    source_question_id: null,
    target_usertype: null,
    customerid: null,
    training_knowledge_id: null,
    question_type: questionType,
    title: '',
    sample_files: [],
    options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType) ? Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])() : [],
    standard_answer: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: '',
    analysis_files: []
  }, overrides);
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

// 格式化每个题目，扁平化，原因是题目组件当时重新组装了form，这里复用组件也需要重新组装一下后端或者粘贴的题目结构
function normalizeExamQuestionFromRow(row) {
  var questionJson = row.question_json || {};
  var analysis = questionJson.question_analysis || {};
  var questionType = Number(row.question_type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var standardAnswer = hasValue(questionJson.standard_answer) ? questionJson.standard_answer : row.standard_answer;

  return createExamQuestion(questionType, {
    title: row.title || questionJson.title || '',
    source_question_id: row.id || null,
    target_usertype: hasValue(row.target_usertype) ? row.target_usertype : null,
    customerid: hasValue(row.customerid) ? row.customerid : null,
    training_knowledge_id: hasValue(row.training_knowledge_id) ? row.training_knowledge_id : null,
    sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
    options: Array.isArray(questionJson.options) ? questionJson.options : [],
    standard_answer: hasValue(standardAnswer) ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: analysis.analysis_text || '',
    analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
  });
}

// 格式化每道题目，如果后续没有改动可以复用training-question.constants-getQuestionSubmitPayload方法，先这样各自处理吧
function getExamQuestionSubmitPayload(question) {
  var questionType = Number(question.question_type);
  var questionJson = {
    title: question.title || '',
    sample_files: question.sample_files || [],
    question_analysis: {
      analysis_text: question.analysis_text || '',
      analysis_files: question.analysis_files || []
    },
    standard_answer: question.standard_answer
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType)) {
    questionJson.options = question.options || [];
  }

  return {
    id: question.source_question_id || question.id || null,
    question_type: questionType,
    question_json: questionJson
  };
}

function getExamSubmitPayload(form) {
  return {
    title: form.title,
    target_usertype: String(form.target_usertype),
    is_common: Number(form.is_common),
    customerid: Number(form.customerid) || 0,
    training_knowledge_id: Number(form.training_knowledge_id),
    open_book_exam: Number(form.open_book_exam),
    question_score: Number(form.question_score),
    passing_score: Number(form.passing_score),
    exam_duration: Number(form.exam_duration),
    question_sort_type: Number(form.question_sort_type),
    question_options_sort_type: Number(form.question_options_sort_type),
    question_list: (form.question_list || []).map(function (question) {
      return getExamQuestionSubmitPayload(question);
    })
  };
}

var TRAINING_EXAM_COPY_TYPE = 'training-exam';

function buildTrainingExamCopyData(form) {
  var data = getExamSubmitPayload(form);
  return {
    version: 1,
    date: new Date().toISOString(),
    type: TRAINING_EXAM_COPY_TYPE,
    title: data.title,
    data: data
  };
}

function normalizeTrainingExamCopyData(copyData) {
  if (!copyData || copyData.type !== TRAINING_EXAM_COPY_TYPE || !copyData.data) {
    return null;
  }

  var data = copyData.data;
  return {
    title: data.title || '',
    target_usertype: Number(data.target_usertype) || consts.TARGETUSER_TYPE_USER,
    is_common: Number(data.is_common || consts.IS_COMMON_DEDICATED),
    customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
    training_knowledge_id: data.training_knowledge_id || null,
    open_book_exam: Number(data.open_book_exam) || consts.OPEN_BOOK_EXAM_CLOSED,
    question_score: Number(data.question_score) || 10,
    passing_score: Number(data.passing_score) || 60,
    exam_duration: Number(data.exam_duration) || 60,
    question_sort_type: Number(data.question_sort_type) || consts.SORT_TYPE_FIXED,
    question_options_sort_type: Number(data.question_options_sort_type) || consts.SORT_TYPE_FIXED,
    question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
      return normalizeExamQuestionFromRow(item);
    }) : []
  };
}

// 不做前端验证，代码先保留 重复项检查比对的是选项显示的内容，而不是内部的选项 UUID
function getChoiceAnswerIndex(answer, options) {
  return options.findIndex(function (option) {
    return option.uuid === answer;
  });
}

function getChoiceDuplicateAnswer(questionType, questionJson, options) {
  if (Number(questionType) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI) {
    return (Array.isArray(questionJson.standard_answer) ? questionJson.standard_answer : []).map(function (answer) {
      return getChoiceAnswerIndex(answer, options);
    }).sort(function (prev, next) {
      return prev - next;
    });
  }
  return getChoiceAnswerIndex(questionJson.standard_answer, options);
}

function getExamQuestionDuplicateKey(question) {
  var payload = getExamQuestionSubmitPayload(question);
  var questionJson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.question_json);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(payload.question_type)) {
    var options = Array.isArray(questionJson.options) ? questionJson.options : [];
    // 取标题检测
    questionJson.options = options.map(function (option) {
      return {
        title: option.title || ''
      };
    });
    questionJson.standard_answer = getChoiceDuplicateAnswer(payload.question_type, questionJson, options);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    question_type: payload.question_type,
    question_json: questionJson
  });
}

/***/ }),

/***/ 2097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_column_config__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_exam_record_table_fields__ = __webpack_require__(2495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_instruction_constants__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_training_components_TrainingInstructionSubHeading_vue__ = __webpack_require__(1612);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TrainingInstructionSubHeading: __WEBPACK_IMPORTED_MODULE_7__views_training_components_TrainingInstructionSubHeading_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_column_config__["a" /* default */]],
  data: function data() {
    return {
      searchExpanded: true,
      listExpanded: true,
      opts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["d" /* opts */],
      targetUserMaps: __WEBPACK_IMPORTED_MODULE_6__views_training_training_instruction_constants__["c" /* opts */].targetUserMaps,
      instruction: {
        id: 0,
        title: ''
      },
      examination: {
        id: 0,
        title: ''
      },
      chinaAreaData: [],
      search: {
        keyword: '',
        examination_status: null,
        target_usertype: null,
        source_type: null,
        projectid: null,
        batchid: null,
        regionids: [],
        examination_submitted_at: []
      },
      searchFieldType: {
        examination_status: Number,
        target_usertype: Number,
        source_type: Number,
        projectid: Number,
        batchid: Number,
        regionids: Array,
        examination_submitted_at: Array
      },
      examStatusOptions: __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["d" /* opts */].examinationStatusMaps.filter(function (it) {
        return it.value !== __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_START;
      }),
      fields: Object(__WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_exam_record_table_fields__["a" /* createTrainingInstructionExamRecordTableFields */])(this)
    };
  },

  computed: {
    pageHeadingTitle: function pageHeadingTitle() {
      if (this.instruction.id) {
        return this.$route.meta.title + ' \xB7 ' + this.instruction.title;
      }

      if (this.examination.id) {
        return this.$route.meta.title + ' \xB7 ' + this.examination.title;
      }

      return this.$route.meta.title || '';
    },
    pageEntityId: function pageEntityId() {
      if (this.instruction.id) {
        return this.instruction.id;
      }

      if (this.examination.id) {
        return this.examination.id;
      }

      return null;
    },
    pageTitle: function pageTitle() {
      var entityId = this.pageEntityId;
      if (!entityId) {
        return this.pageHeadingTitle;
      }

      return this.pageHeadingTitle + ' ID\uFF1A' + entityId;
    },
    activeTableFields: function activeTableFields() {
      var fieldMap = _.keyBy(this.fields, 'key');
      return this.activeTableColumns.map(function (column) {
        return fieldMap[column.key];
      }).filter(Boolean);
    }
  },
  created: function created() {
    this.syncPageContext();
    this.getChinaAreaData();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.syncPageContext(to);
    this.onSearch();
    next();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getTableColumnStorageKey: function getTableColumnStorageKey() {
      return __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["a" /* TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY */];
    },
    getFieldColumnBind: function getFieldColumnBind(field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS);
    }
  }, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), {
    loadInstruction: function loadInstruction() {
      var _this = this;

      if (!this.instruction.id) {
        return;
      }
      var instructionId = this.instruction.id;
      request.common('getTrainingInstruction', { id: instructionId }).then(function (_ref) {
        var data = _ref.data;

        if (Number(_this.instruction.id) !== Number(instructionId)) {
          return;
        }
        _this.instruction.title = data.title;
      }).catch(function () {});
    },
    loadExamination: function loadExamination() {
      var _this2 = this;

      if (!this.examination.id) {
        return;
      }
      var examinationId = this.examination.id;
      request.common('getTrainingExamination', { id: examinationId }).then(function (_ref2) {
        var data = _ref2.data;

        if (Number(_this2.examination.id) !== Number(examinationId)) {
          return;
        }
        _this2.examination.title = data.title;
      }).catch(function () {});
    },
    syncPageContext: function syncPageContext() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route;

      var instructionId = route.params.instructionId ? Number(route.params.instructionId) : 0;
      var examinationId = route.params.examinationId ? Number(route.params.examinationId) : 0;
      var queryTitle = route.query.title || '';

      if (instructionId > 0) {
        this.instruction.id = instructionId;
        if (queryTitle) {
          this.instruction.title = queryTitle;
        }
        this.loadInstruction();
      } else {
        this.instruction.id = 0;
        this.instruction.title = '';
      }

      if (examinationId > 0) {
        this.examination.id = examinationId;
        if (queryTitle) {
          this.examination.title = queryTitle;
        }
        this.loadExamination();
      } else {
        this.examination.id = 0;
        this.examination.title = '';
      }
    },
    getTableData: function getTableData(params) {
      delete params.id;
      delete params.title;
      delete params.recordId;
      delete params.instructionId;
      delete params.examinationId;

      if (this.instruction.id) {
        params.training_instruction_id = this.instruction.id;
      }
      if (this.examination.id) {
        params.training_examination_id = this.examination.id;
      }
      return request.page('queryTrainingInstructionExamRecord', params);
    },
    getDetailLink: function getDetailLink(row) {
      var instructionId = row.training_instruction_id || this.instruction.id;
      var title = this.instruction.title || row.instruction_title || '';
      return {
        path: '/training/instruction/exam-records/' + instructionId + '/detail/' + row.id,
        query: { title: title }
      };
    },
    getExamStatusTagClass: function getExamStatusTagClass(status) {
      var value = Number(status);
      if (value === __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_PASS) {
        return 'is-pass';
      }
      if (value === __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_NOT_PASS) {
        return 'is-fail';
      }
      if (value === __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_WAIT_SUBMIT) {
        return 'is-pending';
      }
      if (value === __WEBPACK_IMPORTED_MODULE_4__views_training_training_instruction_record_constants__["c" /* consts */].EXAMINATION_STATUS_SUBMITTED) {
        return 'is-submitted';
      }
      return 'is-default';
    },
    resetSearch: function resetSearch() {
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    getChinaAreaData: function getChinaAreaData() {
      var _this3 = this;

      request.alert('queryAllFormatted').then(function (_ref3) {
        var data = _ref3.data;

        _this3.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
      }).catch(function () {
        _this3.chinaAreaData = [];
      });
    }
  })
});

/***/ }),

/***/ 2098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExamStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getExamStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExamStatusActions;
/* harmony export (immutable) */ __webpack_exports__["o"] = isExamStructureLocked;
/* harmony export (immutable) */ __webpack_exports__["l"] = isExamReadonly;
/* harmony export (immutable) */ __webpack_exports__["m"] = isExamScopeLocked;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExamScoreLocked;
/* harmony export (immutable) */ __webpack_exports__["j"] = isExamAnswerLocked;
/* harmony export (immutable) */ __webpack_exports__["k"] = isExamOptionStructureLocked;
/* unused harmony export createExamQuestionClientId */
/* harmony export (immutable) */ __webpack_exports__["c"] = createExamQuestion;
/* harmony export (immutable) */ __webpack_exports__["p"] = normalizeExamQuestionFromRow;
/* unused harmony export getExamQuestionSubmitPayload */
/* harmony export (immutable) */ __webpack_exports__["h"] = getExamSubmitPayload;
/* unused harmony export TRAINING_EXAM_COPY_TYPE */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["q"] = normalizeTrainingExamCopyData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExamQuestionDuplicateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);






var consts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["c" /* consts */], {
  OPEN_BOOK_EXAM_OPEN: 1,
  OPEN_BOOK_EXAM_CLOSED: 2,
  SORT_TYPE_FIXED: 1,
  SORT_TYPE_RANDOM: 2,
  RECORD_STATUS_EXAMINING: 1, // 考试中
  RECORD_STATUS_PASS: 2, // 通过
  RECORD_STATUS_UNPASS: 3 // 未通过
});

var opts = {
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].isCommonMaps,
  InternScopeMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].InternScopeMaps,
  statusMaps: __WEBPACK_IMPORTED_MODULE_3__views_training_training_course_intern_constants__["l" /* opts */].statusMaps,
  openBookMaps: [{ value: consts.OPEN_BOOK_EXAM_OPEN, label: '开卷' }, { value: consts.OPEN_BOOK_EXAM_CLOSED, label: '闭卷' }],
  sortTypeMaps: [{ value: consts.SORT_TYPE_FIXED, label: '固定顺序' }, { value: consts.SORT_TYPE_RANDOM, label: '乱序' }],
  // 答卷状态
  recordStatusMaps: [{ value: consts.RECORD_STATUS_EXAMINING, label: '考试中' }, { value: consts.RECORD_STATUS_PASS, label: '通过' }, { value: consts.RECORD_STATUS_UNPASS, label: '未通过' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getExamStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getExamStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getExamStatusActions(status) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{
        name: 'online',
        label: '上架',
        type: 'success',
        apiName: 'onlineTrainingExaminationIntern',
        successText: '上架成功'
      }];
    case consts.STATUS_ONLINE:
      return [{
        name: 'offline',
        label: '下架',
        type: 'warning',
        apiName: 'offlineTrainingExaminationIntern',
        successText: '下架成功'
      }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingExaminationIntern', successText: '作废成功' }, {
        name: 'online',
        label: '上架',
        type: 'success',
        apiName: 'onlineTrainingExaminationIntern',
        successText: '上架成功'
      }];
    case consts.STATUS_BANNED:
      return [{
        name: 'active',
        label: '激活',
        type: 'primary',
        apiName: 'activeTrainingExaminationIntern',
        successText: '激活成功'
      }];
    default:
      return [];
  }
}

function isExamStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamReadonly(status) {
  return Number(status) === consts.STATUS_BANNED;
}

function isExamScopeLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_OFFLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamScoreLocked(status) {
  return Number(status) !== consts.STATUS_NEW;
}

function isExamAnswerLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function isExamOptionStructureLocked(status) {
  return Number(status) === consts.STATUS_ONLINE || Number(status) === consts.STATUS_BANNED;
}

function createExamQuestionClientId() {
  return 'examq' + Math.random().toString(16).slice(2) + Date.now();
}

function createExamQuestion() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var questionType = Number(type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    client_id: createExamQuestionClientId(),
    source_question_id: null,
    target_usertype: null,
    customerid: null,
    training_knowledge_id: null,
    question_type: questionType,
    title: '',
    sample_files: [],
    options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType) ? Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])() : [],
    standard_answer: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: '',
    analysis_files: []
  }, overrides);
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

// 格式化每个题目，扁平化，原因是题目组件当时重新组装了form，这里复用组件也需要重新组装一下后端或者粘贴的题目结构
function normalizeExamQuestionFromRow(row) {
  var questionJson = row.question_json || {};
  var analysis = questionJson.question_analysis || {};
  var questionType = Number(row.question_type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
  var standardAnswer = hasValue(questionJson.standard_answer) ? questionJson.standard_answer : row.standard_answer;

  return createExamQuestion(questionType, {
    title: row.title || questionJson.title || '',
    source_question_id: row.id || null,
    target_usertype: hasValue(row.target_usertype) ? row.target_usertype : null,
    customerid: hasValue(row.customerid) ? row.customerid : null,
    training_knowledge_id: hasValue(row.training_knowledge_id) ? row.training_knowledge_id : null,
    sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
    options: Array.isArray(questionJson.options) ? questionJson.options : [],
    standard_answer: hasValue(standardAnswer) ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
    analysis_text: analysis.analysis_text || '',
    analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : []
  });
}

// 格式化每道题目
function getExamQuestionSubmitPayload(question) {
  var questionType = Number(question.question_type);
  var questionJson = {
    title: question.title || '',
    sample_files: question.sample_files || [],
    question_analysis: {
      analysis_text: question.analysis_text || '',
      analysis_files: question.analysis_files || []
    },
    standard_answer: question.standard_answer
  };

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(questionType)) {
    questionJson.options = question.options || [];
  }

  return {
    id: question.source_question_id || question.id || null,
    question_type: questionType,
    question_json: questionJson
  };
}

function getExamSubmitPayload(form) {
  return {
    title: form.title,
    target_usertype: String(form.target_usertype),
    is_common: Number(form.is_common),
    customerid: Number(form.customerid) || 0,
    training_knowledge_id: Number(form.training_knowledge_id),
    open_book_exam: Number(form.open_book_exam),
    question_score: Number(form.question_score),
    passing_score: Number(form.passing_score),
    exam_duration: Number(form.exam_duration),
    question_sort_type: Number(form.question_sort_type),
    question_options_sort_type: Number(form.question_options_sort_type),
    question_list: (form.question_list || []).map(function (question) {
      return getExamQuestionSubmitPayload(question);
    })
  };
}

var TRAINING_EXAM_COPY_TYPE = 'training-exam-intern';

// 复制
function buildTrainingExamCopyData(form) {
  var data = getExamSubmitPayload(form);
  return {
    version: 1,
    date: new Date().toISOString(),
    type: TRAINING_EXAM_COPY_TYPE,
    title: data.title,
    data: data
  };
}

// 粘贴
function normalizeTrainingExamCopyData(copyData) {
  if (!copyData || copyData.type !== TRAINING_EXAM_COPY_TYPE || !copyData.data) {
    return null;
  }

  var data = copyData.data;
  return {
    title: data.title || '',
    target_usertype: Number(data.target_usertype) || consts.TARGETUSER_TYPE_USER,
    is_common: Number(data.is_common || consts.IS_COMMON_DEDICATED),
    customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
    training_knowledge_id: data.training_knowledge_id || null,
    open_book_exam: Number(data.open_book_exam) || consts.OPEN_BOOK_EXAM_CLOSED,
    question_score: Number(data.question_score) || 10,
    passing_score: Number(data.passing_score) || 60,
    exam_duration: Number(data.exam_duration) || 60,
    question_sort_type: Number(data.question_sort_type) || consts.SORT_TYPE_FIXED,
    question_options_sort_type: Number(data.question_options_sort_type) || consts.SORT_TYPE_FIXED,
    question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
      return normalizeExamQuestionFromRow(item);
    }) : []
  };
}

// 不做前端验证，代码先保留 重复项检查比对的是选项显示的内容，而不是内部的选项 UUID
function getChoiceAnswerIndex(answer, options) {
  return options.findIndex(function (option) {
    return option.uuid === answer;
  });
}

function getChoiceDuplicateAnswer(questionType, questionJson, options) {
  if (Number(questionType) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI) {
    return (Array.isArray(questionJson.standard_answer) ? questionJson.standard_answer : []).map(function (answer) {
      return getChoiceAnswerIndex(answer, options);
    }).sort(function (prev, next) {
      return prev - next;
    });
  }
  return getChoiceAnswerIndex(questionJson.standard_answer, options);
}

function getExamQuestionDuplicateKey(question) {
  var payload = getExamQuestionSubmitPayload(question);
  var questionJson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.question_json);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(payload.question_type)) {
    var options = Array.isArray(questionJson.options) ? questionJson.options : [];
    // 取标题检测
    questionJson.options = options.map(function (option) {
      return {
        title: option.title || ''
      };
    });
    questionJson.standard_answer = getChoiceDuplicateAnswer(payload.question_type, questionJson, options);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    question_type: payload.question_type,
    question_json: questionJson
  });
}

/***/ }),

/***/ 2099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingFileUpload_vue__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_components_training_upload__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__ = __webpack_require__(1526);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuestionForm',
  components: {
    TrainingFileUpload: __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingFileUpload_vue__["a" /* default */]
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    questionType: {
      type: [Number, String],
      required: true
    },
    // 查看模式
    isViewMode: {
      type: Boolean,
      default: true
    },
    // 答案选择是否禁用
    isAnswerLocked: {
      type: Boolean,
      default: false
    },

    // 选项新增删除修改是否禁用
    isOptionStructureLocked: {
      type: Boolean,
      default: false
    },
    propPrefix: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */],
      TRAINING_UPLOAD_TYPES: __WEBPACK_IMPORTED_MODULE_1__views_training_components_training_upload__["a" /* TRAINING_UPLOAD_TYPES */]
    };
  },

  computed: {
    normalizedQuestionType: function normalizedQuestionType() {
      return Number(this.questionType);
    },
    isChoiceQuestion: function isChoiceQuestion() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["k" /* isChoiceQuestion */])(this.normalizedQuestionType);
    },
    isSingleQuestion: function isSingleQuestion() {
      return this.normalizedQuestionType === __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
    },
    isMultiQuestion: function isMultiQuestion() {
      return this.normalizedQuestionType === __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI;
    },
    readonly: function readonly() {
      return this.isViewMode;
    },
    answerLocked: function answerLocked() {
      return this.readonly || this.isAnswerLocked;
    },
    optionStructureLocked: function optionStructureLocked() {
      return this.readonly || this.isOptionStructureLocked;
    },
    multiAnswerValue: function multiAnswerValue() {
      return Array.isArray(this.form.standard_answer) ? this.form.standard_answer : [];
    },

    blankAnswerValue: {
      get: function get() {
        return Array.isArray(this.form.standard_answer) ? '' : this.form.standard_answer;
      },
      set: function set(value) {
        this.form.standard_answer = value;
      }
    }
  },
  methods: {
    getOptionLetter: __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["e" /* getOptionLetter */],
    addOption: function addOption() {
      if (this.optionStructureLocked) {
        return;
      }
      this.form.options.push({
        uuid: Object(__WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["d" /* createOptionUuid */])(),
        title: '\u9009\u9879' + this.getOptionLetter(this.form.options.length)
      });
    },
    onMultiAnswerChanged: function onMultiAnswerChanged(uuid, checked) {
      if (this.answerLocked || !this.isMultiQuestion) {
        return;
      }
      var answer = this.multiAnswerValue.slice();
      if (checked && !answer.includes(uuid)) {
        answer.push(uuid);
      }
      if (!checked) {
        this.form.standard_answer = answer.filter(function (item) {
          return item !== uuid;
        });
      } else {
        this.form.standard_answer = answer;
      }
      // this.validateField('standard_answer')
    },
    removeOption: function removeOption(index) {
      if (this.optionStructureLocked) {
        return;
      }
      var option = this.form.options[index];
      this.form.options.splice(index, 1);
      if (this.isSingleQuestion && this.form.standard_answer === option.uuid) {
        this.form.standard_answer = '';
      }
      if (this.isMultiQuestion) {
        this.form.standard_answer = this.multiAnswerValue.filter(function (uuid) {
          return uuid !== option.uuid;
        });
      }
      // this.validateField('standard_answer')
    },
    validateField: function validateField(field) {
      this.$emit('validate-field', this.fieldProp(field));
    },
    fieldProp: function fieldProp(field) {
      return this.propPrefix ? this.propPrefix + '.' + field : field;
    }
  }
});

/***/ }),

/***/ 2100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__training_upload__ = __webpack_require__(2101);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingFileUpload',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 默认多图片上传
    // 文件类型
    acceptTypes: {
      type: Array,
      default: function _default() {
        return [__WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].IMAGE];
      }
    },
    // 多文件上传
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否支持拖拽 button不支持，drag支持
    variant: {
      type: String,
      default: 'button'
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: '上传文件'
    },
    // 类型
    buttonType: {
      type: String,
      default: 'default'
    },
    // 大小
    buttonSize: {
      type: String,
      default: 'mini'
    },
    // 图标
    buttonIcon: {
      type: String,
      default: 'el-icon-upload'
    },
    signedUrlApiName: {
      type: String,
      default: 'getTrainingSignedOssUrl'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uploading: false,
      uploadTypes: __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    uploadConfig: function uploadConfig() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["d" /* getTrainingUploadConfig */])(this.acceptTypes, this.multiple);
    },

    // 上传格式限制
    acceptText: function acceptText() {
      return this.uploadConfig.accept.concat(this.uploadConfig.extensions.map(function (ext) {
        return '.' + ext;
      })).join(',');
    },

    // 上传文件提示
    uploadTip: function uploadTip() {
      return this.uploadConfig.tip;
    },
    imagePreviewList: function imagePreviewList() {
      return this.value.filter(function (file) {
        return file.type === __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].IMAGE;
      }).map(function (file) {
        return file.url;
      });
    }
  }),
  methods: {
    clearFiles: function clearFiles() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    onFileChange: function onFileChange(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var raw, validation, uploadedFile, nextValue;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                raw = file.raw;

                if (raw) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                validation = Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["e" /* validateTrainingUploadFile */])(raw, _this.value, _this.acceptTypes, _this.multiple);

                if (validation.valid) {
                  _context.next = 8;
                  break;
                }

                _this.$message.error(validation.message);
                _this.clearFiles();
                return _context.abrupt('return');

              case 8:

                _this.uploading = true;
                _this.$emit('uploading-change', true);
                _context.prev = 10;
                _context.next = 13;
                return _this.uploadFile(raw);

              case 13:
                uploadedFile = _context.sent;
                nextValue = validation.replaceAll ? [uploadedFile] : _this.value.concat(uploadedFile);

                _this.$emit('input', nextValue);
                _this.$emit('change', nextValue);
                _this.$message.success(validation.replaceAll ? '文件已替换' : '上传成功');
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](10);

                _this.$message.error(_context.t0.message || '上传失败');

              case 23:
                _context.prev = 23;

                _this.uploading = false;
                _this.$emit('uploading-change', false);
                _this.clearFiles();
                return _context.finish(23);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[10, 20, 23, 28]]);
      }))();
    },
    uploadFile: function uploadFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data, uploadRes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request.common(_this2.signedUrlApiName, {
                  file_name: file.name,
                  ext: Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["c" /* getFileExtension */])(file.name),
                  content_type: file.type || 'application/octet-stream'
                });

              case 2:
                _ref = _context2.sent;
                data = _ref.data;
                _context2.next = 6;
                return fetch(data.signedUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': data.content_type }),
                  body: file
                });

              case 6:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 9;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status);

              case 9:
                return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["b" /* formatTrainingUploadFile */])(file, data.url, _this2.loginUser));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeFile: function removeFile(index) {
      var nextValue = this.value.slice();
      nextValue.splice(index, 1);
      this.$emit('input', nextValue);
      this.$emit('change', nextValue);
    },
    openFile: function openFile(file) {
      if (file && file.url) {
        window.open(file.url, '_blank');
      }
    },

    // 以后可以往里面加
    getFileIcon: function getFileIcon(file) {
      if (file.type === __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].VIDEO) {
        return 'el-icon-video-camera';
      }
      return 'el-icon-document';
    }
  }
});

/***/ }),

/***/ 2101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_UPLOAD_TYPES; });
/* unused harmony export trainingUploadTypeOptions */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTrainingUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFileExtension;
/* unused harmony export getTrainingUploadFileType */
/* harmony export (immutable) */ __webpack_exports__["e"] = validateTrainingUploadFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatTrainingUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var _trainingUploadTypeOp;



// 暂时支持这三种
var TRAINING_UPLOAD_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf'

  // 这是每种上传类型支持的各种参数
};var trainingUploadTypeOptions = (_trainingUploadTypeOp = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.IMAGE, {
  label: '图片',
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxSizeMB: 20
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.VIDEO, {
  label: '视频',
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxSizeMB: 1024
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.PDF, {
  label: 'PDF',
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxSizeMB: 100
}), _trainingUploadTypeOp);

// acceptTypes 组件外部传进的支持类型，可多种类型
function getTrainingUploadConfig() {
  var acceptTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var types = acceptTypes.length ? acceptTypes : [TRAINING_UPLOAD_TYPES.IMAGE];

  // 获取每种类型的参数
  var options = types.map(function (type) {
    return trainingUploadTypeOptions[type];
  }).filter(Boolean);

  // 合并accept，方便upload组件使用
  var accept = options.reduce(function (result, item) {
    return result.concat(item.accept);
  }, []);

  // 合并支持的后缀
  var extensions = options.reduce(function (result, item) {
    return result.concat(item.extensions);
  }, []);

  // 多种文件取最大的上传大小
  var maxSizeMB = Math.max.apply(null, options.map(function (item) {
    return item.maxSizeMB;
  }));
  var maxSizeLabel = maxSizeMB >= 1024 ? (maxSizeMB / 1024).toFixed(maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : maxSizeMB + 'MB';

  var labels = options.map(function (item) {
    return item.label;
  }).join('、');

  return {
    accept: accept,
    extensions: extensions,
    maxFiles: multiple ? 0 : 1,
    maxSizeMB: maxSizeMB,
    tip: '' + (multiple ? '支持上传多个' : '只能上传一个') + labels + '\u6587\u4EF6\uFF0C\u6700\u5927 ' + maxSizeLabel
  };
}

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getTrainingUploadFileType(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || ['jpg', 'jpeg', 'png'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0 || ['mp4', 'avi', 'mov'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.VIDEO;
  }
  if (type === 'application/pdf' || ext === 'pdf') {
    return TRAINING_UPLOAD_TYPES.PDF;
  }
  return '';
}

// 检测选择文件是否合法
function validateTrainingUploadFile(file, currentFiles, acceptTypes, multiple) {
  // 获取配置
  var config = getTrainingUploadConfig(acceptTypes, multiple);

  // 后缀
  var ext = getFileExtension(file && file.name);

  var typeMatched = file && (config.accept.includes(file.type) || config.extensions.includes(ext));

  if (!typeMatched || Number(file.size) > config.maxSizeMB * 1024 * 1024) {
    return { valid: false, message: config.tip, replaceAll: false };
  }

  // replaceAll参数代表单文件就替换，多文件就push
  return {
    valid: true,
    message: '',
    replaceAll: !multiple && Array.isArray(currentFiles) && currentFiles.length > 0
  };
}

// 统一使用这组字段作为传入后端的参数
function formatTrainingUploadFile(file, url, loginUser) {
  return {
    name: file.name,
    url: url,
    uid: file.uid,
    size: file.size,
    type: getTrainingUploadFileType(file),
    submit_admin_id: loginUser.id,
    submit_admin_name: loginUser.name,
    submit_at: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD HH:mm:ss')
  };
}

/***/ }),

/***/ 2109:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 2120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionForm_vue__ = __webpack_require__(2099);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b116df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionForm_vue__ = __webpack_require__(2503);
function injectStyle (ssrContext) {
  __webpack_require__(2497)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49b116df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b116df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0e9ae86e", content, true, {});

/***/ }),

/***/ 2492:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-exam-record__card[data-v-707a9ef7]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.training-instruction-exam-record__card+.training-instruction-exam-record__card[data-v-707a9ef7]{margin-top:16px}.training-instruction-exam-record__card-header[data-v-707a9ef7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.training-instruction-exam-record__card-header i[data-v-707a9ef7]{color:#909399}.training-instruction-exam-record__card-header-actions[data-v-707a9ef7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.training-instruction-exam-record__card-header-actions ::v-deep .training-instruction-exam-record__header-action.el-button[data-v-707a9ef7]{min-width:24px;padding:0;margin:0}.training-instruction-exam-record__header-action[data-v-707a9ef7]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.training-instruction-exam-record__header-action i[data-v-707a9ef7]{font-size:14px}.training-instruction-exam-record__search-form[data-v-707a9ef7]{padding:16px 24px 20px}.training-instruction-exam-record__search-grid[data-v-707a9ef7]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.training-instruction-exam-record__search-actions[data-v-707a9ef7]{margin-top:4px;padding-top:4px}.training-instruction-exam-record__list-body[data-v-707a9ef7]{padding:0 16px 16px}.training-instruction-exam-record__table-wrap[data-v-707a9ef7]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden}.training-instruction-exam-record__table ::v-deep th[data-v-707a9ef7]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.training-instruction-exam-record__table ::v-deep td[data-v-707a9ef7]{font-size:14px;color:#303133}.training-instruction-exam-record__table ::v-deep .el-table__row:hover>td[data-v-707a9ef7]{background:#fafafa}.training-instruction-exam-record__table[data-v-707a9ef7] ::v-deep:before{display:none}.training-instruction-exam-record__tag[data-v-707a9ef7]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap}.training-instruction-exam-record__tag.is-pass[data-v-707a9ef7]{background:#dcfce7;color:#15803d}.training-instruction-exam-record__tag.is-fail[data-v-707a9ef7]{background:#fee2e2;color:#dc2626}.training-instruction-exam-record__tag.is-pending[data-v-707a9ef7]{background:#fef9c3;color:#a16207}.training-instruction-exam-record__tag.is-submitted[data-v-707a9ef7]{background:#e0f2fe;color:#0369a1}.training-instruction-exam-record__tag.is-default[data-v-707a9ef7]{background:#f3f4f6;color:#6b7280}.training-instruction-exam-record__sub-id[data-v-707a9ef7]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo,Monaco,Consolas,monospace}.training-instruction-exam-record__empty[data-v-707a9ef7]{color:#c0c4cc}.training-instruction-exam-record__action-link[data-v-707a9ef7]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;cursor:pointer}.training-instruction-exam-record__action-link[data-v-707a9ef7]:hover{background:#ecf5ff}.training-instruction-exam-record .pagination[data-v-707a9ef7]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.training-instruction-exam-record__search-grid[data-v-707a9ef7]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.training-instruction-exam-record__search-grid[data-v-707a9ef7]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionExamRecordTable.vue"],"names":[],"mappings":"AACA,yDAAyD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAC7L,AACD,iGAAiG,eAAe,CAC/G,AACD,gEAAgE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CACrc,AACD,kEAAkE,aAAa,CAC9E,AACD,wEAAwE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CACrM,AACD,4IAA4I,eAAe,UAAU,QAAQ,CAC5K,AACD,kEAAkE,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CACxX,AACD,oEAAoE,cAAc,CACjF,AACD,gEAAgE,sBAAsB,CACrF,AACD,gEAAgE,aAAa,8CAAgD,aAAa,CACzI,AACD,mEAAmE,eAAe,eAAe,CAChG,AACD,8DAA8D,mBAAmB,CAChF,AACD,+DAA+D,yBAAyB,kBAAkB,eAAe,CACxH,AACD,sEAAsE,mBAAmB,cAAc,eAAe,eAAe,CACpI,AACD,sEAAsE,eAAe,aAAa,CACjG,AACD,2FAA2F,kBAAkB,CAC5G,AACD,0EAA2E,YAAY,CACtF,AACD,wDAAwD,qBAAqB,iBAAiB,oBAAoB,eAAe,iBAAiB,gBAAgB,kBAAkB,CACnL,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,mEAAmE,mBAAmB,aAAa,CAClG,AACD,qEAAqE,mBAAmB,aAAa,CACpG,AACD,mEAAmE,mBAAmB,aAAa,CAClG,AACD,2DAA2D,gBAAgB,cAAc,eAAe,2CAA8C,CACrJ,AACD,0DAA0D,aAAa,CACtE,AACD,gEAAgE,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,cAAc,cAAc,CACnM,AACD,sEAAsE,kBAAkB,CACvF,AACD,+DAA+D,mBAAmB,iBAAiB,CAClG,AACD,0BACA,gEAAgE,6CAA+C,CAC9G,CACA,AACD,yBACA,gEAAgE,yBAAyB,CACxF,CACA","file":"TrainingInstructionExamRecordTable.vue","sourcesContent":["\n.training-instruction-exam-record__card[data-v-707a9ef7]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.training-instruction-exam-record__card+.training-instruction-exam-record__card[data-v-707a9ef7]{margin-top:16px\n}\n.training-instruction-exam-record__card-header[data-v-707a9ef7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.training-instruction-exam-record__card-header i[data-v-707a9ef7]{color:#909399\n}\n.training-instruction-exam-record__card-header-actions[data-v-707a9ef7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.training-instruction-exam-record__card-header-actions ::v-deep .training-instruction-exam-record__header-action.el-button[data-v-707a9ef7]{min-width:24px;padding:0;margin:0\n}\n.training-instruction-exam-record__header-action[data-v-707a9ef7]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.training-instruction-exam-record__header-action i[data-v-707a9ef7]{font-size:14px\n}\n.training-instruction-exam-record__search-form[data-v-707a9ef7]{padding:16px 24px 20px\n}\n.training-instruction-exam-record__search-grid[data-v-707a9ef7]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.training-instruction-exam-record__search-actions[data-v-707a9ef7]{margin-top:4px;padding-top:4px\n}\n.training-instruction-exam-record__list-body[data-v-707a9ef7]{padding:0 16px 16px\n}\n.training-instruction-exam-record__table-wrap[data-v-707a9ef7]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden\n}\n.training-instruction-exam-record__table ::v-deep th[data-v-707a9ef7]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.training-instruction-exam-record__table ::v-deep td[data-v-707a9ef7]{font-size:14px;color:#303133\n}\n.training-instruction-exam-record__table ::v-deep .el-table__row:hover>td[data-v-707a9ef7]{background:#fafafa\n}\n.training-instruction-exam-record__table[data-v-707a9ef7] ::v-deep::before{display:none\n}\n.training-instruction-exam-record__tag[data-v-707a9ef7]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap\n}\n.training-instruction-exam-record__tag.is-pass[data-v-707a9ef7]{background:#dcfce7;color:#15803d\n}\n.training-instruction-exam-record__tag.is-fail[data-v-707a9ef7]{background:#fee2e2;color:#dc2626\n}\n.training-instruction-exam-record__tag.is-pending[data-v-707a9ef7]{background:#fef9c3;color:#a16207\n}\n.training-instruction-exam-record__tag.is-submitted[data-v-707a9ef7]{background:#e0f2fe;color:#0369a1\n}\n.training-instruction-exam-record__tag.is-default[data-v-707a9ef7]{background:#f3f4f6;color:#6b7280\n}\n.training-instruction-exam-record__sub-id[data-v-707a9ef7]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo, Monaco, Consolas, monospace\n}\n.training-instruction-exam-record__empty[data-v-707a9ef7]{color:#c0c4cc\n}\n.training-instruction-exam-record__action-link[data-v-707a9ef7]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;cursor:pointer\n}\n.training-instruction-exam-record__action-link[data-v-707a9ef7]:hover{background:#ecf5ff\n}\n.training-instruction-exam-record .pagination[data-v-707a9ef7]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.training-instruction-exam-record__search-grid[data-v-707a9ef7]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.training-instruction-exam-record__search-grid[data-v-707a9ef7]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2493:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2494);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("88fac530", content, true, {});

/***/ }),

/***/ 2494:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-exam-record__search-form .el-form-item{margin-bottom:0}.training-instruction-exam-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionExamRecordTable.vue"],"names":[],"mappings":"AACA,6DAA6D,eAAe,CAC3E,AACD,oEAAoE,cAAc,eAAe,gBAAgB,CAChH","file":"TrainingInstructionExamRecordTable.vue","sourcesContent":["\n.training-instruction-exam-record__search-form .el-form-item{margin-bottom:0\n}\n.training-instruction-exam-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTrainingInstructionExamRecordTableFields;
function createTrainingInstructionExamRecordTableFields(vm) {
  return [{ key: 'id', prop: 'id', label: '答卷ID', width: 90 }, { key: 'training_instruction_id', prop: 'training_instruction_id', label: '培训ID', width: 90 }, { key: 'training_examination_id', prop: 'training_examination_id', label: '考试ID', width: 90 }, {
    key: 'training_instruction_title',
    prop: 'training_instruction_title',
    label: '培训标题',
    minWidth: 160,
    showOverflowTooltip: true
  }, { key: 'userid', label: '用户ID', width: 90, formatter: function formatter(row) {
      return row.userid;
    } }, { key: 'realname', prop: 'realname', label: '真实姓名', minWidth: 100, showOverflowTooltip: true }, { key: 'region_name', prop: 'region_name', label: '省市区', minWidth: 160, showOverflowTooltip: true }, {
    key: 'target_usertype',
    label: '用户类型',
    width: 110,
    slot: 'emptyText',
    textKey: 'target_usertype_name'
  }, {
    key: 'source_type',
    label: '来源',
    width: 110,
    slot: 'emptyText',
    textKey: 'source_type_name'
  }, { key: 'project', label: '项目', minWidth: 160, slot: 'subId', nameKey: 'project_name', idKey: 'projectid' }, { key: 'batch', label: '批次', minWidth: 160, slot: 'subId', nameKey: 'batch_name', idKey: 'batchid' }, { key: 'task', label: '任务', minWidth: 160, slot: 'subId', nameKey: 'task_title', idKey: 'taskid' }, { key: 'examination_submitted_at', prop: 'examination_submitted_at', label: '提交时间', width: 170 }, { key: 'examination_duration_text', prop: 'examination_duration_text', label: '用时', width: 90 }, { key: 'open_book_exam_text', prop: 'open_book_exam_text', label: '是否开卷', width: 90 }, {
    key: 'examination_score',
    label: '得分',
    width: 100,
    formatter: function formatter(row) {
      return row.examination_score_text || '-';
    }
  }, {
    key: 'examination_status',
    label: '状态',
    width: 100,
    slot: 'tag',
    formatter: function formatter(row) {
      return row.examination_status_name;
    },
    tagClass: function tagClass(row) {
      return vm.getExamStatusTagClass(row.examination_status);
    }
  }];
}

/***/ }),

/***/ 2496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"training-instruction-exam-record"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/instruction' }}},[_vm._v("培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("答卷列表")])],1)],1),_vm._v(" "),_c('training-instruction-sub-heading',{attrs:{"title":_vm.pageHeadingTitle,"entity-id":_vm.pageEntityId}}),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card training-instruction-exam-record__card--search"},[_c('div',{staticClass:"training-instruction-exam-record__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"training-instruction-exam-record__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"training-instruction-exam-record__search-grid"},[_c('el-form-item',{attrs:{"label":"关键字","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入真实姓名或ID","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"答卷状态","prop":"examination_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.examination_status),callback:function ($$v) {_vm.$set(_vm.search, "examination_status", $$v)},expression:"search.examination_status"}},_vm._l((_vm.examStatusOptions),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.target_usertype),callback:function ($$v) {_vm.$set(_vm.search, "target_usertype", $$v)},expression:"search.target_usertype"}},_vm._l((_vm.targetUserMaps),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"来源","prop":"source_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.source_type),callback:function ($$v) {_vm.$set(_vm.search, "source_type", $$v)},expression:"search.source_type"}},_vm._l((_vm.opts.sourceTypeMaps),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},on:{"change":function($event){_vm.search.batchid = null}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","disabled":!_vm.search.projectid,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称/编号 进行搜索","query-request":function (_) { return _vm.getBatchTable(Object.assign({ projectid: _vm.search.projectid }, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"regionids"}},[_c('el-cascader',{staticClass:"width-max",attrs:{"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":"","placeholder":"请选择省市区"},model:{value:(_vm.search.regionids),callback:function ($$v) {_vm.$set(_vm.search, "regionids", $$v)},expression:"search.regionids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提交时间","prop":"examination_submitted_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.examination_submitted_at),callback:function ($$v) {_vm.$set(_vm.search, "examination_submitted_at", $$v)},expression:"search.examination_submitted_at"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card"},[_c('div',{staticClass:"training-instruction-exam-record__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("答卷列表")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card-header-actions"},[_c('el-button',{staticClass:"training-instruction-exam-record__header-action",attrs:{"type":"text","icon":"el-icon-setting","title":"列配置"},on:{"click":function($event){$event.stopPropagation();return _vm.openTableColumnConfigDialog($event)}}}),_vm._v(" "),_c('el-button',{staticClass:"training-instruction-exam-record__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"training-instruction-exam-record__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"training-instruction-exam-record__list-body"},[_c('div',{staticClass:"training-instruction-exam-record__table-wrap"},[_c('el-table',{key:_vm.tableColumnRenderKey,staticClass:"training-instruction-exam-record__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_vm._l((_vm.activeTableFields),function(field){return _c('el-table-column',_vm._b({key:field.key,scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(field.slot === 'tag')?_c('span',[(field.formatter(scope.row))?_c('span',{class:['training-instruction-exam-record__tag', field.tagClass(scope.row)]},[_vm._v("\n                  "+_vm._s(field.formatter(scope.row))+"\n                ")]):_c('span',{staticClass:"training-instruction-exam-record__empty"},[_vm._v("-")])]):(field.slot === 'emptyText')?_c('span',[(scope.row[field.textKey])?_c('span',[_vm._v(_vm._s(scope.row[field.textKey]))]):_c('span',{staticClass:"training-instruction-exam-record__empty"},[_vm._v("-")])]):(field.slot === 'subId')?[(scope.row[field.idKey])?[_c('span',[_vm._v(_vm._s(scope.row[field.nameKey]))]),_vm._v(" "),_c('span',{staticClass:"training-instruction-exam-record__sub-id"},[_vm._v("/ "+_vm._s(scope.row[field.idKey]))])]:_c('span',{staticClass:"training-instruction-exam-record__empty"},[_vm._v("-")])]:[_vm._v("\n                "+_vm._s(field.formatter ? field.formatter(scope.row) : scope.row[field.prop])+"\n              ")]]}}],null,true)},'el-table-column',_vm.getFieldColumnBind(field),false))}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"training-instruction-exam-record__action-link",on:{"click":function($event){_vm.$router.push(_vm.getDetailLink(scope.row))}}},[_vm._v("查看详情")])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])]),_vm._v(" "),_c('table-column-config-dialog',{attrs:{"visible":_vm.tableColumnConfigDialogVisible,"applied-columns":_vm.tableColumnAppliedConfig,"definitions":_vm.fields},on:{"update:visible":function($event){_vm.tableColumnConfigDialogVisible=$event},"save":_vm.onTableColumnConfigSave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2497:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("47e2c4e0", content, true, {});

/***/ }),

/***/ 2498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".answer-tip[data-v-49b116df]{margin-bottom:8px;color:#8492a6;font-size:12px}.option-row[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px}.option-row__letter[data-v-49b116df]{width:22px;color:#1f2d3d}.option-row__input[data-v-49b116df]{-webkit-box-flex:1;-ms-flex:1;flex:1}.sample-upload-group[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px}", "", {"version":3,"sources":["/workspace/src/views/training/components/QuestionForm.vue"],"names":[],"mappings":"AACA,6BAA6B,kBAAkB,cAAc,cAAc,CAC1E,AACD,6BAA6B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,iBAAiB,CAC5K,AACD,qCAAqC,WAAW,aAAa,CAC5D,AACD,oCAAoC,mBAAmB,WAAW,MAAM,CACvE,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,CAC3M","file":"QuestionForm.vue","sourcesContent":["\n.answer-tip[data-v-49b116df]{margin-bottom:8px;color:#8492a6;font-size:12px\n}\n.option-row[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px\n}\n.option-row__letter[data-v-49b116df]{width:22px;color:#1f2d3d\n}\n.option-row__input[data-v-49b116df]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.sample-upload-group[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingFileUpload_vue__ = __webpack_require__(2100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476f346e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingFileUpload_vue__ = __webpack_require__(2502);
function injectStyle (ssrContext) {
  __webpack_require__(2500)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-476f346e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingFileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476f346e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingFileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2500:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d3aff38", content, true, {});

/***/ }),

/***/ 2501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-file-upload--drag[data-v-476f346e]{max-width:760px}.training-file-upload--drag[data-v-476f346e] .el-upload,.training-file-upload--drag[data-v-476f346e] .el-upload-dragger{width:100%}.training-file-upload__icon[data-v-476f346e]{font-size:40px;color:#409eff}.training-file-upload__list[data-v-476f346e]{margin-top:8px}.training-file-upload__item[data-v-476f346e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;min-height:32px}.training-file-upload__thumb[data-v-476f346e]{width:54px;height:36px;border-radius:4px;background:#f5f7fa}.training-file-upload__file-icon[data-v-476f346e]{font-size:20px;color:#409eff}.training-file-upload__name[data-v-476f346e]{max-width:360px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingFileUpload.vue"],"names":[],"mappings":"AACA,6CAA6C,eAAe,CAC3D,AACD,wHAAwH,UAAU,CACjI,AACD,6CAA6C,eAAe,aAAa,CACxE,AACD,6CAA6C,cAAc,CAC1D,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,eAAe,CAC1L,AACD,8CAA8C,WAAW,YAAY,kBAAkB,kBAAkB,CACxG,AACD,kDAAkD,eAAe,aAAa,CAC7E,AACD,6CAA6C,gBAAgB,gBAAgB,uBAAuB,kBAAkB,CACrH","file":"TrainingFileUpload.vue","sourcesContent":["\n.training-file-upload--drag[data-v-476f346e]{max-width:760px\n}\n.training-file-upload--drag[data-v-476f346e] .el-upload,.training-file-upload--drag[data-v-476f346e] .el-upload-dragger{width:100%\n}\n.training-file-upload__icon[data-v-476f346e]{font-size:40px;color:#409EFF\n}\n.training-file-upload__list[data-v-476f346e]{margin-top:8px\n}\n.training-file-upload__item[data-v-476f346e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;min-height:32px\n}\n.training-file-upload__thumb[data-v-476f346e]{width:54px;height:36px;border-radius:4px;background:#f5f7fa\n}\n.training-file-upload__file-icon[data-v-476f346e]{font-size:20px;color:#409EFF\n}\n.training-file-upload__name[data-v-476f346e]{max-width:360px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-file-upload",class:("training-file-upload--" + _vm.variant)},[_c('el-upload',{ref:"upload",attrs:{"action":"","drag":_vm.variant === 'drag',"auto-upload":false,"show-file-list":false,"multiple":_vm.multiple,"accept":_vm.acceptText,"disabled":_vm.disabled || _vm.uploading,"on-change":_vm.onFileChange}},[(_vm.variant === 'drag')?[_c('i',{staticClass:"el-icon-upload training-file-upload__icon"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])]:_c('el-button',{attrs:{"size":_vm.buttonSize,"type":_vm.buttonType,"icon":_vm.buttonIcon}},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.uploadTip))])],2),_vm._v(" "),(_vm.value.length)?_c('div',{staticClass:"training-file-upload__list"},_vm._l((_vm.value),function(file,index){return _c('div',{key:file.uid || file.url || index,staticClass:"training-file-upload__item"},[(file.type === _vm.uploadTypes.IMAGE)?_c('el-image',{staticClass:"training-file-upload__thumb",attrs:{"src":file.url,"preview-src-list":_vm.imagePreviewList,"fit":"cover"}}):_c('i',{staticClass:"training-file-upload__file-icon",class:_vm.getFileIcon(file)}),_vm._v(" "),_c('span',{staticClass:"training-file-upload__name",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.openFile(file)}}},[_vm._v("查看")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","disabled":_vm.disabled},on:{"click":function($event){return _vm.removeFile(index)}}},[_vm._v("删除")])],1)}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-form"},[_c('el-form-item',{attrs:{"label":"题目标题","prop":_vm.fieldProp('title')}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.readonly,"maxlength":"200","placeholder":"请输入题目内容"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目示例","prop":_vm.fieldProp('sample_files')}},[_c('div',{staticClass:"sample-upload-group"},[_c('div',{staticClass:"sample-upload-block"},[_c('training-file-upload',{attrs:{"accept-types":[_vm.TRAINING_UPLOAD_TYPES.IMAGE,_vm.TRAINING_UPLOAD_TYPES.VIDEO],"multiple":true,"variant":"button","button-text":"添加题目示例","button-icon":"el-icon-picture-outline","disabled":_vm.readonly},on:{"change":function($event){return _vm.validateField('sample_files')},"uploading-change":function($event){return _vm.$emit('uploading-change', $event)}},model:{value:(_vm.form.sample_files),callback:function ($$v) {_vm.$set(_vm.form, "sample_files", $$v)},expression:"form.sample_files"}})],1)])]),_vm._v(" "),(_vm.isChoiceQuestion)?_c('el-form-item',{attrs:{"label":"答案选项","prop":_vm.fieldProp('standard_answer')}},[_c('div',{staticClass:"answer-tip"},[_vm._v("点击选中正确答案")]),_vm._v(" "),_vm._l((_vm.form.options),function(option,index){return _c('div',{key:option.uuid,staticClass:"option-row"},[_c('span',{staticClass:"option-row__letter"},[_vm._v(_vm._s(_vm.getOptionLetter(index))+".")]),_vm._v(" "),(_vm.isSingleQuestion)?_c('el-radio',{attrs:{"disabled":_vm.answerLocked,"label":option.uuid},model:{value:(_vm.form.standard_answer),callback:function ($$v) {_vm.$set(_vm.form, "standard_answer", $$v)},expression:"form.standard_answer"}},[_vm._v(" \n      ")]):_c('el-checkbox',{attrs:{"disabled":_vm.answerLocked,"value":_vm.multiAnswerValue.includes(option.uuid)},on:{"change":function (checked) { return _vm.onMultiAnswerChanged(option.uuid, checked); }}},[_vm._v(" \n      ")]),_vm._v(" "),_c('el-input',{staticClass:"option-row__input",attrs:{"disabled":_vm.readonly,"placeholder":"请输入选项内容"},model:{value:(option.title),callback:function ($$v) {_vm.$set(option, "title", $$v)},expression:"option.title"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-delete","disabled":_vm.optionStructureLocked || _vm.form.options.length <= 1},on:{"click":function($event){return _vm.removeOption(index)}}})],1)}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-plus","disabled":_vm.optionStructureLocked},on:{"click":_vm.addOption}},[_vm._v("添加选项\n    ")])],2):_c('el-form-item',{attrs:{"label":"标准答案","prop":_vm.fieldProp('standard_answer')}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.answerLocked,"placeholder":"请输入数字答案"},model:{value:(_vm.blankAnswerValue),callback:function ($$v) {_vm.blankAnswerValue=$$v},expression:"blankAnswerValue"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目解析"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"disabled":_vm.readonly,"maxlength":"1000","placeholder":"请输入题目解析说明"},model:{value:(_vm.form.analysis_text),callback:function ($$v) {_vm.$set(_vm.form, "analysis_text", $$v)},expression:"form.analysis_text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"解析附件","prop":_vm.fieldProp('analysis_files')}},[_c('training-file-upload',{attrs:{"accept-types":[_vm.TRAINING_UPLOAD_TYPES.IMAGE,_vm.TRAINING_UPLOAD_TYPES.VIDEO],"multiple":true,"variant":"button","button-text":"添加解析附件","button-icon":"el-icon-upload","disabled":_vm.readonly},on:{"change":function($event){return _vm.validateField('analysis_files')},"uploading-change":function($event){return _vm.$emit('uploading-change', $event)}},model:{value:(_vm.form.analysis_files),callback:function ($$v) {_vm.$set(_vm.form, "analysis_files", $$v)},expression:"form.analysis_files"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionExamRecordTable_vue__ = __webpack_require__(2097);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707a9ef7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionExamRecordTable_vue__ = __webpack_require__(2496);
function injectStyle (ssrContext) {
  __webpack_require__(2491)
  __webpack_require__(2493)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-707a9ef7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionExamRecordTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707a9ef7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionExamRecordTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_column_config__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_intern_constants__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_exam_intern_record_table_fields__ = __webpack_require__(5654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_components_TrainingInstructionSubHeading_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_components_RemoteSelect_vue__ = __webpack_require__(248);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RemoteSelect: __WEBPACK_IMPORTED_MODULE_7__core_components_RemoteSelect_vue__["a" /* default */],
    TrainingInstructionSubHeading: __WEBPACK_IMPORTED_MODULE_6__views_training_components_TrainingInstructionSubHeading_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_column_config__["a" /* default */]],
  data: function data() {
    return {
      searchExpanded: true,
      listExpanded: true,
      opts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_intern_constants__["r" /* opts */],
      examination: {
        id: 0,
        title: ''
      },
      search: {
        admin_id: null,
        status: null,
        submitted_at: []
      },
      searchFieldType: {
        status: Number,
        submitted_at: Array
      },
      examStatusOptions: __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_intern_constants__["r" /* opts */].recordStatusMaps.filter(function (it) {
        return it.value !== __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_intern_constants__["b" /* consts */].RECORD_STATUS_EXAMINING;
      }),
      fields: Object(__WEBPACK_IMPORTED_MODULE_5__views_training_training_exam_intern_record_table_fields__["a" /* createTrainingExaminationInternRecordTableFields */])(this)
    };
  },

  computed: {
    pageHeadingTitle: function pageHeadingTitle() {
      if (this.examination.id) {
        return this.$route.meta.title + ' \xB7 ' + this.examination.title;
      }
      return this.$route.meta.title || '';
    },
    pageEntityId: function pageEntityId() {
      if (this.examination.id) {
        return this.examination.id;
      }
      return null;
    },
    pageTitle: function pageTitle() {
      var entityId = this.pageEntityId;
      if (!entityId) {
        return this.pageHeadingTitle;
      }

      return this.pageHeadingTitle + ' ID\uFF1A' + entityId;
    },
    activeTableFields: function activeTableFields() {
      var fieldMap = _.keyBy(this.fields, 'key');
      return this.activeTableColumns.map(function (column) {
        return fieldMap[column.key];
      }).filter(Boolean);
    }
  },
  created: function created() {
    this.syncPageContext();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getFieldColumnBind: function getFieldColumnBind(field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS);
    },
    loadExamination: function loadExamination() {
      var _this = this;

      if (!this.examination.id) {
        return;
      }
      var examinationId = this.examination.id;
      request.common('getTrainingExaminationIntern', { id: examinationId }).then(function (_ref) {
        var data = _ref.data;

        if (Number(_this.examination.id) !== Number(examinationId)) {
          return;
        }
        _this.examination.title = data.title;
      }).catch(function () {});
    },
    syncPageContext: function syncPageContext() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route;

      var examinationId = route.params.examinationId ? Number(route.params.examinationId) : 0;
      var queryTitle = route.query.title || '';

      if (examinationId > 0) {
        this.examination.id = examinationId;
        if (queryTitle) {
          this.examination.title = queryTitle;
        }
        this.loadExamination();
      } else {
        this.examination.id = 0;
        this.examination.title = '';
      }
    },
    getTableData: function getTableData(params) {
      delete params.id;
      delete params.title;
      delete params.recordId;
      delete params.examinationId;

      if (this.examination.id) {
        params.training_exam_id = this.examination.id;
      }
      return request.page('queryTrainingExaminationInternRecord', params);
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.pageTitle, {
        fileHeader: this.activeTableFields.map(function (field) {
          return {
            key: field.prop,
            text: field.label
          };
        }),
        request: this.getTableData,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["b" /* removeEmptyParams */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _.cloneDeep(this.search), {
          training_exam_id: this.examination.id
        }))
      });
    },
    getDetailLink: function getDetailLink(row) {
      return {
        path: '/training/examination/' + row.training_exam_id + '/intern/records/' + row.id
      };
    },
    resetSearch: function resetSearch() {
      this.$refs.searchForm.resetFields();
      this.onSearch();
    }
  })
});

/***/ }),

/***/ 3058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_user__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_common__ = __webpack_require__(1515);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["b" /* consts */],
      examOptions: __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["r" /* opts */],
      search: {
        title: null,
        open_book_exam: null,
        target_usertype: null,
        status: [],
        is_common: null,
        training_knowledge_id: [],
        customerid: [],
        creator_id: [],
        created_at: []
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      searchFieldType: {
        open_book_exam: Number,
        target_usertype: Number,
        status: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        is_common: Number,
        training_knowledge_id: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        customerid: Array,
        creator_id: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        created_at: Array
      }
    };
  },

  computed: {
    isSuperAdmin: function isSuperAdmin() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__views_training_training_user__["a" /* isSuperAdminUser */])(this.loginUser);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['queryTrainingKnowledge', 'getTrainingKnowledge', 'getBasicCustomerTable', 'getCustomerDetail', 'getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.page('queryTrainingExamination', params);
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },
    getTargetUserLabel: function getTargetUserLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["i" /* getOptionLabel */])(this.examOptions.targetUserMaps, value) || '-';
    },
    getIsCommonLabel: function getIsCommonLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["i" /* getOptionLabel */])(this.examOptions.isCommonMaps, value) || '-';
    },

    getExamStatusLabel: __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["f" /* getExamStatusLabel */],
    getStatusTagClass: function getStatusTagClass(status) {
      return 'exam-tag--' + Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["g" /* getExamStatusType */])(status);
    },
    getTagClass: function getTagClass(type, value) {
      if (type === 'user') {
        return Number(value) === this.consts.TARGETUSER_TYPE_USER ? 'exam-tag--primary' : 'exam-tag--warning';
      }
      if (type === 'common') {
        return Number(value) === this.consts.IS_COMMON_SHARED ? 'exam-tag--success' : 'exam-tag--default';
      }
      return 'exam-tag--default';
    },
    getQuestionCount: function getQuestionCount(row) {
      return Array.isArray(row.question_list) ? row.question_list.length : 0;
    },
    formatPassingScore: function formatPassingScore(row) {
      if (row.open_book_exam === __WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        var passingScore = row.passing_score === undefined || row.passing_score === null ? '-' : row.passing_score;
        var totalScore = row.question_score * this.getQuestionCount(row);
        if (totalScore) {
          return totalScore ? passingScore + '/' + totalScore : passingScore;
        } else {
          return '-';
        }
      } else {
        var statusItem = (this.examOptions.openBookMaps || []).find(function (item) {
          return item.value === row.open_book_exam;
        });
        return statusItem ? statusItem.label : '';
      }
    },
    getActionConfig: function getActionConfig(name) {
      var actions = Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_NEW).concat(Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_ONLINE)).concat(Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_OFFLINE)).concat(Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_exam_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_BANNED));
      return actions.find(function (action) {
        return action.name === name;
      });
    },
    handleExamAction: function handleExamAction(row, name) {
      var _this = this;

      var action = this.getActionConfig(name);
      if (!action) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u8981' + action.label + '\u8003\u8BD5\u3010' + row.title + '\u3011\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        request.common(action.apiName, row.id).then(function () {
          _this.$message.success(action.successText);
          _this.onRefresh();
        });
      });
    },
    getExamRecordLink: function getExamRecordLink(row) {
      return {
        path: '/training/examination/exam-records/' + row.id,
        query: { title: row.title }
      };
    }
  })
});

/***/ }),

/***/ 3059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_components_QuestionForm_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__ = __webpack_require__(1526);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingExamForm',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    QuestionForm: __WEBPACK_IMPORTED_MODULE_5__views_training_components_QuestionForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      consts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["r" /* opts */],
      questionConsts: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */],
      questionOpts: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["o" /* opts */],
      submitting: false,
      uploading: false,
      copyExamClipboard: null,
      activeQuestionIndex: 0,
      questionDialogVisible: false,
      questionDialogLoading: false,
      questionBankList: [],
      selectedQuestionRows: [],
      questionPagination: {
        current_page: 1,
        per_page: 10,
        total: 0
      },
      questionSearch: {
        title: '',
        customerid: null,
        training_knowledge_id: null,
        question_type: null
      },
      form: {
        status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].STATUS_NEW,
        title: '',
        target_usertype: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].TARGETUSER_TYPE_USER,
        is_common: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].IS_COMMON_DEDICATED,
        customerid: null,
        training_knowledge_id: null,
        open_book_exam: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED,
        question_score: 10,
        passing_score: 60,
        exam_duration: 60,
        question_sort_type: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].SORT_TYPE_FIXED,
        question_options_sort_type: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].SORT_TYPE_FIXED,
        question_list: []
      }
    };
  },

  computed: {
    formRules: function formRules() {
      return {
        title: [{ required: true, message: '请输入考试标题', trigger: 'blur' }, { max: 100, message: '考试标题最多 100 个字符', trigger: 'blur' }],
        target_usertype: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{ validator: this.validateCustomer, trigger: 'change' }],
        training_knowledge_id: [{ required: true, message: '请选择所属知识库', trigger: 'change' }],
        open_book_exam: [{ required: true, message: '请选择是否开卷', trigger: 'change' }],
        question_score: [{ validator: this.validatePositiveNumber('请输入单题分值'), trigger: 'blur' }],
        passing_score: [{ validator: this.validatePassingScoreRule, trigger: 'blur' }],
        exam_duration: [{ validator: this.validatePositiveNumber('请输入考试时效'), trigger: 'blur' }],
        question_sort_type: [{ required: true, message: '请选择题目顺序', trigger: 'change' }],
        question_options_sort_type: [{ required: true, message: '请选择选项顺序', trigger: 'change' }]
      };
    },
    knowledgeQueryParams: function knowledgeQueryParams() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(this.form);
    },
    knowledgeDisabled: function knowledgeDisabled() {
      return this.isScopeLocked || Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].IS_COMMON_DEDICATED && !this.form.customerid;
    },
    isReadonly: function isReadonly() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["l" /* isExamReadonly */])(this.form.status);
    },
    isScopeLocked: function isScopeLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["m" /* isExamScopeLocked */])(this.form.status);
    },
    isStructureLocked: function isStructureLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["o" /* isExamStructureLocked */])(this.form.status);
    },
    isQuestionScoreLocked: function isQuestionScoreLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["n" /* isExamScoreLocked */])(this.form.status);
    },
    isAnswerLocked: function isAnswerLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["j" /* isExamAnswerLocked */])(this.form.status);
    },
    isOptionStructureLocked: function isOptionStructureLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["k" /* isExamOptionStructureLocked */])(this.form.status);
    },
    allowCopyExam: function allowCopyExam() {
      return !!this.id;
    },
    allowPasteExam: function allowPasteExam() {
      return !this.id;
    },

    draggableQuestionList: {
      get: function get() {
        return this.form.question_list;
      },
      set: function set(list) {
        console.log(list);
        var activeQuestion = this.form.question_list[this.activeQuestionIndex];
        this.form.question_list = list;
        var activeIndex = activeQuestion ? this.form.question_list.findIndex(function (question) {
          return question.client_id === activeQuestion.client_id;
        }) : -1;
        this.activeQuestionIndex = activeIndex >= 0 ? activeIndex : 0;
      }
    },
    questionCount: function questionCount() {
      return this.form.question_list.length;
    },
    totalScore: function totalScore() {
      return this.questionCount * (Number(this.form.question_score) || 0);
    },
    passingRate: function passingRate() {
      if (!this.totalScore) {
        return 0;
      }
      return Math.round((Number(this.form.passing_score) || 0) / this.totalScore * 100);
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.id = Number(this.$route.params.id);
      this.loadDetail(this.id);
    } else {
      this.applyRoutePrefill();
    }
  },
  mounted: function mounted() {
    if (this.allowCopyExam) {
      this.bindCopyExam();
    }
    if (this.allowPasteExam) {
      document.addEventListener('paste', this.pasteExam);
    }
  },
  destroyed: function destroyed() {
    if (this.copyExamClipboard) {
      this.copyExamClipboard.destroy();
      this.copyExamClipboard = null;
    }
    document.removeEventListener('paste', this.pasteExam);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getBasicCustomerTable', 'getCustomerDetail', 'queryTrainingKnowledge', 'getTrainingKnowledge', 'queryTrainingQuestion', 'getTrainingExamination', 'createTrainingExamination', 'updateTrainingExamination']), {
    validateCustomer: function validateCustomer(rule, value, callback) {
      if (Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].IS_COMMON_DEDICATED && !value) {
        callback(new Error('请选择所属客户'));
        return;
      }
      callback();
    },
    validatePositiveNumber: function validatePositiveNumber(message) {
      return function (rule, value, callback) {
        if (Number(value) <= 0) {
          callback(new Error(message));
          return;
        }
        callback();
      };
    },
    validatePassingScoreRule: function validatePassingScoreRule(rule, value, callback) {
      if (Number(value) <= 0 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('请输入及格分数'));
        return;
      }
      if (this.totalScore && Number(value) > this.totalScore && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('及格分数不能超过总分'));
        return;
      }
      if (Number(value) >= 100 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('及格分数不能大于等于100分'));
        return;
      }
      callback();
    },
    validatePassingScore: function validatePassingScore() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.validateField('passing_score');
      });
    },
    validateField: function validateField(field) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.form && _this2.$refs.form.validateField(field);
      });
    },
    bindCopyExam: function bindCopyExam() {
      var _this3 = this;

      this.copyExamClipboard = new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a(this.$refs.copyExam, {
        text: function text() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["a" /* buildTrainingExamCopyData */])(_this3.form));
        }
      });
      this.copyExamClipboard.on('success', function () {
        _this3.$message.success('复制成功');
      });
      this.copyExamClipboard.on('error', function () {
        _this3.$message.error('复制失败');
      });
    },
    pasteExam: function pasteExam(event) {
      var _this4 = this;

      if (!this.allowPasteExam) {
        return;
      }
      var paste = (event.clipboardData || window.clipboardData).getData('text');
      var copyData = null;
      try {
        copyData = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["q" /* normalizeTrainingExamCopyData */])(JSON.parse(paste));
      } catch (e) {}
      if (!copyData) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();
      var title = copyData.title || '未命名考试';
      this.$confirm('\u53D1\u73B0[' + title + ']\u8003\u8BD5JSON\uFF0C\u662F\u5426\u7ACB\u5373\u5199\u5165\u5F53\u524D\u8003\u8BD5\uFF1F', '提示', { type: 'warning' }).then(function () {
        _this4.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.form, copyData, {
          status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].STATUS_NEW
        });
        _this4.activeQuestionIndex = 0;
        _this4.clearScopeValidate();
        _this4.validatePassingScore();
        _this4.$message.success('考试JSON写入成功');
      });
    },
    applyRoutePrefill: function applyRoutePrefill() {
      var query = this.$route.query;
      if (query.target_usertype) {
        this.form.target_usertype = Number(query.target_usertype);
      }
      if (query.is_common !== undefined && query.is_common !== '') {
        this.form.is_common = Number(query.is_common);
      }
      if (query.customerid) {
        this.form.customerid = String(query.customerid);
      }
      if (query.training_knowledge_id) {
        this.form.training_knowledge_id = Number(query.training_knowledge_id);
      }
    },
    onOpenBookExamChanged: function onOpenBookExamChanged(value) {
      var _this5 = this;

      if (value === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_OPEN) {
        this.$nextTick(function () {
          _this5.$refs.form && _this5.$refs.form.clearValidate(['question_score', 'passing_score']);
        });
      }
    },
    loadDetail: function loadDetail(id) {
      var _this6 = this;

      request.common('getTrainingExamination', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this6.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.form, {
          title: data.title || '',
          status: Number(data.status) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].STATUS_NEW,
          target_usertype: data.target_usertype || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].TARGETUSER_TYPE_USER,
          is_common: Number(data.is_common || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].IS_COMMON_DEDICATED),
          customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
          training_knowledge_id: data.training_knowledge_id || null,
          open_book_exam: Number(data.open_book_exam),
          question_score: Number(data.question_score) || 10,
          passing_score: Number(data.passing_score) || 60,
          exam_duration: Number(data.exam_duration) || 60,
          question_sort_type: Number(data.question_sort_type) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].SORT_TYPE_FIXED,
          question_options_sort_type: Number(data.question_options_sort_type) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].SORT_TYPE_FIXED,
          question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["p" /* normalizeExamQuestionFromRow */])(item);
          }) : []
        });
      });
    },
    onIsCommonChanged: function onIsCommonChanged(value) {
      if (this.isScopeLocked) {
        return;
      }
      if (Number(value) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].IS_COMMON_SHARED) {
        this.form.customerid = null;
      }
      this.form.training_knowledge_id = null;
      this.clearScopeValidate();
    },
    onCustomerChanged: function onCustomerChanged() {
      if (this.isScopeLocked) {
        return;
      }
      this.form.training_knowledge_id = null;
      this.clearScopeValidate();
    },
    clearScopeValidate: function clearScopeValidate() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.$refs.form && _this7.$refs.form.clearValidate(['customerid', 'training_knowledge_id']);
      });
    },
    addQuestion: function addQuestion(type) {
      var _this8 = this;

      if (this.isStructureLocked) {
        return;
      }
      this.form.question_list.push(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["c" /* createExamQuestion */])(type));
      this.activeQuestionIndex = this.form.question_list.length - 1;
      // 每新增一条要检测一下分数是否超限
      this.validatePassingScore();
      this.$nextTick(function () {
        _this8.scrollToQuestion(_this8.activeQuestionIndex);
      });
    },
    removeQuestion: function removeQuestion(index) {
      var _this9 = this;

      if (this.isStructureLocked) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u5220\u9664\u7B2C ' + (index + 1) + ' \u9898\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        _this9.form.question_list.splice(index, 1);
        if (_this9.activeQuestionIndex >= _this9.form.question_list.length) {
          _this9.activeQuestionIndex = Math.max(_this9.form.question_list.length - 1, 0);
        }
        _this9.validatePassingScore();
      });
    },
    scrollToQuestion: function scrollToQuestion(index) {
      var _this10 = this;

      this.activeQuestionIndex = index;
      this.$nextTick(function () {
        var ref = _this10.$refs['questionCard_' + index];
        var el = Array.isArray(ref) ? ref[0] : ref;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    openQuestionDialog: function openQuestionDialog() {
      if (this.isStructureLocked) {
        return;
      }
      this.questionDialogVisible = true;
    },
    onQuestionDialogOpen: function onQuestionDialogOpen() {
      this.selectedQuestionRows = [];
      this.loadQuestionBank();
    },
    getQuestionBankParams: function getQuestionBankParams() {
      var params = {
        current_page: this.questionPagination.current_page,
        per_page: this.questionPagination.per_page,
        title: this.questionSearch.title,
        target_usertype: this.form.target_usertype
      };
      if (this.questionSearch.customerid) {
        params.customerid = [this.questionSearch.customerid];
      }
      if (this.questionSearch.training_knowledge_id) {
        params.training_knowledge_id = [this.questionSearch.training_knowledge_id];
      }
      if (this.questionSearch.question_type) {
        params.question_type = [this.questionSearch.question_type];
      }
      return params;
    },
    loadQuestionBank: function loadQuestionBank() {
      var _this11 = this;

      this.questionDialogLoading = true;
      request.page('queryTrainingQuestion', this.getQuestionBankParams()).then(function (_ref2) {
        var data = _ref2.data;

        _this11.questionBankList = data.data || [];
        _this11.questionPagination.current_page = Number(data.current_page) || 1;
        _this11.questionPagination.per_page = Number(data.per_page) || 10;
        _this11.questionPagination.total = Number(data.total) || 0;
      }).finally(function () {
        _this11.questionDialogLoading = false;
      });
    },
    searchQuestionBank: function searchQuestionBank() {
      this.questionPagination.current_page = 1;
      this.loadQuestionBank();
    },
    resetQuestionSearch: function resetQuestionSearch() {
      this.questionSearch = {
        title: '',
        customerid: null,
        training_knowledge_id: null,
        question_type: null
      };
      this.searchQuestionBank();
    },
    handleQuestionPageChange: function handleQuestionPageChange(page) {
      this.questionPagination.current_page = page;
      this.loadQuestionBank();
    },
    getBankQuestionKey: function getBankQuestionKey(row) {
      return Number(row.id);
    },
    isBankQuestionSelected: function isBankQuestionSelected(row) {
      var _this12 = this;

      var key = this.getBankQuestionKey(row);
      return this.selectedQuestionRows.some(function (item) {
        return _this12.getBankQuestionKey(item) === key;
      });
    },
    toggleBankQuestion: function toggleBankQuestion(row, checked) {
      var _this13 = this;

      var key = this.getBankQuestionKey(row);
      if (checked && !this.isBankQuestionSelected(row)) {
        this.selectedQuestionRows.push(row);
      }
      if (!checked) {
        this.selectedQuestionRows = this.selectedQuestionRows.filter(function (item) {
          return _this13.getBankQuestionKey(item) !== key;
        });
      }
    },
    addSelectedQuestions: function addSelectedQuestions() {
      var _this14 = this;

      if (!this.selectedQuestionRows.length) {
        this.$message.error('请选择题目');
        return;
      }
      this.selectedQuestionRows.forEach(function (row) {
        _this14.form.question_list.push(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["p" /* normalizeExamQuestionFromRow */])(row));
      });
      this.activeQuestionIndex = this.form.question_list.length - 1;
      this.$message.success('\u5DF2\u6DFB\u52A0 ' + this.selectedQuestionRows.length + ' \u9898');
      this.selectedQuestionRows = [];
      this.questionDialogVisible = false;
      this.validatePassingScore();
    },
    getRowQuestionJson: function getRowQuestionJson(row) {
      return row.question_json || {};
    },
    getRowQuestionType: function getRowQuestionType(row) {
      return row.question_type || row.type || this.getRowQuestionJson(row).question_type;
    },
    getRowQuestionTitle: function getRowQuestionTitle(row) {
      return row.title || this.getRowQuestionJson(row).title || '-';
    },
    getRowQuestionOptions: function getRowQuestionOptions(row) {
      var json = this.getRowQuestionJson(row);
      if (Array.isArray(json.options)) {
        return json.options;
      }
      return Array.isArray(row.options) ? row.options : [];
    },
    getFirstValue: function getFirstValue(row, keys) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var key = keys.find(function (item) {
        return row[item] !== undefined && row[item] !== null;
      });
      return key ? row[key] : defaultValue;
    },
    formatAccuracy: function formatAccuracy(row) {
      var direct = this.getFirstValue(row, ['correct_rate', 'accuracy_rate', 'accuracy'], null);
      if (direct === null) {
        return '';
      }
      var value = Number(direct);
      var percent = value <= 1 ? value * 100 : value;
      return percent.toFixed(1).replace(/\.0$/, '') + '%';
    },
    getQuestionUniqueKey: function getQuestionUniqueKey(question) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["d" /* getExamQuestionDuplicateKey */])(question);
    },
    validateDuplicateQuestions: function validateDuplicateQuestions() {
      var questionKeyMap = {};
      for (var index = 0; index < this.form.question_list.length; index += 1) {
        var key = this.getQuestionUniqueKey(this.form.question_list[index]);
        if (questionKeyMap[key] !== undefined) {
          var firstIndex = questionKeyMap[key] + 1;
          var duplicateIndex = index + 1;
          this.activeQuestionIndex = index;
          this.$message.error('\u7B2C ' + duplicateIndex + ' \u9898\u4E0E\u7B2C ' + firstIndex + ' \u9898\u91CD\u590D\uFF0C\u8BF7\u4FEE\u6539\u540E\u518D\u63D0\u4EA4');
          return false;
        }
        questionKeyMap[key] = index;
      }
      return true;
    },

    getQuestionTypeLabel: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["j" /* getQuestionTypeLabel */],
    getOptionLetter: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["e" /* getOptionLetter */],
    validateQuestions: function validateQuestions() {
      if (!this.form.question_list.length) {
        this.$message.error('请至少添加一道题目');
        return false;
      }
      for (var index = 0; index < this.form.question_list.length; index += 1) {
        var question = this.form.question_list[index];
        var label = '\u7B2C ' + (index + 1) + ' \u9898';

        if (this.totalScore !== 100 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
          this.$message.error('闭卷类型的试卷总分必须是100');
          return false;
        }
        if (!question.title) {
          this.activeQuestionIndex = index;
          this.$message.error(label + '\u8BF7\u586B\u5199\u9898\u76EE\u6807\u9898');
          return false;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["k" /* isChoiceQuestion */])(question.question_type)) {
          if (!Array.isArray(question.options) || !question.options.length) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u6DFB\u52A0\u7B54\u6848\u9009\u9879');
            return false;
          }
          if (!question.options.every(function (option) {
            return option.title;
          })) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u586B\u5199\u5B8C\u6574\u9009\u9879\u5185\u5BB9');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE && !question.standard_answer) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u6B63\u786E\u7B54\u6848');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI && (!Array.isArray(question.standard_answer) || !question.standard_answer.length)) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u6B63\u786E\u7B54\u6848');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI && Array.isArray(question.standard_answer) && question.standard_answer.length <= 1) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u81F3\u5C112\u4E2A\u7B54\u6848\u9009\u9879');
            return false;
          }
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["l" /* isNumericAnswer */])(question.standard_answer)) {
          this.activeQuestionIndex = index;
          this.$message.error(label + '\u586B\u7A7A\u9898\u7B54\u6848\u4EC5\u652F\u6301\u6570\u5B57');
          return false;
        }
      }
      // if (!this.validateDuplicateQuestions()) {
      //   return false
      // }
      return true;
    },
    onSubmit: function onSubmit() {
      var _this15 = this;

      if (this.submitting || this.uploading || this.isReadonly) {
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this15.$message.error('请检查表单填写是否正确');
          return;
        }
        if (!_this15.validateQuestions()) {
          return;
        }
        var requestName = _this15.id ? 'updateTrainingExamination' : 'createTrainingExamination';
        var params = _this15.id ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ id: _this15.id }, Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["h" /* getExamSubmitPayload */])(_this15.form)) : Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_constants__["h" /* getExamSubmitPayload */])(_this15.form);
        _this15.submitting = true;
        request.common(requestName, params).then(function () {
          _this15.$message.success(_this15.id ? '保存成功' : '创建成功');
          _this15.$router.push({ path: '/training/examination' });
        }).finally(function () {
          _this15.submitting = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 3060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_user__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_common__ = __webpack_require__(1515);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */],
      examOptions: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["r" /* opts */],
      search: {
        title: null,
        open_book_exam: null,
        target_usertype: null,
        status: [],
        is_common: null,
        training_knowledge_id: [],
        customerid: [],
        creator_id: [],
        created_at: []
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      searchFieldType: {
        open_book_exam: Number,
        target_usertype: Number,
        status: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        is_common: Number,
        training_knowledge_id: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        customerid: Array,
        creator_id: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        created_at: Array
      },
      internAssignmentDialogVisible: false,
      internAssignmentMode: 'all',
      internAssignmentFile: null,
      internAssignmentUploading: false
    };
  },

  computed: {
    isSuperAdmin: function isSuperAdmin() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__views_training_training_user__["a" /* isSuperAdminUser */])(this.loginUser);
    },
    internAssignmentModeHint: function internAssignmentModeHint() {
      if (this.internAssignmentMode === 'all') return '所有实习生：账号ID必须留空，按考试ID为所有实习生分配。';
      if (this.internAssignmentMode === 'replace') return '覆盖上传实习生：实习生账号ID必须填写，按考试覆盖实习生分配关系。';
      return '追加上传实习生：实习生账号ID必须填写，在该考试现有实习生分配后追加。';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['queryTrainingKnowledge', 'getTrainingKnowledge', 'getBasicCustomerTable', 'getCustomerDetail', 'getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.page('queryInternTrainingExamination', params);
    },
    openInternAssignmentDialog: function openInternAssignmentDialog() {
      this.resetInternAssignmentDialog();
      this.internAssignmentDialogVisible = true;
    },
    beforeInternAssignmentUpload: function beforeInternAssignmentUpload(file) {
      if (!/\.xlsx$/i.test(file.name || '')) {
        this.$message.error('仅支持上传 .xlsx 文件');
        return false;
      }
      return true;
    },
    handleInternAssignmentFileChange: function handleInternAssignmentFileChange(file, fileList) {
      var selected = fileList[fileList.length - 1];
      this.internAssignmentFile = selected && this.beforeInternAssignmentUpload(selected) ? selected.raw || selected : null;
    },
    submitInternAssignment: function submitInternAssignment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.internAssignmentUploading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (_this.internAssignmentFile) {
                  _context.next = 5;
                  break;
                }

                _this.$message.error('请先选择实习生考试文件');
                return _context.abrupt('return');

              case 5:
                _this.internAssignmentUploading = true;
                _context.prev = 6;
                _context.next = 9;
                return request.common('uploadInternExaminationAssignment', {
                  mode: _this.internAssignmentMode,
                  file: _this.internAssignmentFile
                });

              case 9:
                _this.$message.success('批量分配成功');
                _this.internAssignmentDialogVisible = false;
                _this.internAssignmentUploading = false;
                _this.resetInternAssignmentDialog();
                _this.onRefresh();
                _context.next = 18;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](6);

              case 18:
                _context.prev = 18;

                _this.internAssignmentUploading = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 16, 18, 21]]);
      }))();
    },
    resetInternAssignmentDialog: function resetInternAssignmentDialog() {
      if (this.internAssignmentUploading) return;
      this.internAssignmentMode = 'all';
      this.internAssignmentFile = null;
      if (this.$refs.internAssignmentUpload) this.$refs.internAssignmentUpload.clearFiles();
    },
    downloadInternAssignmentTemplate: function downloadInternAssignmentTemplate() {
      var row = {
        training_exam_id: '必填',
        intern_user_id: this.internAssignmentMode === 'all' ? '' : '必填',
        name: '选填'
      };
      this.$export('实习生考试批量分配模板', [row], {
        fileHeader: [{ key: 'training_exam_id', text: '考试ID' }, { key: 'intern_user_id', text: '实习生账号ID' }, { key: 'name', text: '姓名' }]
      });
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },
    getIsCommonLabel: function getIsCommonLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["i" /* getOptionLabel */])(this.examOptions.isCommonMaps, value) || '-';
    },
    getInternScopeLabel: function getInternScopeLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["i" /* getOptionLabel */])(this.examOptions.InternScopeMaps, value) || '-';
    },

    getExamStatusLabel: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["f" /* getExamStatusLabel */],
    getStatusTagClass: function getStatusTagClass(status) {
      return 'exam-tag--' + Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["g" /* getExamStatusType */])(status);
    },
    getTagClass: function getTagClass(type, value) {
      if (type === 'user') {
        return Number(value) === this.consts.TARGETUSER_TYPE_USER ? 'exam-tag--primary' : 'exam-tag--warning';
      }
      if (type === 'common') {
        return Number(value) === this.consts.IS_COMMON_SHARED ? 'exam-tag--success' : 'exam-tag--default';
      }
      return 'exam-tag--default';
    },
    getQuestionCount: function getQuestionCount(row) {
      return Array.isArray(row.question_list) ? row.question_list.length : 0;
    },
    formatPassingScore: function formatPassingScore(row) {
      if (row.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        var passingScore = row.passing_score === undefined || row.passing_score === null ? '-' : row.passing_score;
        var totalScore = row.question_score * this.getQuestionCount(row);
        if (totalScore) {
          return totalScore ? passingScore + '/' + totalScore : passingScore;
        } else {
          return '-';
        }
      } else {
        var statusItem = (this.examOptions.openBookMaps || []).find(function (item) {
          return item.value === row.open_book_exam;
        });
        return statusItem ? statusItem.label : '';
      }
    },
    getActionConfig: function getActionConfig(name) {
      var actions = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_NEW).concat(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_ONLINE)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_OFFLINE)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["e" /* getExamStatusActions */])(this.consts.STATUS_BANNED));
      return actions.find(function (action) {
        return action.name === name;
      });
    },
    handleExamAction: function handleExamAction(row, name) {
      var _this2 = this;

      var action = this.getActionConfig(name);
      if (!action) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u8981' + action.label + '\u8003\u8BD5\u3010' + row.title + '\u3011\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        request.common(action.apiName, row.id).then(function () {
          _this2.$message.success(action.successText);
          _this2.onRefresh();
        });
      });
    },
    getExamRecordLink: function getExamRecordLink(row) {
      return {
        path: '/training/examination/' + row.id + '/intern/records',
        query: { title: row.title }
      };
    }
  })
});

/***/ }),

/***/ 3061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_components_QuestionForm_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__ = __webpack_require__(1526);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingExamForm',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    QuestionForm: __WEBPACK_IMPORTED_MODULE_5__views_training_components_QuestionForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      consts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["r" /* opts */],
      questionConsts: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */],
      questionOpts: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["o" /* opts */],
      submitting: false,
      uploading: false,
      copyExamClipboard: null,
      activeQuestionIndex: 0,
      questionDialogVisible: false,
      questionDialogLoading: false,
      questionBankList: [],
      selectedQuestionRows: [],
      questionPagination: {
        current_page: 1,
        per_page: 10,
        total: 0
      },
      questionSearch: {
        title: '',
        customerid: null,
        training_knowledge_id: null,
        question_type: null
      },
      form: {
        status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].STATUS_NEW,
        target_usertype: 2,
        title: '',
        is_common: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].IS_COMMON_DEDICATED,
        customerid: null,
        training_knowledge_id: null,
        open_book_exam: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED,
        question_score: 10,
        passing_score: 60,
        exam_duration: 60,
        question_sort_type: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].SORT_TYPE_FIXED,
        question_options_sort_type: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].SORT_TYPE_FIXED,
        question_list: []
      }
    };
  },

  computed: {
    formRules: function formRules() {
      return {
        title: [{ required: true, message: '请输入考试标题', trigger: 'blur' }, { max: 100, message: '考试标题最多 100 个字符', trigger: 'blur' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{ validator: this.validateCustomer, trigger: 'change' }],
        training_knowledge_id: [{ required: true, message: '请选择所属知识库', trigger: 'change' }],
        open_book_exam: [{ required: true, message: '请选择是否开卷', trigger: 'change' }],
        question_score: [{ validator: this.validatePositiveNumber('请输入单题分值'), trigger: 'blur' }],
        passing_score: [{ validator: this.validatePassingScoreRule, trigger: 'blur' }],
        exam_duration: [{ validator: this.validatePositiveNumber('请输入考试时效'), trigger: 'blur' }],
        question_sort_type: [{ required: true, message: '请选择题目顺序', trigger: 'change' }],
        question_options_sort_type: [{ required: true, message: '请选择选项顺序', trigger: 'change' }]
      };
    },
    knowledgeQueryParams: function knowledgeQueryParams() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(this.form);
    },
    knowledgeDisabled: function knowledgeDisabled() {
      return this.isScopeLocked || Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].IS_COMMON_DEDICATED && !this.form.customerid;
    },
    isReadonly: function isReadonly() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["l" /* isExamReadonly */])(this.form.status);
    },
    isScopeLocked: function isScopeLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["m" /* isExamScopeLocked */])(this.form.status);
    },
    isStructureLocked: function isStructureLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["o" /* isExamStructureLocked */])(this.form.status);
    },
    isQuestionScoreLocked: function isQuestionScoreLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["n" /* isExamScoreLocked */])(this.form.status);
    },
    isAnswerLocked: function isAnswerLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["j" /* isExamAnswerLocked */])(this.form.status);
    },
    isOptionStructureLocked: function isOptionStructureLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["k" /* isExamOptionStructureLocked */])(this.form.status);
    },
    allowCopyExam: function allowCopyExam() {
      return !!this.id;
    },
    allowPasteExam: function allowPasteExam() {
      return !this.id;
    },

    draggableQuestionList: {
      get: function get() {
        return this.form.question_list;
      },
      set: function set(list) {
        var activeQuestion = this.form.question_list[this.activeQuestionIndex];
        this.form.question_list = list;
        var activeIndex = activeQuestion ? this.form.question_list.findIndex(function (question) {
          return question.client_id === activeQuestion.client_id;
        }) : -1;
        this.activeQuestionIndex = activeIndex >= 0 ? activeIndex : 0;
      }
    },
    questionCount: function questionCount() {
      return this.form.question_list.length;
    },
    totalScore: function totalScore() {
      return this.questionCount * (Number(this.form.question_score) || 0);
    },
    passingRate: function passingRate() {
      if (!this.totalScore) {
        return 0;
      }
      return Math.round((Number(this.form.passing_score) || 0) / this.totalScore * 100);
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.id = Number(this.$route.params.id);
      this.loadDetail(this.id);
    } else {
      this.applyRoutePrefill();
    }
  },
  mounted: function mounted() {
    if (this.allowCopyExam) {
      this.bindCopyExam();
    }
    if (this.allowPasteExam) {
      document.addEventListener('paste', this.pasteExam);
    }
  },
  destroyed: function destroyed() {
    if (this.copyExamClipboard) {
      this.copyExamClipboard.destroy();
      this.copyExamClipboard = null;
    }
    document.removeEventListener('paste', this.pasteExam);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getBasicCustomerTable', 'getCustomerDetail', 'queryTrainingKnowledge', 'getTrainingKnowledge', 'queryTrainingQuestion', 'getTrainingExamination', 'createTrainingExamination', 'updateTrainingExamination']), {
    validateCustomer: function validateCustomer(rule, value, callback) {
      if (Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].IS_COMMON_DEDICATED && !value) {
        callback(new Error('请选择所属客户'));
        return;
      }
      callback();
    },
    validatePositiveNumber: function validatePositiveNumber(message) {
      return function (rule, value, callback) {
        if (Number(value) <= 0) {
          callback(new Error(message));
          return;
        }
        callback();
      };
    },
    validatePassingScoreRule: function validatePassingScoreRule(rule, value, callback) {
      if (Number(value) <= 0 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('请输入及格分数'));
        return;
      }
      if (this.totalScore && Number(value) > this.totalScore && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('及格分数不能超过总分'));
        return;
      }
      if (Number(value) >= 100 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
        callback(new Error('及格分数不能大于等于100分'));
        return;
      }
      callback();
    },
    validatePassingScore: function validatePassingScore() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.validateField('passing_score');
      });
    },
    validateField: function validateField(field) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.form && _this2.$refs.form.validateField(field);
      });
    },
    bindCopyExam: function bindCopyExam() {
      var _this3 = this;

      this.copyExamClipboard = new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a(this.$refs.copyExam, {
        text: function text() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["a" /* buildTrainingExamCopyData */])(_this3.form));
        }
      });
      this.copyExamClipboard.on('success', function () {
        _this3.$message.success('复制成功');
      });
      this.copyExamClipboard.on('error', function () {
        _this3.$message.error('复制失败');
      });
    },
    pasteExam: function pasteExam(event) {
      var _this4 = this;

      if (!this.allowPasteExam) {
        return;
      }
      var paste = (event.clipboardData || window.clipboardData).getData('text');
      var copyData = null;
      try {
        copyData = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["q" /* normalizeTrainingExamCopyData */])(JSON.parse(paste));
      } catch (e) {}
      if (!copyData) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();
      var title = copyData.title || '未命名考试';
      this.$confirm('\u53D1\u73B0[' + title + ']\u8003\u8BD5JSON\uFF0C\u662F\u5426\u7ACB\u5373\u5199\u5165\u5F53\u524D\u8003\u8BD5\uFF1F', '提示', { type: 'warning' }).then(function () {
        _this4.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.form, copyData, {
          status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].STATUS_NEW
        });
        _this4.activeQuestionIndex = 0;
        _this4.clearScopeValidate();
        _this4.validatePassingScore();
        _this4.$message.success('考试JSON写入成功');
      });
    },
    applyRoutePrefill: function applyRoutePrefill() {
      var query = this.$route.query;
      if (query.is_common !== undefined && query.is_common !== '') {
        this.form.is_common = Number(query.is_common);
      }
      if (query.customerid) {
        this.form.customerid = String(query.customerid);
      }
      if (query.training_knowledge_id) {
        this.form.training_knowledge_id = Number(query.training_knowledge_id);
      }
    },
    onOpenBookExamChanged: function onOpenBookExamChanged(value) {
      var _this5 = this;

      if (value === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_OPEN) {
        this.$nextTick(function () {
          _this5.$refs.form && _this5.$refs.form.clearValidate(['question_score', 'passing_score']);
        });
      }
    },
    loadDetail: function loadDetail(id) {
      var _this6 = this;

      request.common('getInternTrainingExamination', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this6.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.form, {
          title: data.title || '',
          target_usertype: 2,
          status: Number(data.status) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].STATUS_NEW,
          is_common: Number(data.is_common || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].IS_COMMON_DEDICATED),
          customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
          training_knowledge_id: data.training_knowledge_id || null,
          open_book_exam: Number(data.open_book_exam),
          question_score: Number(data.question_score) || 10,
          passing_score: Number(data.passing_score) || 60,
          exam_duration: Number(data.exam_duration) || 60,
          question_sort_type: Number(data.question_sort_type) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].SORT_TYPE_FIXED,
          question_options_sort_type: Number(data.question_options_sort_type) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].SORT_TYPE_FIXED,
          question_list: Array.isArray(data.question_list) ? data.question_list.map(function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["p" /* normalizeExamQuestionFromRow */])(item);
          }) : []
        });
      });
    },
    onIsCommonChanged: function onIsCommonChanged(value) {
      if (this.isScopeLocked) {
        return;
      }
      if (Number(value) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].IS_COMMON_SHARED) {
        this.form.customerid = null;
      }
      this.form.training_knowledge_id = null;
      this.clearScopeValidate();
    },
    onCustomerChanged: function onCustomerChanged() {
      if (this.isScopeLocked) {
        return;
      }
      this.form.training_knowledge_id = null;
      this.clearScopeValidate();
    },
    clearScopeValidate: function clearScopeValidate() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.$refs.form && _this7.$refs.form.clearValidate(['customerid', 'training_knowledge_id']);
      });
    },
    addQuestion: function addQuestion(type) {
      var _this8 = this;

      if (this.isStructureLocked) {
        return;
      }
      this.form.question_list.push(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["c" /* createExamQuestion */])(type));
      this.activeQuestionIndex = this.form.question_list.length - 1;
      // 每新增一条要检测一下分数是否超限
      this.validatePassingScore();
      this.$nextTick(function () {
        _this8.scrollToQuestion(_this8.activeQuestionIndex);
      });
    },
    removeQuestion: function removeQuestion(index) {
      var _this9 = this;

      if (this.isStructureLocked) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u5220\u9664\u7B2C ' + (index + 1) + ' \u9898\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        _this9.form.question_list.splice(index, 1);
        if (_this9.activeQuestionIndex >= _this9.form.question_list.length) {
          _this9.activeQuestionIndex = Math.max(_this9.form.question_list.length - 1, 0);
        }
        _this9.validatePassingScore();
      });
    },
    scrollToQuestion: function scrollToQuestion(index) {
      var _this10 = this;

      this.activeQuestionIndex = index;
      this.$nextTick(function () {
        var ref = _this10.$refs['questionCard_' + index];
        var el = Array.isArray(ref) ? ref[0] : ref;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    openQuestionDialog: function openQuestionDialog() {
      if (this.isStructureLocked) {
        return;
      }
      this.questionDialogVisible = true;
    },
    onQuestionDialogOpen: function onQuestionDialogOpen() {
      this.selectedQuestionRows = [];
      this.loadQuestionBank();
    },
    getQuestionBankParams: function getQuestionBankParams() {
      var params = {
        current_page: this.questionPagination.current_page,
        per_page: this.questionPagination.per_page,
        title: this.questionSearch.title,
        target_usertype: __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].TARGETUSER_TYPE_INTERN
      };
      if (this.questionSearch.customerid) {
        params.customerid = [this.questionSearch.customerid];
      }
      if (this.questionSearch.training_knowledge_id) {
        params.training_knowledge_id = [this.questionSearch.training_knowledge_id];
      }
      if (this.questionSearch.question_type) {
        params.question_type = [this.questionSearch.question_type];
      }
      return params;
    },
    loadQuestionBank: function loadQuestionBank() {
      var _this11 = this;

      this.questionDialogLoading = true;
      request.page('queryTrainingQuestion', this.getQuestionBankParams()).then(function (_ref2) {
        var data = _ref2.data;

        _this11.questionBankList = data.data || [];
        _this11.questionPagination.current_page = Number(data.current_page) || 1;
        _this11.questionPagination.per_page = Number(data.per_page) || 10;
        _this11.questionPagination.total = Number(data.total) || 0;
      }).finally(function () {
        _this11.questionDialogLoading = false;
      });
    },
    searchQuestionBank: function searchQuestionBank() {
      this.questionPagination.current_page = 1;
      this.loadQuestionBank();
    },
    resetQuestionSearch: function resetQuestionSearch() {
      this.questionSearch = {
        title: '',
        customerid: null,
        training_knowledge_id: null,
        question_type: null
      };
      this.searchQuestionBank();
    },
    handleQuestionPageChange: function handleQuestionPageChange(page) {
      this.questionPagination.current_page = page;
      this.loadQuestionBank();
    },
    getBankQuestionKey: function getBankQuestionKey(row) {
      return Number(row.id);
    },
    isBankQuestionSelected: function isBankQuestionSelected(row) {
      var _this12 = this;

      var key = this.getBankQuestionKey(row);
      return this.selectedQuestionRows.some(function (item) {
        return _this12.getBankQuestionKey(item) === key;
      });
    },
    toggleBankQuestion: function toggleBankQuestion(row, checked) {
      var _this13 = this;

      var key = this.getBankQuestionKey(row);
      if (checked && !this.isBankQuestionSelected(row)) {
        this.selectedQuestionRows.push(row);
      }
      if (!checked) {
        this.selectedQuestionRows = this.selectedQuestionRows.filter(function (item) {
          return _this13.getBankQuestionKey(item) !== key;
        });
      }
    },
    addSelectedQuestions: function addSelectedQuestions() {
      var _this14 = this;

      if (!this.selectedQuestionRows.length) {
        this.$message.error('请选择题目');
        return;
      }
      this.selectedQuestionRows.forEach(function (row) {
        _this14.form.question_list.push(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["p" /* normalizeExamQuestionFromRow */])(row));
      });
      this.activeQuestionIndex = this.form.question_list.length - 1;
      this.$message.success('\u5DF2\u6DFB\u52A0 ' + this.selectedQuestionRows.length + ' \u9898');
      this.selectedQuestionRows = [];
      this.questionDialogVisible = false;
      this.validatePassingScore();
    },
    getRowQuestionJson: function getRowQuestionJson(row) {
      return row.question_json || {};
    },
    getRowQuestionType: function getRowQuestionType(row) {
      return row.question_type || row.type || this.getRowQuestionJson(row).question_type;
    },
    getRowQuestionTitle: function getRowQuestionTitle(row) {
      return row.title || this.getRowQuestionJson(row).title || '-';
    },
    getRowQuestionOptions: function getRowQuestionOptions(row) {
      var json = this.getRowQuestionJson(row);
      if (Array.isArray(json.options)) {
        return json.options;
      }
      return Array.isArray(row.options) ? row.options : [];
    },
    getFirstValue: function getFirstValue(row, keys) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var key = keys.find(function (item) {
        return row[item] !== undefined && row[item] !== null;
      });
      return key ? row[key] : defaultValue;
    },
    formatAccuracy: function formatAccuracy(row) {
      var direct = this.getFirstValue(row, ['correct_rate', 'accuracy_rate', 'accuracy'], null);
      if (direct === null) {
        return '';
      }
      var value = Number(direct);
      var percent = value <= 1 ? value * 100 : value;
      return percent.toFixed(1).replace(/\.0$/, '') + '%';
    },
    getQuestionUniqueKey: function getQuestionUniqueKey(question) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["d" /* getExamQuestionDuplicateKey */])(question);
    },
    validateDuplicateQuestions: function validateDuplicateQuestions() {
      var questionKeyMap = {};
      for (var index = 0; index < this.form.question_list.length; index += 1) {
        var key = this.getQuestionUniqueKey(this.form.question_list[index]);
        if (questionKeyMap[key] !== undefined) {
          var firstIndex = questionKeyMap[key] + 1;
          var duplicateIndex = index + 1;
          this.activeQuestionIndex = index;
          this.$message.error('\u7B2C ' + duplicateIndex + ' \u9898\u4E0E\u7B2C ' + firstIndex + ' \u9898\u91CD\u590D\uFF0C\u8BF7\u4FEE\u6539\u540E\u518D\u63D0\u4EA4');
          return false;
        }
        questionKeyMap[key] = index;
      }
      return true;
    },

    getQuestionTypeLabel: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["j" /* getQuestionTypeLabel */],
    getOptionLetter: __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["e" /* getOptionLetter */],
    validateQuestions: function validateQuestions() {
      if (!this.form.question_list.length) {
        this.$message.error('请至少添加一道题目');
        return false;
      }
      for (var index = 0; index < this.form.question_list.length; index += 1) {
        var question = this.form.question_list[index];
        var label = '\u7B2C ' + (index + 1) + ' \u9898';

        if (this.totalScore !== 100 && this.form.open_book_exam === __WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["b" /* consts */].OPEN_BOOK_EXAM_CLOSED) {
          this.$message.error('闭卷类型的试卷总分必须是100');
          return false;
        }
        if (!question.title) {
          this.activeQuestionIndex = index;
          this.$message.error(label + '\u8BF7\u586B\u5199\u9898\u76EE\u6807\u9898');
          return false;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["k" /* isChoiceQuestion */])(question.question_type)) {
          if (!Array.isArray(question.options) || !question.options.length) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u6DFB\u52A0\u7B54\u6848\u9009\u9879');
            return false;
          }
          if (!question.options.every(function (option) {
            return option.title;
          })) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u586B\u5199\u5B8C\u6574\u9009\u9879\u5185\u5BB9');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE && !question.standard_answer) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u6B63\u786E\u7B54\u6848');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI && (!Array.isArray(question.standard_answer) || !question.standard_answer.length)) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u6B63\u786E\u7B54\u6848');
            return false;
          }
          if (Number(question.question_type) === __WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI && Array.isArray(question.standard_answer) && question.standard_answer.length <= 1) {
            this.activeQuestionIndex = index;
            this.$message.error(label + '\u8BF7\u9009\u62E9\u81F3\u5C112\u4E2A\u7B54\u6848\u9009\u9879');
            return false;
          }
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_8__views_training_training_question_constants__["l" /* isNumericAnswer */])(question.standard_answer)) {
          this.activeQuestionIndex = index;
          this.$message.error(label + '\u586B\u7A7A\u9898\u7B54\u6848\u4EC5\u652F\u6301\u6570\u5B57');
          return false;
        }
      }
      // if (!this.validateDuplicateQuestions()) {
      //   return false
      // }
      return true;
    },
    onSubmit: function onSubmit() {
      var _this15 = this;

      if (this.submitting || this.uploading || this.isReadonly) {
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this15.$message.error('请检查表单填写是否正确');
          return;
        }
        if (!_this15.validateQuestions()) {
          return;
        }
        var requestName = _this15.id ? 'updateTrainingExaminationIntern' : 'createTrainingExaminationIntern';
        var params = _this15.id ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ id: _this15.id }, Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["h" /* getExamSubmitPayload */])(_this15.form)) : Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_exam_intern_constants__["h" /* getExamSubmitPayload */])(_this15.form);
        _this15.submitting = true;
        request.common(requestName, params).then(function () {
          _this15.$message.success(_this15.id ? '保存成功' : '创建成功');
          _this15.$router.push({ path: '/training/intern-examination' });
        }).finally(function () {
          _this15.submitting = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExamForm_vue__ = __webpack_require__(3059);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5355abe2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExamForm_vue__ = __webpack_require__(5678);
function injectStyle (ssrContext) {
  __webpack_require__(5676)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5355abe2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingExamForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5355abe2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingExamForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingExamForm_vue__ = __webpack_require__(3061);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebd560c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingExamForm_vue__ = __webpack_require__(5684);
function injectStyle (ssrContext) {
  __webpack_require__(5682)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ebd560c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingExamForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebd560c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingExamForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5650:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5651);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d9ee594", content, true, {});

/***/ }),

/***/ 5651:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-exam-record__card[data-v-ad5def66]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.training-instruction-exam-record__card+.training-instruction-exam-record__card[data-v-ad5def66]{margin-top:16px}.training-instruction-exam-record__card-header[data-v-ad5def66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.training-instruction-exam-record__card-header i[data-v-ad5def66]{color:#909399}.training-instruction-exam-record__card-header-actions[data-v-ad5def66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.training-instruction-exam-record__card-header-actions ::v-deep .training-instruction-exam-record__header-action.el-button[data-v-ad5def66]{min-width:24px;padding:0;margin:0}.training-instruction-exam-record__header-action[data-v-ad5def66]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.training-instruction-exam-record__header-action i[data-v-ad5def66]{font-size:14px}.training-instruction-exam-record__search-form[data-v-ad5def66]{padding:16px 24px 20px}.training-instruction-exam-record__search-grid[data-v-ad5def66]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.training-instruction-exam-record__search-actions[data-v-ad5def66]{margin-top:4px;padding-top:4px}.training-instruction-exam-record__list-body[data-v-ad5def66]{padding:0 16px 16px}.training-instruction-exam-record__table-wrap[data-v-ad5def66]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden}.training-instruction-exam-record__table ::v-deep th[data-v-ad5def66]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.training-instruction-exam-record__table ::v-deep td[data-v-ad5def66]{font-size:14px;color:#303133}.training-instruction-exam-record__table ::v-deep .el-table__row:hover>td[data-v-ad5def66]{background:#fafafa}.training-instruction-exam-record__table[data-v-ad5def66] ::v-deep:before{display:none}.training-instruction-exam-record__tag[data-v-ad5def66]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap}.training-instruction-exam-record__tag.is-pass[data-v-ad5def66]{background:#dcfce7;color:#15803d}.training-instruction-exam-record__tag.is-fail[data-v-ad5def66]{background:#fee2e2;color:#dc2626}.training-instruction-exam-record__tag.is-pending[data-v-ad5def66]{background:#fef9c3;color:#a16207}.training-instruction-exam-record__tag.is-submitted[data-v-ad5def66]{background:#e0f2fe;color:#0369a1}.training-instruction-exam-record__tag.is-default[data-v-ad5def66]{background:#f3f4f6;color:#6b7280}.training-instruction-exam-record__sub-id[data-v-ad5def66]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo,Monaco,Consolas,monospace}.training-instruction-exam-record__empty[data-v-ad5def66]{color:#c0c4cc}.training-instruction-exam-record__action-link[data-v-ad5def66]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;cursor:pointer}.training-instruction-exam-record__action-link[data-v-ad5def66]:hover{background:#ecf5ff}.training-instruction-exam-record .pagination[data-v-ad5def66]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.training-instruction-exam-record__search-grid[data-v-ad5def66]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.training-instruction-exam-record__search-grid[data-v-ad5def66]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/TrainingExaminationInternRecordTable.vue"],"names":[],"mappings":"AACA,yDAAyD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAC7L,AACD,iGAAiG,eAAe,CAC/G,AACD,gEAAgE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CACrc,AACD,kEAAkE,aAAa,CAC9E,AACD,wEAAwE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CACrM,AACD,4IAA4I,eAAe,UAAU,QAAQ,CAC5K,AACD,kEAAkE,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CACxX,AACD,oEAAoE,cAAc,CACjF,AACD,gEAAgE,sBAAsB,CACrF,AACD,gEAAgE,aAAa,8CAAgD,aAAa,CACzI,AACD,mEAAmE,eAAe,eAAe,CAChG,AACD,8DAA8D,mBAAmB,CAChF,AACD,+DAA+D,yBAAyB,kBAAkB,eAAe,CACxH,AACD,sEAAsE,mBAAmB,cAAc,eAAe,eAAe,CACpI,AACD,sEAAsE,eAAe,aAAa,CACjG,AACD,2FAA2F,kBAAkB,CAC5G,AACD,0EAA2E,YAAY,CACtF,AACD,wDAAwD,qBAAqB,iBAAiB,oBAAoB,eAAe,iBAAiB,gBAAgB,kBAAkB,CACnL,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,gEAAgE,mBAAmB,aAAa,CAC/F,AACD,mEAAmE,mBAAmB,aAAa,CAClG,AACD,qEAAqE,mBAAmB,aAAa,CACpG,AACD,mEAAmE,mBAAmB,aAAa,CAClG,AACD,2DAA2D,gBAAgB,cAAc,eAAe,2CAA8C,CACrJ,AACD,0DAA0D,aAAa,CACtE,AACD,gEAAgE,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,cAAc,cAAc,CACnM,AACD,sEAAsE,kBAAkB,CACvF,AACD,+DAA+D,mBAAmB,iBAAiB,CAClG,AACD,0BACA,gEAAgE,6CAA+C,CAC9G,CACA,AACD,yBACA,gEAAgE,yBAAyB,CACxF,CACA","file":"TrainingExaminationInternRecordTable.vue","sourcesContent":["\n.training-instruction-exam-record__card[data-v-ad5def66]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.training-instruction-exam-record__card+.training-instruction-exam-record__card[data-v-ad5def66]{margin-top:16px\n}\n.training-instruction-exam-record__card-header[data-v-ad5def66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.training-instruction-exam-record__card-header i[data-v-ad5def66]{color:#909399\n}\n.training-instruction-exam-record__card-header-actions[data-v-ad5def66]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.training-instruction-exam-record__card-header-actions ::v-deep .training-instruction-exam-record__header-action.el-button[data-v-ad5def66]{min-width:24px;padding:0;margin:0\n}\n.training-instruction-exam-record__header-action[data-v-ad5def66]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.training-instruction-exam-record__header-action i[data-v-ad5def66]{font-size:14px\n}\n.training-instruction-exam-record__search-form[data-v-ad5def66]{padding:16px 24px 20px\n}\n.training-instruction-exam-record__search-grid[data-v-ad5def66]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.training-instruction-exam-record__search-actions[data-v-ad5def66]{margin-top:4px;padding-top:4px\n}\n.training-instruction-exam-record__list-body[data-v-ad5def66]{padding:0 16px 16px\n}\n.training-instruction-exam-record__table-wrap[data-v-ad5def66]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden\n}\n.training-instruction-exam-record__table ::v-deep th[data-v-ad5def66]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.training-instruction-exam-record__table ::v-deep td[data-v-ad5def66]{font-size:14px;color:#303133\n}\n.training-instruction-exam-record__table ::v-deep .el-table__row:hover>td[data-v-ad5def66]{background:#fafafa\n}\n.training-instruction-exam-record__table[data-v-ad5def66] ::v-deep::before{display:none\n}\n.training-instruction-exam-record__tag[data-v-ad5def66]{display:inline-block;padding:2px 10px;border-radius:999px;font-size:12px;line-height:20px;font-weight:500;white-space:nowrap\n}\n.training-instruction-exam-record__tag.is-pass[data-v-ad5def66]{background:#dcfce7;color:#15803d\n}\n.training-instruction-exam-record__tag.is-fail[data-v-ad5def66]{background:#fee2e2;color:#dc2626\n}\n.training-instruction-exam-record__tag.is-pending[data-v-ad5def66]{background:#fef9c3;color:#a16207\n}\n.training-instruction-exam-record__tag.is-submitted[data-v-ad5def66]{background:#e0f2fe;color:#0369a1\n}\n.training-instruction-exam-record__tag.is-default[data-v-ad5def66]{background:#f3f4f6;color:#6b7280\n}\n.training-instruction-exam-record__sub-id[data-v-ad5def66]{margin-left:4px;color:#c0c4cc;font-size:12px;font-family:Menlo, Monaco, Consolas, monospace\n}\n.training-instruction-exam-record__empty[data-v-ad5def66]{color:#c0c4cc\n}\n.training-instruction-exam-record__action-link[data-v-ad5def66]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;color:#409eff;cursor:pointer\n}\n.training-instruction-exam-record__action-link[data-v-ad5def66]:hover{background:#ecf5ff\n}\n.training-instruction-exam-record .pagination[data-v-ad5def66]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.training-instruction-exam-record__search-grid[data-v-ad5def66]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.training-instruction-exam-record__search-grid[data-v-ad5def66]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5652:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5653);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f566cf40", content, true, {});

/***/ }),

/***/ 5653:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-exam-record__search-form .el-form-item{margin-bottom:0}.training-instruction-exam-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/TrainingExaminationInternRecordTable.vue"],"names":[],"mappings":"AACA,6DAA6D,eAAe,CAC3E,AACD,oEAAoE,cAAc,eAAe,gBAAgB,CAChH","file":"TrainingExaminationInternRecordTable.vue","sourcesContent":["\n.training-instruction-exam-record__search-form .el-form-item{margin-bottom:0\n}\n.training-instruction-exam-record__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTrainingExaminationInternRecordTableFields;
function createTrainingExaminationInternRecordTableFields(vm) {
  return [{ key: 'id', prop: 'id', label: '答卷ID' }, { key: 'training_exam_id', prop: 'training_exam_id', label: '考试ID' }, { key: 'admin_id', prop: 'admin_id', label: '实习生ID' }, { key: 'user_name', prop: 'user_name', label: '真实姓名', showOverflowTooltip: true }, { key: 'submitted_at', prop: 'submitted_at', label: '提交时间' }, { key: 'examination_duration_text', prop: 'examination_duration_text', label: '用时' }, { key: 'open_book_exam_text', prop: 'open_book_exam_text', label: '是否开卷' }, {
    key: 'score_text',
    label: '得分',
    prop: 'score_text'
  }, {
    key: 'examination_status',
    prop: 'examination_status',
    label: '状态'
  }];
}

/***/ }),

/***/ 5655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"training-instruction-exam-record"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/instruction' }}},[_vm._v("考试管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("实习生答卷列表")])],1)],1),_vm._v(" "),_c('training-instruction-sub-heading',{attrs:{"title":_vm.pageHeadingTitle,"entity-id":_vm.pageEntityId}}),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card training-instruction-exam-record__card--search"},[_c('div',{staticClass:"training-instruction-exam-record__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"training-instruction-exam-record__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"training-instruction-exam-record__search-grid"},[_c('el-form-item',{attrs:{"label":"实习生","prop":"admin_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请输入账号名搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status_lists: [1, 2]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.admin_id),callback:function ($$v) {_vm.$set(_vm.search, "admin_id", $$v)},expression:"search.admin_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"答卷状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.examStatusOptions),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":Number(it.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提交时间","prop":"submitted_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.submitted_at),callback:function ($$v) {_vm.$set(_vm.search, "submitted_at", $$v)},expression:"search.submitted_at"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("导出\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card"},[_c('div',{staticClass:"training-instruction-exam-record__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("答卷列表")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-exam-record__card-header-actions"},[_c('el-button',{staticClass:"training-instruction-exam-record__header-action",attrs:{"type":"text","icon":"el-icon-setting","title":"列配置"},on:{"click":function($event){$event.stopPropagation();return _vm.openTableColumnConfigDialog($event)}}}),_vm._v(" "),_c('el-button',{staticClass:"training-instruction-exam-record__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"training-instruction-exam-record__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"training-instruction-exam-record__list-body"},[_c('div',{staticClass:"training-instruction-exam-record__table-wrap"},[_c('el-table',{key:_vm.tableColumnRenderKey,staticClass:"training-instruction-exam-record__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_vm._l((_vm.activeTableFields),function(field){return _c('el-table-column',_vm._b({key:field.key},'el-table-column',_vm.getFieldColumnBind(field),false))}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"training-instruction-exam-record__action-link",on:{"click":function($event){_vm.$router.push(_vm.getDetailLink(scope.row))}}},[_vm._v("查看详情")])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])]),_vm._v(" "),_c('table-column-config-dialog',{attrs:{"visible":_vm.tableColumnConfigDialogVisible,"applied-columns":_vm.tableColumnAppliedConfig,"definitions":_vm.fields},on:{"update:visible":function($event){_vm.tableColumnConfigDialogVisible=$event},"save":_vm.onTableColumnConfigSave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5673:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("adabc6c2", content, true, {});

/***/ }),

/***/ 5674:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".exam-title[data-v-21cf826b],.knowledge-name[data-v-21cf826b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d}.knowledge-name__icon[data-v-21cf826b]{margin-right:8px;color:#f5a623;font-size:14px}.exam-paper-count[data-v-21cf826b]{color:#005cff}.exam-tag[data-v-21cf826b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap}.exam-tag--primary[data-v-21cf826b]{color:#409eff;background-color:#ecf5ff}.exam-tag--success[data-v-21cf826b]{color:#00a854;background-color:#d9f7e7}.exam-tag--warning[data-v-21cf826b]{color:#e6a23c;background-color:#fdf6ec}.exam-tag--danger[data-v-21cf826b]{color:#f56c6c;background-color:#fef0f0}.exam-tag--default[data-v-21cf826b],.exam-tag--info[data-v-21cf826b]{color:#1f2d3d;background-color:#f4f5f7}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/TrainingExaminationTable.vue"],"names":[],"mappings":"AAGA,8DAAiC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,aAAa,CAC1M,AACD,uCAAuC,iBAAiB,cAAc,cAAc,CACnF,AACD,mCAAmC,aAAa,CAC/C,AACD,2BAA2B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,eAAe,mBAAmB,8BAA8B,sBAAsB,eAAe,iBAAiB,kBAAkB,CAC7Y,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,mCAAmC,cAAc,wBAAwB,CACxE,AACD,qEAAqE,cAAc,wBAAwB,CAC1G","file":"TrainingExaminationTable.vue","sourcesContent":["\n.exam-title[data-v-21cf826b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name[data-v-21cf826b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name__icon[data-v-21cf826b]{margin-right:8px;color:#f5a623;font-size:14px\n}\n.exam-paper-count[data-v-21cf826b]{color:#005cff\n}\n.exam-tag[data-v-21cf826b]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap\n}\n.exam-tag--primary[data-v-21cf826b]{color:#409EFF;background-color:#ecf5ff\n}\n.exam-tag--success[data-v-21cf826b]{color:#00a854;background-color:#d9f7e7\n}\n.exam-tag--warning[data-v-21cf826b]{color:#e6a23c;background-color:#fdf6ec\n}\n.exam-tag--danger[data-v-21cf826b]{color:#f56c6c;background-color:#fef0f0\n}\n.exam-tag--info[data-v-21cf826b],.exam-tag--default[data-v-21cf826b]{color:#1f2d3d;background-color:#f4f5f7\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"108px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"考试标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入考试标题"},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试类型","prop":"open_book_exam"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"全部"},model:{value:(_vm.search.open_book_exam),callback:function ($$v) {_vm.$set(_vm.search, "open_book_exam", $$v)},expression:"search.open_book_exam"}},_vm._l((_vm.examOptions.openBookMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"全部"},model:{value:(_vm.search.target_usertype),callback:function ($$v) {_vm.$set(_vm.search, "target_usertype", $$v)},expression:"search.target_usertype"}},_vm._l((_vm.examOptions.targetUserMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"全部"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.examOptions.statusMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"全部"},model:{value:(_vm.search.is_common),callback:function ($$v) {_vm.$set(_vm.search, "is_common", $$v)},expression:"search.is_common"}},_vm._l((_vm.examOptions.isCommonMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入知识库名称","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.search.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.search, "training_knowledge_id", $$v)},expression:"search.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户名称","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入创建人","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/training/examination/create"}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("创建考试\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"考试ID","width":"88"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"考试标题","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":{ path: ("/training/examination/update/" + (scope.row.id)), query: { mode: 'view' } }}},[_c('el-link',{attrs:{"type":"primary"}},[_vm._v(_vm._s(scope.row.title || '-'))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"题目数","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.getQuestionCount(scope.row)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"及格分","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.formatPassingScore(scope.row)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"target_usertype","label":"用户类型","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"exam-tag",class:_vm.getTagClass('user', scope.row.target_usertype)},[_vm._v("\n            "+_vm._s(_vm.getTargetUserLabel(scope.row.target_usertype))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_common","label":"是否通用","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"exam-tag",class:_vm.getTagClass('common', scope.row.is_common)},[_vm._v("\n            "+_vm._s(_vm.getIsCommonLabel(scope.row.is_common))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"knowledge_name","label":"所属知识库","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-name"},[_c('i',{staticClass:"el-icon-folder knowledge-name__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(scope.row.knowledge_name))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"所属客户","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.customer_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关联答卷数","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.answers_count > 0)?_c('router-link',{attrs:{"to":_vm.getExamRecordLink(scope.row)}},[_c('span',{staticClass:"exam-paper-count"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(_vm._s(scope.row.answers_count || 0))])]):_c('span',{staticClass:"exam-paper-count"},[_vm._v(_vm._s(scope.row.answers_count || 0))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"创建人","min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.user_name || scope.row.creator_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"exam-tag",class:_vm.getStatusTagClass(scope.row.status)},[_vm._v("\n            "+_vm._s(_vm.getExamStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/training/examination/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""}},[_vm._v("编辑\n            ")])],1),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_NEW)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'online')}}},[_vm._v("上架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_ONLINE)?_c('el-button',{attrs:{"type":"warning","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'offline')}}},[_vm._v("下架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_OFFLINE && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"danger","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'ban')}}},[_vm._v("作废\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_OFFLINE)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'online')}}},[_vm._v("上架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_BANNED && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'active')}}},[_vm._v("激活\n          ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5676:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5677);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("70a87f1b", content, true, {});

/***/ }),

/***/ 5677:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".exam-editor[data-v-5355abe2]{display:grid;grid-template-columns:280px minmax(0,1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start}.exam-sidebar[data-v-5355abe2]{position:-webkit-sticky;position:sticky;top:12px}.exam-side-panel[data-v-5355abe2]{margin-bottom:12px;padding:14px;border:1px solid #ebeef5;border-radius:6px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(31,45,61,.06);box-shadow:0 1px 2px rgba(31,45,61,.06)}.exam-side-panel__header[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:6px;color:#1f2d3d}.exam-side-panel__score[data-v-5355abe2]{color:#2468f2;font-size:12px}.exam-side-panel__sub[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#606266;font-size:12px;line-height:20px}.exam-side-panel__title[data-v-5355abe2]{margin-bottom:12px;color:#1f2d3d;font-weight:600}.question-index-list[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin-top:10px}.question-index-list.is-disabled .question-index-button[data-v-5355abe2]{cursor:default}.question-index-item[data-v-5355abe2]{position:relative}.question-index-button[data-v-5355abe2]{min-width:40px;height:30px;border:1px solid #dcdfe6;border-radius:4px;color:#606266;background:#fff;cursor:pointer}.question-index-remove[data-v-5355abe2]{display:none;position:absolute;top:-6px;right:-6px;width:14px;height:14px;padding:0;border:0;border-radius:50%;color:#fff;background:#f56c6c;font-size:12px;line-height:14px;text-align:center;cursor:pointer}.question-index-item:hover .question-index-remove[data-v-5355abe2]{display:block}.question-index-button.is-active[data-v-5355abe2]{border-color:#2468f2;color:#fff;background:#2468f2}.question-index-empty[data-v-5355abe2]{color:#909399;font-size:12px}.question-add-button[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;width:100%;min-height:34px;border:0;color:#303133;background:transparent;cursor:pointer;text-align:left}.question-add-button[data-v-5355abe2]:hover{color:#2468f2}.exam-side-actions[data-v-5355abe2]{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:12px;border:1px solid #ebeef5;border-radius:6px;background:#fff}.exam-side-actions .el-button[data-v-5355abe2]{width:100%;margin-left:0}.exam-main[data-v-5355abe2]{min-width:0}.exam-panel-title[data-v-5355abe2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.exam-copy-button[data-v-5355abe2]{border:0;color:#1e88e5;background:transparent;cursor:pointer}.exam-form-section[data-v-5355abe2]{max-width:980px}.inline-number-field[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.inline-number-field .el-input-number[data-v-5355abe2]{width:130px}.field-tip[data-v-5355abe2]{color:#8492a6;font-size:12px}.question-empty[data-v-5355abe2]{padding:28px;border:1px dashed #dcdfe6;border-radius:6px;color:#909399;text-align:center}.exam-question-card[data-v-5355abe2]{padding:18px 20px;border:1px solid #dcdfe6;border-radius:6px;background:#f8fbff}.exam-question-card+.exam-question-card[data-v-5355abe2]{margin-top:14px}.exam-question-card.is-active[data-v-5355abe2]{border-color:#2468f2;-webkit-box-shadow:0 0 0 1px #2468f2 inset;box-shadow:inset 0 0 0 1px #2468f2}.exam-question-card__header[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:14px;color:#1f2d3d}.question-bank-toolbar[data-v-5355abe2]{display:grid;grid-template-columns:minmax(180px,1fr) 150px 170px 130px auto auto;gap:8px;padding-bottom:12px;border-bottom:1px solid #ebeef5}.question-bank-list[data-v-5355abe2]{min-height:360px;max-height:520px;overflow:auto;padding:14px 0}.question-bank-item[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:14px;border:1px solid #dcdfe6;border-radius:6px}.question-bank-item+.question-bank-item[data-v-5355abe2]{margin-top:10px}.question-bank-item__body[data-v-5355abe2]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.question-bank-item__meta[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:6px;color:#606266;font-size:12px}.question-bank-item__title[data-v-5355abe2]{margin-bottom:6px;color:#1f2d3d;font-weight:600;line-height:20px}.question-bank-item__option[data-v-5355abe2]{color:#303133;font-size:12px;line-height:20px}.question-bank-empty[data-v-5355abe2]{padding:48px 0;color:#909399;text-align:center}.question-bank-pagination[data-v-5355abe2]{padding-top:12px;border-top:1px solid #ebeef5}.question-bank-footer[data-v-5355abe2],.question-bank-pagination[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.question-tag[data-v-5355abe2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:52px;height:22px;padding:0 8px;border-radius:3px;color:#606266;background:#f4f5f7;-webkit-box-sizing:border-box;box-sizing:border-box}.accuracy-tag[data-v-5355abe2]{padding:2px 6px;border-radius:3px;color:#f56c6c;background:#fef0f0}@media (max-width:1200px){.exam-editor[data-v-5355abe2]{grid-template-columns:1fr}.exam-sidebar[data-v-5355abe2]{position:static}.question-bank-toolbar[data-v-5355abe2]{grid-template-columns:1fr 1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/TrainingExamForm.vue"],"names":[],"mappings":"AACA,8BAA8B,aAAa,0CAA2C,SAAS,wBAAwB,qBAAqB,iBAAiB,CAC5J,AACD,+BAA+B,wBAAwB,gBAAgB,QAAQ,CAC9E,AACD,kCAAkC,mBAAmB,aAAa,yBAAyB,kBAAkB,gBAAgB,gDAAiD,uCAAwC,CACrN,AACD,0CAA0C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,aAAa,CAC5Q,AACD,yCAAyC,cAAc,cAAc,CACpE,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,cAAc,eAAe,gBAAgB,CACvR,AACD,yCAAyC,mBAAmB,cAAc,eAAe,CACxF,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,eAAe,CACnJ,AACD,yEAAyE,cAAc,CACtF,AACD,sCAAsC,iBAAiB,CACtD,AACD,wCAAwC,eAAe,YAAY,yBAAyB,kBAAkB,cAAc,gBAAgB,cAAc,CACzJ,AACD,wCAAwC,aAAa,kBAAkB,SAAS,WAAW,WAAW,YAAY,UAAU,SAAS,kBAAkB,WAAW,mBAAmB,eAAe,iBAAiB,kBAAkB,cAAc,CACpP,AACD,mEAAmE,aAAa,CAC/E,AACD,kDAAkD,qBAAqB,WAAW,kBAAkB,CACnG,AACD,uCAAuC,cAAc,cAAc,CAClE,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,WAAW,gBAAgB,SAAS,cAAc,uBAAuB,eAAe,eAAe,CAC3Q,AACD,4CAA4C,aAAa,CACxD,AACD,oCAAoC,aAAa,8BAA8B,SAAS,aAAa,yBAAyB,kBAAkB,eAAe,CAC9J,AACD,+CAA+C,WAAW,aAAa,CACtE,AACD,4BAA4B,WAAW,CACtC,AACD,mCAAmC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,OAAO,CACrL,AACD,mCAAmC,SAAS,cAAc,uBAAuB,cAAc,CAC9F,AACD,oCAAoC,eAAe,CAClD,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CACnK,AACD,uDAAuD,WAAW,CACjE,AACD,4BAA4B,cAAc,cAAc,CACvD,AACD,iCAAiC,aAAa,0BAA0B,kBAAkB,cAAc,iBAAiB,CACxH,AACD,qCAAqC,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CACnH,AACD,yDAAyD,eAAe,CACvE,AACD,+CAA+C,qBAAqB,2CAA2C,kCAAkC,CAChJ,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,mBAAmB,aAAa,CAChR,AACD,wCAAwC,aAAa,oEAAqE,QAAQ,oBAAoB,+BAA+B,CACpL,AACD,qCAAqC,iBAAiB,iBAAiB,cAAc,cAAc,CAClG,AACD,qCAAqC,oBAAoB,oBAAoB,aAAa,SAAS,aAAa,yBAAyB,iBAAiB,CACzJ,AACD,yDAAyD,eAAe,CACvE,AACD,2CAA2C,mBAAmB,WAAW,OAAO,WAAW,CAC1F,AACD,2CAA2C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,kBAAkB,cAAc,cAAc,CACvN,AACD,4CAA4C,kBAAkB,cAAc,gBAAgB,gBAAgB,CAC3G,AACD,6CAA6C,cAAc,eAAe,gBAAgB,CACzF,AACD,sCAAsC,eAAe,cAAc,iBAAiB,CACnF,AACD,2CAA+O,iBAAiB,4BAA4B,CAC3R,AACD,kFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,6BAA8B,CAG9O,AACD,+BAA+B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,cAAc,kBAAkB,cAAc,mBAAmB,8BAA8B,qBAAqB,CAC7X,AACD,+BAA+B,gBAAgB,kBAAkB,cAAc,kBAAkB,CAChG,AACD,0BACA,8BAA8B,yBAAyB,CACtD,AACD,+BAA+B,eAAe,CAC7C,AACD,wCAAwC,6BAA6B,CACpE,CACA","file":"TrainingExamForm.vue","sourcesContent":["\n.exam-editor[data-v-5355abe2]{display:grid;grid-template-columns:280px minmax(0, 1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start\n}\n.exam-sidebar[data-v-5355abe2]{position:-webkit-sticky;position:sticky;top:12px\n}\n.exam-side-panel[data-v-5355abe2]{margin-bottom:12px;padding:14px;border:1px solid #ebeef5;border-radius:6px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(31,45,61,0.06);box-shadow:0 1px 2px rgba(31,45,61,0.06)\n}\n.exam-side-panel__header[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:6px;color:#1f2d3d\n}\n.exam-side-panel__score[data-v-5355abe2]{color:#2468f2;font-size:12px\n}\n.exam-side-panel__sub[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#606266;font-size:12px;line-height:20px\n}\n.exam-side-panel__title[data-v-5355abe2]{margin-bottom:12px;color:#1f2d3d;font-weight:600\n}\n.question-index-list[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin-top:10px\n}\n.question-index-list.is-disabled .question-index-button[data-v-5355abe2]{cursor:default\n}\n.question-index-item[data-v-5355abe2]{position:relative\n}\n.question-index-button[data-v-5355abe2]{min-width:40px;height:30px;border:1px solid #dcdfe6;border-radius:4px;color:#606266;background:#fff;cursor:pointer\n}\n.question-index-remove[data-v-5355abe2]{display:none;position:absolute;top:-6px;right:-6px;width:14px;height:14px;padding:0;border:0;border-radius:50%;color:#fff;background:#f56c6c;font-size:12px;line-height:14px;text-align:center;cursor:pointer\n}\n.question-index-item:hover .question-index-remove[data-v-5355abe2]{display:block\n}\n.question-index-button.is-active[data-v-5355abe2]{border-color:#2468f2;color:#fff;background:#2468f2\n}\n.question-index-empty[data-v-5355abe2]{color:#909399;font-size:12px\n}\n.question-add-button[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;width:100%;min-height:34px;border:0;color:#303133;background:transparent;cursor:pointer;text-align:left\n}\n.question-add-button[data-v-5355abe2]:hover{color:#2468f2\n}\n.exam-side-actions[data-v-5355abe2]{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:12px;border:1px solid #ebeef5;border-radius:6px;background:#fff\n}\n.exam-side-actions .el-button[data-v-5355abe2]{width:100%;margin-left:0\n}\n.exam-main[data-v-5355abe2]{min-width:0\n}\n.exam-panel-title[data-v-5355abe2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.exam-copy-button[data-v-5355abe2]{border:0;color:#1e88e5;background:transparent;cursor:pointer\n}\n.exam-form-section[data-v-5355abe2]{max-width:980px\n}\n.inline-number-field[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.inline-number-field .el-input-number[data-v-5355abe2]{width:130px\n}\n.field-tip[data-v-5355abe2]{color:#8492a6;font-size:12px\n}\n.question-empty[data-v-5355abe2]{padding:28px;border:1px dashed #dcdfe6;border-radius:6px;color:#909399;text-align:center\n}\n.exam-question-card[data-v-5355abe2]{padding:18px 20px;border:1px solid #dcdfe6;border-radius:6px;background:#f8fbff\n}\n.exam-question-card+.exam-question-card[data-v-5355abe2]{margin-top:14px\n}\n.exam-question-card.is-active[data-v-5355abe2]{border-color:#2468f2;-webkit-box-shadow:0 0 0 1px #2468f2 inset;box-shadow:0 0 0 1px #2468f2 inset\n}\n.exam-question-card__header[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:14px;color:#1f2d3d\n}\n.question-bank-toolbar[data-v-5355abe2]{display:grid;grid-template-columns:minmax(180px, 1fr) 150px 170px 130px auto auto;gap:8px;padding-bottom:12px;border-bottom:1px solid #ebeef5\n}\n.question-bank-list[data-v-5355abe2]{min-height:360px;max-height:520px;overflow:auto;padding:14px 0\n}\n.question-bank-item[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:14px;border:1px solid #dcdfe6;border-radius:6px\n}\n.question-bank-item+.question-bank-item[data-v-5355abe2]{margin-top:10px\n}\n.question-bank-item__body[data-v-5355abe2]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.question-bank-item__meta[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:6px;color:#606266;font-size:12px\n}\n.question-bank-item__title[data-v-5355abe2]{margin-bottom:6px;color:#1f2d3d;font-weight:600;line-height:20px\n}\n.question-bank-item__option[data-v-5355abe2]{color:#303133;font-size:12px;line-height:20px\n}\n.question-bank-empty[data-v-5355abe2]{padding:48px 0;color:#909399;text-align:center\n}\n.question-bank-pagination[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:12px;border-top:1px solid #ebeef5\n}\n.question-bank-footer[data-v-5355abe2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.question-tag[data-v-5355abe2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:52px;height:22px;padding:0 8px;border-radius:3px;color:#606266;background:#f4f5f7;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.accuracy-tag[data-v-5355abe2]{padding:2px 6px;border-radius:3px;color:#f56c6c;background:#fef0f0\n}\n@media (max-width: 1200px){\n.exam-editor[data-v-5355abe2]{grid-template-columns:1fr\n}\n.exam-sidebar[data-v-5355abe2]{position:static\n}\n.question-bank-toolbar[data-v-5355abe2]{grid-template-columns:1fr 1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/examination' }}},[_vm._v("考试管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px","label-position":"left"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"exam-editor"},[_c('aside',{staticClass:"exam-sidebar"},[_c('section',{staticClass:"exam-side-panel"},[_c('div',{staticClass:"exam-side-panel__header"},[_c('strong',[_vm._v("题号目录")]),_vm._v(" "),_c('span',{staticClass:"exam-side-panel__score"},[_vm._v("总分: "+_vm._s(_vm.totalScore)+"分")])]),_vm._v(" "),_c('div',{staticClass:"exam-side-panel__sub"},[_c('span',[_vm._v("及格分数")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.form.passing_score || 0)+"分 ("+_vm._s(_vm.passingRate)+"%)")])]),_vm._v(" "),_c('draggable',{class:['question-index-list', _vm.isStructureLocked ? 'is-disabled' : ''],attrs:{"tag":"div","disabled":_vm.isStructureLocked,"options":{animation: 150}},model:{value:(_vm.draggableQuestionList),callback:function ($$v) {_vm.draggableQuestionList=$$v},expression:"draggableQuestionList"}},[_vm._l((_vm.form.question_list),function(question,index){return _c('div',{key:question.client_id,staticClass:"question-index-item"},[_c('el-tooltip',{attrs:{"content":question.title,"placement":"top"}},[_c('button',{class:['question-index-button', _vm.activeQuestionIndex === index ? 'is-active' : ''],attrs:{"type":"button"},on:{"click":function($event){return _vm.scrollToQuestion(index)}}},[_vm._v("\n                  "+_vm._s(index + 1)+"\n                ")])]),_vm._v(" "),(!_vm.isStructureLocked)?_c('button',{staticClass:"question-index-remove",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeQuestion(index)}}},[_vm._v("\n                ×\n              ")]):_vm._e()],1)}),_vm._v(" "),(!_vm.form.question_list.length)?_c('div',{staticClass:"question-index-empty"},[_vm._v("\n              暂无题目\n            ")]):_vm._e()],2)],1),_vm._v(" "),_c('section',{staticClass:"exam-side-panel"},[_c('div',{staticClass:"exam-side-panel__title"},[_vm._v("添加题型")]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_SINGLE)}}},[_c('i',{staticClass:"el-icon-circle-check"}),_vm._v(" "),_c('span',[_vm._v("单选题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_MULTI)}}},[_c('i',{staticClass:"el-icon-finished"}),_vm._v(" "),_c('span',[_vm._v("多选题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_FILL_BLANK)}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "),_c('span',[_vm._v("填空题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":_vm.openQuestionDialog}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',[_vm._v("从题库选择")])])]),_vm._v(" "),_c('div',{staticClass:"exam-side-actions"},[_c('el-button',{attrs:{"type":"primary","native-type":"submit","disabled":_vm.isReadonly,"loading":_vm.submitting || _vm.uploading}},[_vm._v("\n            保存\n          ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("取消")])],1)]),_vm._v(" "),_c('main',{staticClass:"exam-main"},[_c('layout-panel',[_c('template',{slot:"header"},[_c('span',{staticClass:"exam-panel-title"},[_c('span',[_vm._v("考试信息")]),_vm._v(" "),(_vm.allowCopyExam)?_c('el-tooltip',{attrs:{"content":"复制考试","placement":"top"}},[_c('button',{ref:"copyExam",staticClass:"sj-icon-copy exam-copy-button",attrs:{"type":"button"}})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"exam-form-section"},[_c('el-form-item',{attrs:{"label":"考试标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.isReadonly,"maxlength":"100","placeholder":"请输入考试标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isScopeLocked},on:{"change":_vm.onIsCommonChanged},model:{value:(_vm.form.is_common),callback:function ($$v) {_vm.$set(_vm.form, "is_common", $$v)},expression:"form.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),(Number(_vm.form.is_common) === _vm.consts.IS_COMMON_DEDICATED)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","disabled":_vm.isScopeLocked,"placeholder":"请选择客户","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择知识库","disabled":_vm.knowledgeDisabled,"query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge,"query-params":_vm.knowledgeQueryParams},model:{value:(_vm.form.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.form, "training_knowledge_id", $$v)},expression:"form.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否开卷","prop":"open_book_exam"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},on:{"input":_vm.onOpenBookExamChanged},model:{value:(_vm.form.open_book_exam),callback:function ($$v) {_vm.$set(_vm.form, "open_book_exam", $$v)},expression:"form.open_book_exam"}},_vm._l((_vm.opts.openBookMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),(_vm.form.open_book_exam===_vm.consts.OPEN_BOOK_EXAM_CLOSED)?_c('el-form-item',{attrs:{"label":"单题分值","prop":"question_score","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":1,"precision":0,"disabled":_vm.isQuestionScoreLocked,"controls":false},on:{"change":_vm.validatePassingScore},model:{value:(_vm.form.question_score),callback:function ($$v) {_vm.$set(_vm.form, "question_score", $$v)},expression:"form.question_score"}}),_vm._v(" "),_c('span',[_vm._v("分/题")]),_vm._v(" "),_c('span',{staticClass:"field-tip"},[_vm._v("("+_vm._s(_vm.questionCount)+"题 × "+_vm._s(_vm.form.question_score || 0)+"分 = "+_vm._s(_vm.totalScore)+"分)")])],1)]):_vm._e(),_vm._v(" "),(_vm.form.open_book_exam===_vm.consts.OPEN_BOOK_EXAM_CLOSED)?_c('el-form-item',{attrs:{"label":"及格分数","prop":"passing_score","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":0,"precision":0,"disabled":_vm.isReadonly,"controls":false},model:{value:(_vm.form.passing_score),callback:function ($$v) {_vm.$set(_vm.form, "passing_score", $$v)},expression:"form.passing_score"}}),_vm._v(" "),_c('span',[_vm._v("分")]),_vm._v(" "),_c('span',{staticClass:"field-tip"},[_vm._v("总分: "+_vm._s(_vm.totalScore)+"分")])],1)]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试时效","prop":"exam_duration","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":1,"precision":0,"disabled":_vm.isReadonly,"controls":false},model:{value:(_vm.form.exam_duration),callback:function ($$v) {_vm.$set(_vm.form, "exam_duration", $$v)},expression:"form.exam_duration"}}),_vm._v(" "),_c('span',[_vm._v("分钟")])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目顺序","prop":"question_sort_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},model:{value:(_vm.form.question_sort_type),callback:function ($$v) {_vm.$set(_vm.form, "question_sort_type", $$v)},expression:"form.question_sort_type"}},_vm._l((_vm.opts.sortTypeMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"选项顺序","prop":"question_options_sort_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},model:{value:(_vm.form.question_options_sort_type),callback:function ($$v) {_vm.$set(_vm.form, "question_options_sort_type", $$v)},expression:"form.question_options_sort_type"}},_vm._l((_vm.opts.sortTypeMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("题目列表 ("+_vm._s(_vm.questionCount)+"题)")]),_vm._v(" "),(!_vm.form.question_list.length)?_c('div',{staticClass:"question-empty"},[_vm._v("\n            请从左侧添加题目\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.form.question_list),function(question,index){return _c('div',{key:question.client_id,ref:("questionCard_" + index),refInFor:true,class:['exam-question-card', _vm.activeQuestionIndex === index ? 'is-active' : ''],on:{"click":function($event){_vm.activeQuestionIndex = index}}},[_c('div',{staticClass:"exam-question-card__header"},[_c('strong',[_vm._v(_vm._s(index + 1)+". "+_vm._s(_vm.getQuestionTypeLabel(question.question_type)))]),_vm._v(" "),(!_vm.isStructureLocked)?_c('el-button',{attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){$event.stopPropagation();return _vm.removeQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('question-form',{attrs:{"form":question,"question-type":question.question_type,"prop-prefix":("question_list." + index),"is-view-mode":_vm.isReadonly,"is-answer-locked":_vm.isAnswerLocked,"is-option-structure-locked":_vm.isOptionStructureLocked},on:{"validate-field":_vm.validateField,"uploading-change":function($event){_vm.uploading = $event}}})],1)})],2)],1)])]),_vm._v(" "),_c('el-dialog',{staticClass:"question-bank-dialog",attrs:{"title":"从题库选择题目","width":"72%","visible":_vm.questionDialogVisible},on:{"update:visible":function($event){_vm.questionDialogVisible=$event},"open":_vm.onQuestionDialogOpen}},[_c('div',{staticClass:"question-bank-toolbar"},[_c('el-input',{attrs:{"clearable":"","prefix-icon":"el-icon-search","placeholder":"搜索题目"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchQuestionBank($event)}},model:{value:(_vm.questionSearch.title),callback:function ($$v) {_vm.$set(_vm.questionSearch, "title", $$v)},expression:"questionSearch.title"}}),_vm._v(" "),_c('remote-select',{attrs:{"clearable":"","placeholder":"所有客户","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.questionSearch.customerid),callback:function ($$v) {_vm.$set(_vm.questionSearch, "customerid", $$v)},expression:"questionSearch.customerid"}}),_vm._v(" "),_c('remote-select',{attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"所有知识库","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.questionSearch.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.questionSearch, "training_knowledge_id", $$v)},expression:"questionSearch.training_knowledge_id"}}),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","placeholder":"所有类型"},model:{value:(_vm.questionSearch.question_type),callback:function ($$v) {_vm.$set(_vm.questionSearch, "question_type", $$v)},expression:"questionSearch.question_type"}},_vm._l((_vm.questionOpts.questionTypeMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.searchQuestionBank}},[_vm._v("搜索\n      ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.resetQuestionSearch}},[_vm._v("重置")])],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.questionDialogLoading),expression:"questionDialogLoading"}],staticClass:"question-bank-list"},[_vm._l((_vm.questionBankList),function(row){return _c('div',{key:row.id,staticClass:"question-bank-item"},[_c('el-checkbox',{attrs:{"value":_vm.isBankQuestionSelected(row)},on:{"change":function (checked) { return _vm.toggleBankQuestion(row, checked); }}}),_vm._v(" "),_c('div',{staticClass:"question-bank-item__body"},[_c('div',{staticClass:"question-bank-item__meta"},[_c('span',{staticClass:"question-tag"},[_vm._v(_vm._s(_vm.getQuestionTypeLabel(_vm.getRowQuestionType(row))))]),_vm._v(" "),_c('span',[_vm._v("Q"+_vm._s(row.id))]),_vm._v(" "),(_vm.formatAccuracy(row))?_c('span',{staticClass:"accuracy-tag"},[_vm._v("正确率: "+_vm._s(_vm.formatAccuracy(row)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"question-bank-item__title"},[_vm._v(_vm._s(_vm.getRowQuestionTitle(row)))]),_vm._v(" "),_vm._l((_vm.getRowQuestionOptions(row)),function(option,index){return _c('div',{key:option.uuid || index,staticClass:"question-bank-item__option"},[_vm._v("\n            "+_vm._s(_vm.getOptionLetter(index))+". "+_vm._s(option.title)+"\n          ")])})],2)],1)}),_vm._v(" "),(!_vm.questionBankList.length && !_vm.questionDialogLoading)?_c('div',{staticClass:"question-bank-empty"},[_vm._v("\n        暂无题目\n      ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"question-bank-pagination"},[_c('span',[_vm._v("共 "+_vm._s(_vm.questionPagination.total)+" 条")]),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, jumper","current-page":_vm.questionPagination.current_page,"page-size":_vm.questionPagination.per_page,"total":_vm.questionPagination.total},on:{"current-change":_vm.handleQuestionPageChange}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"question-bank-footer"},[_c('span',[_vm._v("已选 "+_vm._s(_vm.selectedQuestionRows.length)+" 题")]),_vm._v(" "),_c('div',[_c('el-button',{on:{"click":function($event){_vm.questionDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.selectedQuestionRows.length},on:{"click":_vm.addSelectedQuestions}},[_vm._v("\n            添加至考试\n          ")])],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5679:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2ec37707", content, true, {});

/***/ }),

/***/ 5680:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".exam-title[data-v-ed5ccfb2],.knowledge-name[data-v-ed5ccfb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d}.knowledge-name__icon[data-v-ed5ccfb2]{margin-right:8px;color:#f5a623;font-size:14px}.exam-paper-count[data-v-ed5ccfb2]{color:#005cff}.exam-tag[data-v-ed5ccfb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap}.exam-tag--primary[data-v-ed5ccfb2]{color:#409eff;background-color:#ecf5ff}.exam-tag--success[data-v-ed5ccfb2]{color:#00a854;background-color:#d9f7e7}.exam-tag--warning[data-v-ed5ccfb2]{color:#e6a23c;background-color:#fdf6ec}.exam-tag--danger[data-v-ed5ccfb2]{color:#f56c6c;background-color:#fef0f0}.exam-tag--default[data-v-ed5ccfb2],.exam-tag--info[data-v-ed5ccfb2]{color:#1f2d3d;background-color:#f4f5f7}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/InternTrainingExaminationTable.vue"],"names":[],"mappings":"AAGA,8DAAiC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,aAAa,CAC1M,AACD,uCAAuC,iBAAiB,cAAc,cAAc,CACnF,AACD,mCAAmC,aAAa,CAC/C,AACD,2BAA2B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,eAAe,mBAAmB,8BAA8B,sBAAsB,eAAe,iBAAiB,kBAAkB,CAC7Y,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,oCAAoC,cAAc,wBAAwB,CACzE,AACD,mCAAmC,cAAc,wBAAwB,CACxE,AACD,qEAAqE,cAAc,wBAAwB,CAC1G","file":"InternTrainingExaminationTable.vue","sourcesContent":["\n.exam-title[data-v-ed5ccfb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name[data-v-ed5ccfb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name__icon[data-v-ed5ccfb2]{margin-right:8px;color:#f5a623;font-size:14px\n}\n.exam-paper-count[data-v-ed5ccfb2]{color:#005cff\n}\n.exam-tag[data-v-ed5ccfb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap\n}\n.exam-tag--primary[data-v-ed5ccfb2]{color:#409EFF;background-color:#ecf5ff\n}\n.exam-tag--success[data-v-ed5ccfb2]{color:#00a854;background-color:#d9f7e7\n}\n.exam-tag--warning[data-v-ed5ccfb2]{color:#e6a23c;background-color:#fdf6ec\n}\n.exam-tag--danger[data-v-ed5ccfb2]{color:#f56c6c;background-color:#fef0f0\n}\n.exam-tag--info[data-v-ed5ccfb2],.exam-tag--default[data-v-ed5ccfb2]{color:#1f2d3d;background-color:#f4f5f7\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"108px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"考试标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入考试标题"},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试类型","prop":"open_book_exam"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"全部"},model:{value:(_vm.search.open_book_exam),callback:function ($$v) {_vm.$set(_vm.search, "open_book_exam", $$v)},expression:"search.open_book_exam"}},_vm._l((_vm.examOptions.openBookMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"全部"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.examOptions.statusMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"全部"},model:{value:(_vm.search.is_common),callback:function ($$v) {_vm.$set(_vm.search, "is_common", $$v)},expression:"search.is_common"}},_vm._l((_vm.examOptions.isCommonMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入知识库名称","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.search.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.search, "training_knowledge_id", $$v)},expression:"search.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户名称","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入创建人","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/training/intern-examination/create"}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("创建考试\n      ")])],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.openInternAssignmentDialog}},[_vm._v("批量分配实习生\n    ")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"考试ID","width":"88"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"考试标题","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":{ path: ("/training/intern-examination/update/" + (scope.row.id)), query: { mode: 'view' } }}},[_c('el-link',{attrs:{"type":"primary"}},[_vm._v(_vm._s(scope.row.title || '-'))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_common","label":"使用范围","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-tag",class:_vm.getTagClass('common', scope.row.intern_scope)},[_vm._v("\n            "+_vm._s(_vm.getInternScopeLabel(scope.row.intern_scope))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"题目数","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.getQuestionCount(scope.row)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"及格分","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.formatPassingScore(scope.row)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_common","label":"是否通用","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"exam-tag",class:_vm.getTagClass('common', scope.row.is_common)},[_vm._v("\n            "+_vm._s(_vm.getIsCommonLabel(scope.row.is_common))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"knowledge_name","label":"所属知识库","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-name"},[_c('i',{staticClass:"el-icon-folder knowledge-name__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(scope.row.knowledge_name))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"所属客户","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.customer_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关联答卷数","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.answers_count > 0)?_c('router-link',{attrs:{"to":_vm.getExamRecordLink(scope.row)}},[_c('span',{staticClass:"exam-paper-count"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(_vm._s(scope.row.answers_count || 0))])]):_c('span',{staticClass:"exam-paper-count"},[_vm._v(_vm._s(scope.row.answers_count || 0))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"创建人","min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.user_name || scope.row.creator_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"exam-tag",class:_vm.getStatusTagClass(scope.row.status)},[_vm._v("\n            "+_vm._s(_vm.getExamStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/training/intern-examination/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""}},[_vm._v("编辑\n            ")])],1),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_NEW)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'online')}}},[_vm._v("上架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_ONLINE)?_c('el-button',{attrs:{"type":"warning","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'offline')}}},[_vm._v("下架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_OFFLINE && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"danger","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'ban')}}},[_vm._v("作废\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_OFFLINE)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'online')}}},[_vm._v("上架\n          ")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_BANNED && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":function($event){return _vm.handleExamAction(scope.row, 'active')}}},[_vm._v("激活\n          ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量分配实习生考试","visible":_vm.internAssignmentDialogVisible,"close-on-click-modal":!_vm.internAssignmentUploading,"close-on-press-escape":!_vm.internAssignmentUploading},on:{"update:visible":function($event){_vm.internAssignmentDialogVisible=$event},"close":_vm.resetInternAssignmentDialog}},[_c('el-form',{attrs:{"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"分配范围"}},[_c('el-radio-group',{attrs:{"disabled":_vm.internAssignmentUploading},model:{value:(_vm.internAssignmentMode),callback:function ($$v) {_vm.internAssignmentMode=$$v},expression:"internAssignmentMode"}},[_c('el-radio',{attrs:{"label":"all"}},[_vm._v("所有实习生")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"replace"}},[_vm._v("覆盖上传实习生")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"append"}},[_vm._v("追加上传实习生")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试文件"}},[_c('el-upload',{ref:"internAssignmentUpload",attrs:{"action":"","auto-upload":false,"limit":1,"accept":".xlsx","disabled":_vm.internAssignmentUploading,"on-change":_vm.handleInternAssignmentFileChange,"before-upload":_vm.beforeInternAssignmentUpload}},[_c('el-button',{attrs:{"size":"small","disabled":_vm.internAssignmentUploading}},[_vm._v("选择 Excel 文件\n          ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("仅支持 .xlsx，所有实习生模式实习生账号ID必须留空；覆盖或追加模式实习生账号ID必须填写。\n          ")])],1)],1),_vm._v(" "),_c('el-form-item',[_c('span',[_vm._v(_vm._s(_vm.internAssignmentModeHint))])]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"text","disabled":_vm.internAssignmentUploading},on:{"click":_vm.downloadInternAssignmentTemplate}},[_vm._v("下载模板\n        ")])],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"disabled":_vm.internAssignmentUploading},on:{"click":function($event){_vm.internAssignmentDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.internAssignmentUploading},on:{"click":_vm.submitInternAssignment}},[_vm._v("开始分配")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5682:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("14ce4186", content, true, {});

/***/ }),

/***/ 5683:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".exam-editor[data-v-1ebd560c]{display:grid;grid-template-columns:280px minmax(0,1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start}.exam-sidebar[data-v-1ebd560c]{position:-webkit-sticky;position:sticky;top:12px}.exam-side-panel[data-v-1ebd560c]{margin-bottom:12px;padding:14px;border:1px solid #ebeef5;border-radius:6px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(31,45,61,.06);box-shadow:0 1px 2px rgba(31,45,61,.06)}.exam-side-panel__header[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:6px;color:#1f2d3d}.exam-side-panel__score[data-v-1ebd560c]{color:#2468f2;font-size:12px}.exam-side-panel__sub[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#606266;font-size:12px;line-height:20px}.exam-side-panel__title[data-v-1ebd560c]{margin-bottom:12px;color:#1f2d3d;font-weight:600}.question-index-list[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin-top:10px}.question-index-list.is-disabled .question-index-button[data-v-1ebd560c]{cursor:default}.question-index-item[data-v-1ebd560c]{position:relative}.question-index-button[data-v-1ebd560c]{min-width:40px;height:30px;border:1px solid #dcdfe6;border-radius:4px;color:#606266;background:#fff;cursor:pointer}.question-index-remove[data-v-1ebd560c]{display:none;position:absolute;top:-6px;right:-6px;width:14px;height:14px;padding:0;border:0;border-radius:50%;color:#fff;background:#f56c6c;font-size:12px;line-height:14px;text-align:center;cursor:pointer}.question-index-item:hover .question-index-remove[data-v-1ebd560c]{display:block}.question-index-button.is-active[data-v-1ebd560c]{border-color:#2468f2;color:#fff;background:#2468f2}.question-index-empty[data-v-1ebd560c]{color:#909399;font-size:12px}.question-add-button[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;width:100%;min-height:34px;border:0;color:#303133;background:transparent;cursor:pointer;text-align:left}.question-add-button[data-v-1ebd560c]:hover{color:#2468f2}.exam-side-actions[data-v-1ebd560c]{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:12px;border:1px solid #ebeef5;border-radius:6px;background:#fff}.exam-side-actions .el-button[data-v-1ebd560c]{width:100%;margin-left:0}.exam-main[data-v-1ebd560c]{min-width:0}.exam-panel-title[data-v-1ebd560c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.exam-copy-button[data-v-1ebd560c]{border:0;color:#1e88e5;background:transparent;cursor:pointer}.exam-form-section[data-v-1ebd560c]{max-width:980px}.inline-number-field[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.inline-number-field .el-input-number[data-v-1ebd560c]{width:130px}.field-tip[data-v-1ebd560c]{color:#8492a6;font-size:12px}.question-empty[data-v-1ebd560c]{padding:28px;border:1px dashed #dcdfe6;border-radius:6px;color:#909399;text-align:center}.exam-question-card[data-v-1ebd560c]{padding:18px 20px;border:1px solid #dcdfe6;border-radius:6px;background:#f8fbff}.exam-question-card+.exam-question-card[data-v-1ebd560c]{margin-top:14px}.exam-question-card.is-active[data-v-1ebd560c]{border-color:#2468f2;-webkit-box-shadow:0 0 0 1px #2468f2 inset;box-shadow:inset 0 0 0 1px #2468f2}.exam-question-card__header[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:14px;color:#1f2d3d}.question-bank-toolbar[data-v-1ebd560c]{display:grid;grid-template-columns:minmax(180px,1fr) 150px 170px 130px auto auto;gap:8px;padding-bottom:12px;border-bottom:1px solid #ebeef5}.question-bank-list[data-v-1ebd560c]{min-height:360px;max-height:520px;overflow:auto;padding:14px 0}.question-bank-item[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:14px;border:1px solid #dcdfe6;border-radius:6px}.question-bank-item+.question-bank-item[data-v-1ebd560c]{margin-top:10px}.question-bank-item__body[data-v-1ebd560c]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.question-bank-item__meta[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:6px;color:#606266;font-size:12px}.question-bank-item__title[data-v-1ebd560c]{margin-bottom:6px;color:#1f2d3d;font-weight:600;line-height:20px}.question-bank-item__option[data-v-1ebd560c]{color:#303133;font-size:12px;line-height:20px}.question-bank-empty[data-v-1ebd560c]{padding:48px 0;color:#909399;text-align:center}.question-bank-pagination[data-v-1ebd560c]{padding-top:12px;border-top:1px solid #ebeef5}.question-bank-footer[data-v-1ebd560c],.question-bank-pagination[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.question-tag[data-v-1ebd560c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:52px;height:22px;padding:0 8px;border-radius:3px;color:#606266;background:#f4f5f7;-webkit-box-sizing:border-box;box-sizing:border-box}.accuracy-tag[data-v-1ebd560c]{padding:2px 6px;border-radius:3px;color:#f56c6c;background:#fef0f0}@media (max-width:1200px){.exam-editor[data-v-1ebd560c]{grid-template-columns:1fr}.exam-sidebar[data-v-1ebd560c]{position:static}.question-bank-toolbar[data-v-1ebd560c]{grid-template-columns:1fr 1fr}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/InternTrainingExamForm.vue"],"names":[],"mappings":"AACA,8BAA8B,aAAa,0CAA2C,SAAS,wBAAwB,qBAAqB,iBAAiB,CAC5J,AACD,+BAA+B,wBAAwB,gBAAgB,QAAQ,CAC9E,AACD,kCAAkC,mBAAmB,aAAa,yBAAyB,kBAAkB,gBAAgB,gDAAiD,uCAAwC,CACrN,AACD,0CAA0C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,aAAa,CAC5Q,AACD,yCAAyC,cAAc,cAAc,CACpE,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,cAAc,eAAe,gBAAgB,CACvR,AACD,yCAAyC,mBAAmB,cAAc,eAAe,CACxF,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,eAAe,CACnJ,AACD,yEAAyE,cAAc,CACtF,AACD,sCAAsC,iBAAiB,CACtD,AACD,wCAAwC,eAAe,YAAY,yBAAyB,kBAAkB,cAAc,gBAAgB,cAAc,CACzJ,AACD,wCAAwC,aAAa,kBAAkB,SAAS,WAAW,WAAW,YAAY,UAAU,SAAS,kBAAkB,WAAW,mBAAmB,eAAe,iBAAiB,kBAAkB,cAAc,CACpP,AACD,mEAAmE,aAAa,CAC/E,AACD,kDAAkD,qBAAqB,WAAW,kBAAkB,CACnG,AACD,uCAAuC,cAAc,cAAc,CAClE,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,WAAW,gBAAgB,SAAS,cAAc,uBAAuB,eAAe,eAAe,CAC3Q,AACD,4CAA4C,aAAa,CACxD,AACD,oCAAoC,aAAa,8BAA8B,SAAS,aAAa,yBAAyB,kBAAkB,eAAe,CAC9J,AACD,+CAA+C,WAAW,aAAa,CACtE,AACD,4BAA4B,WAAW,CACtC,AACD,mCAAmC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,OAAO,CACrL,AACD,mCAAmC,SAAS,cAAc,uBAAuB,cAAc,CAC9F,AACD,oCAAoC,eAAe,CAClD,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CACnK,AACD,uDAAuD,WAAW,CACjE,AACD,4BAA4B,cAAc,cAAc,CACvD,AACD,iCAAiC,aAAa,0BAA0B,kBAAkB,cAAc,iBAAiB,CACxH,AACD,qCAAqC,kBAAkB,yBAAyB,kBAAkB,kBAAkB,CACnH,AACD,yDAAyD,eAAe,CACvE,AACD,+CAA+C,qBAAqB,2CAA2C,kCAAkC,CAChJ,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,mBAAmB,aAAa,CAChR,AACD,wCAAwC,aAAa,oEAAqE,QAAQ,oBAAoB,+BAA+B,CACpL,AACD,qCAAqC,iBAAiB,iBAAiB,cAAc,cAAc,CAClG,AACD,qCAAqC,oBAAoB,oBAAoB,aAAa,SAAS,aAAa,yBAAyB,iBAAiB,CACzJ,AACD,yDAAyD,eAAe,CACvE,AACD,2CAA2C,mBAAmB,WAAW,OAAO,WAAW,CAC1F,AACD,2CAA2C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,kBAAkB,cAAc,cAAc,CACvN,AACD,4CAA4C,kBAAkB,cAAc,gBAAgB,gBAAgB,CAC3G,AACD,6CAA6C,cAAc,eAAe,gBAAgB,CACzF,AACD,sCAAsC,eAAe,cAAc,iBAAiB,CACnF,AACD,2CAA+O,iBAAiB,4BAA4B,CAC3R,AACD,kFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,6BAA8B,CAG9O,AACD,+BAA+B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,cAAc,kBAAkB,cAAc,mBAAmB,8BAA8B,qBAAqB,CAC7X,AACD,+BAA+B,gBAAgB,kBAAkB,cAAc,kBAAkB,CAChG,AACD,0BACA,8BAA8B,yBAAyB,CACtD,AACD,+BAA+B,eAAe,CAC7C,AACD,wCAAwC,6BAA6B,CACpE,CACA","file":"InternTrainingExamForm.vue","sourcesContent":["\n.exam-editor[data-v-1ebd560c]{display:grid;grid-template-columns:280px minmax(0, 1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start\n}\n.exam-sidebar[data-v-1ebd560c]{position:-webkit-sticky;position:sticky;top:12px\n}\n.exam-side-panel[data-v-1ebd560c]{margin-bottom:12px;padding:14px;border:1px solid #ebeef5;border-radius:6px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(31,45,61,0.06);box-shadow:0 1px 2px rgba(31,45,61,0.06)\n}\n.exam-side-panel__header[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:6px;color:#1f2d3d\n}\n.exam-side-panel__score[data-v-1ebd560c]{color:#2468f2;font-size:12px\n}\n.exam-side-panel__sub[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#606266;font-size:12px;line-height:20px\n}\n.exam-side-panel__title[data-v-1ebd560c]{margin-bottom:12px;color:#1f2d3d;font-weight:600\n}\n.question-index-list[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;margin-top:10px\n}\n.question-index-list.is-disabled .question-index-button[data-v-1ebd560c]{cursor:default\n}\n.question-index-item[data-v-1ebd560c]{position:relative\n}\n.question-index-button[data-v-1ebd560c]{min-width:40px;height:30px;border:1px solid #dcdfe6;border-radius:4px;color:#606266;background:#fff;cursor:pointer\n}\n.question-index-remove[data-v-1ebd560c]{display:none;position:absolute;top:-6px;right:-6px;width:14px;height:14px;padding:0;border:0;border-radius:50%;color:#fff;background:#f56c6c;font-size:12px;line-height:14px;text-align:center;cursor:pointer\n}\n.question-index-item:hover .question-index-remove[data-v-1ebd560c]{display:block\n}\n.question-index-button.is-active[data-v-1ebd560c]{border-color:#2468f2;color:#fff;background:#2468f2\n}\n.question-index-empty[data-v-1ebd560c]{color:#909399;font-size:12px\n}\n.question-add-button[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;width:100%;min-height:34px;border:0;color:#303133;background:transparent;cursor:pointer;text-align:left\n}\n.question-add-button[data-v-1ebd560c]:hover{color:#2468f2\n}\n.exam-side-actions[data-v-1ebd560c]{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:12px;border:1px solid #ebeef5;border-radius:6px;background:#fff\n}\n.exam-side-actions .el-button[data-v-1ebd560c]{width:100%;margin-left:0\n}\n.exam-main[data-v-1ebd560c]{min-width:0\n}\n.exam-panel-title[data-v-1ebd560c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.exam-copy-button[data-v-1ebd560c]{border:0;color:#1e88e5;background:transparent;cursor:pointer\n}\n.exam-form-section[data-v-1ebd560c]{max-width:980px\n}\n.inline-number-field[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.inline-number-field .el-input-number[data-v-1ebd560c]{width:130px\n}\n.field-tip[data-v-1ebd560c]{color:#8492a6;font-size:12px\n}\n.question-empty[data-v-1ebd560c]{padding:28px;border:1px dashed #dcdfe6;border-radius:6px;color:#909399;text-align:center\n}\n.exam-question-card[data-v-1ebd560c]{padding:18px 20px;border:1px solid #dcdfe6;border-radius:6px;background:#f8fbff\n}\n.exam-question-card+.exam-question-card[data-v-1ebd560c]{margin-top:14px\n}\n.exam-question-card.is-active[data-v-1ebd560c]{border-color:#2468f2;-webkit-box-shadow:0 0 0 1px #2468f2 inset;box-shadow:0 0 0 1px #2468f2 inset\n}\n.exam-question-card__header[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:14px;color:#1f2d3d\n}\n.question-bank-toolbar[data-v-1ebd560c]{display:grid;grid-template-columns:minmax(180px, 1fr) 150px 170px 130px auto auto;gap:8px;padding-bottom:12px;border-bottom:1px solid #ebeef5\n}\n.question-bank-list[data-v-1ebd560c]{min-height:360px;max-height:520px;overflow:auto;padding:14px 0\n}\n.question-bank-item[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:14px;border:1px solid #dcdfe6;border-radius:6px\n}\n.question-bank-item+.question-bank-item[data-v-1ebd560c]{margin-top:10px\n}\n.question-bank-item__body[data-v-1ebd560c]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.question-bank-item__meta[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:6px;color:#606266;font-size:12px\n}\n.question-bank-item__title[data-v-1ebd560c]{margin-bottom:6px;color:#1f2d3d;font-weight:600;line-height:20px\n}\n.question-bank-item__option[data-v-1ebd560c]{color:#303133;font-size:12px;line-height:20px\n}\n.question-bank-empty[data-v-1ebd560c]{padding:48px 0;color:#909399;text-align:center\n}\n.question-bank-pagination[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:12px;border-top:1px solid #ebeef5\n}\n.question-bank-footer[data-v-1ebd560c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.question-tag[data-v-1ebd560c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:52px;height:22px;padding:0 8px;border-radius:3px;color:#606266;background:#f4f5f7;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.accuracy-tag[data-v-1ebd560c]{padding:2px 6px;border-radius:3px;color:#f56c6c;background:#fef0f0\n}\n@media (max-width: 1200px){\n.exam-editor[data-v-1ebd560c]{grid-template-columns:1fr\n}\n.exam-sidebar[data-v-1ebd560c]{position:static\n}\n.question-bank-toolbar[data-v-1ebd560c]{grid-template-columns:1fr 1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/intern-examination' }}},[_vm._v("实习生考试管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px","label-position":"left"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"exam-editor"},[_c('aside',{staticClass:"exam-sidebar"},[_c('section',{staticClass:"exam-side-panel"},[_c('div',{staticClass:"exam-side-panel__header"},[_c('strong',[_vm._v("题号目录")]),_vm._v(" "),_c('span',{staticClass:"exam-side-panel__score"},[_vm._v("总分: "+_vm._s(_vm.totalScore)+"分")])]),_vm._v(" "),_c('div',{staticClass:"exam-side-panel__sub"},[_c('span',[_vm._v("及格分数")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.form.passing_score || 0)+"分 ("+_vm._s(_vm.passingRate)+"%)")])]),_vm._v(" "),_c('draggable',{class:['question-index-list', _vm.isStructureLocked ? 'is-disabled' : ''],attrs:{"tag":"div","disabled":_vm.isStructureLocked,"options":{animation: 150}},model:{value:(_vm.draggableQuestionList),callback:function ($$v) {_vm.draggableQuestionList=$$v},expression:"draggableQuestionList"}},[_vm._l((_vm.form.question_list),function(question,index){return _c('div',{key:question.client_id,staticClass:"question-index-item"},[_c('el-tooltip',{attrs:{"content":question.title,"placement":"top"}},[_c('button',{class:['question-index-button', _vm.activeQuestionIndex === index ? 'is-active' : ''],attrs:{"type":"button"},on:{"click":function($event){return _vm.scrollToQuestion(index)}}},[_vm._v("\n                  "+_vm._s(index + 1)+"\n                ")])]),_vm._v(" "),(!_vm.isStructureLocked)?_c('button',{staticClass:"question-index-remove",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeQuestion(index)}}},[_vm._v("\n                ×\n              ")]):_vm._e()],1)}),_vm._v(" "),(!_vm.form.question_list.length)?_c('div',{staticClass:"question-index-empty"},[_vm._v("\n              暂无题目\n            ")]):_vm._e()],2)],1),_vm._v(" "),_c('section',{staticClass:"exam-side-panel"},[_c('div',{staticClass:"exam-side-panel__title"},[_vm._v("添加题型")]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_SINGLE)}}},[_c('i',{staticClass:"el-icon-circle-check"}),_vm._v(" "),_c('span',[_vm._v("单选题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_MULTI)}}},[_c('i',{staticClass:"el-icon-finished"}),_vm._v(" "),_c('span',[_vm._v("多选题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":function($event){return _vm.addQuestion(_vm.questionConsts.QUESTION_TYPE_FILL_BLANK)}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "),_c('span',[_vm._v("填空题")])]),_vm._v(" "),_c('button',{staticClass:"question-add-button",attrs:{"type":"button","disabled":_vm.isStructureLocked},on:{"click":_vm.openQuestionDialog}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',[_vm._v("从题库选择")])])]),_vm._v(" "),_c('div',{staticClass:"exam-side-actions"},[_c('el-button',{attrs:{"type":"primary","native-type":"submit","disabled":_vm.isReadonly,"loading":_vm.submitting || _vm.uploading}},[_vm._v("\n            保存\n          ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("取消")])],1)]),_vm._v(" "),_c('main',{staticClass:"exam-main"},[_c('layout-panel',[_c('template',{slot:"header"},[_c('span',{staticClass:"exam-panel-title"},[_c('span',[_vm._v("考试信息")]),_vm._v(" "),(_vm.allowCopyExam)?_c('el-tooltip',{attrs:{"content":"复制考试","placement":"top"}},[_c('button',{ref:"copyExam",staticClass:"sj-icon-copy exam-copy-button",attrs:{"type":"button"}})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"exam-form-section"},[_c('el-form-item',{attrs:{"label":"考试标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.isReadonly,"maxlength":"100","placeholder":"请输入考试标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isScopeLocked},on:{"change":_vm.onIsCommonChanged},model:{value:(_vm.form.is_common),callback:function ($$v) {_vm.$set(_vm.form, "is_common", $$v)},expression:"form.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),(Number(_vm.form.is_common) === _vm.consts.IS_COMMON_DEDICATED)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","disabled":_vm.isScopeLocked,"placeholder":"请选择客户","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择知识库","disabled":_vm.knowledgeDisabled,"query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge,"query-params":_vm.knowledgeQueryParams},model:{value:(_vm.form.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.form, "training_knowledge_id", $$v)},expression:"form.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否开卷","prop":"open_book_exam"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},on:{"input":_vm.onOpenBookExamChanged},model:{value:(_vm.form.open_book_exam),callback:function ($$v) {_vm.$set(_vm.form, "open_book_exam", $$v)},expression:"form.open_book_exam"}},_vm._l((_vm.opts.openBookMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),(_vm.form.open_book_exam===_vm.consts.OPEN_BOOK_EXAM_CLOSED)?_c('el-form-item',{attrs:{"label":"单题分值","prop":"question_score","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":1,"precision":0,"disabled":_vm.isReadonly,"controls":false},on:{"change":_vm.validatePassingScore},model:{value:(_vm.form.question_score),callback:function ($$v) {_vm.$set(_vm.form, "question_score", $$v)},expression:"form.question_score"}}),_vm._v(" "),_c('span',[_vm._v("分/题")]),_vm._v(" "),_c('span',{staticClass:"field-tip"},[_vm._v("("+_vm._s(_vm.questionCount)+"题 × "+_vm._s(_vm.form.question_score || 0)+"分 = "+_vm._s(_vm.totalScore)+"分)")])],1)]):_vm._e(),_vm._v(" "),(_vm.form.open_book_exam===_vm.consts.OPEN_BOOK_EXAM_CLOSED)?_c('el-form-item',{attrs:{"label":"及格分数","prop":"passing_score","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":0,"precision":0,"disabled":_vm.isReadonly,"controls":false},model:{value:(_vm.form.passing_score),callback:function ($$v) {_vm.$set(_vm.form, "passing_score", $$v)},expression:"form.passing_score"}}),_vm._v(" "),_c('span',[_vm._v("分")]),_vm._v(" "),_c('span',{staticClass:"field-tip"},[_vm._v("总分: "+_vm._s(_vm.totalScore)+"分")])],1)]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"考试时效","prop":"exam_duration","required":""}},[_c('div',{staticClass:"inline-number-field"},[_c('el-input-number',{attrs:{"min":1,"precision":0,"disabled":_vm.isReadonly,"controls":false},model:{value:(_vm.form.exam_duration),callback:function ($$v) {_vm.$set(_vm.form, "exam_duration", $$v)},expression:"form.exam_duration"}}),_vm._v(" "),_c('span',[_vm._v("分钟")])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目顺序","prop":"question_sort_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},model:{value:(_vm.form.question_sort_type),callback:function ($$v) {_vm.$set(_vm.form, "question_sort_type", $$v)},expression:"form.question_sort_type"}},_vm._l((_vm.opts.sortTypeMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"选项顺序","prop":"question_options_sort_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isReadonly},model:{value:(_vm.form.question_options_sort_type),callback:function ($$v) {_vm.$set(_vm.form, "question_options_sort_type", $$v)},expression:"form.question_options_sort_type"}},_vm._l((_vm.opts.sortTypeMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),1)],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("题目列表 ("+_vm._s(_vm.questionCount)+"题)")]),_vm._v(" "),(!_vm.form.question_list.length)?_c('div',{staticClass:"question-empty"},[_vm._v("\n            请从左侧添加题目\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.form.question_list),function(question,index){return _c('div',{key:question.client_id,ref:("questionCard_" + index),refInFor:true,class:['exam-question-card', _vm.activeQuestionIndex === index ? 'is-active' : ''],on:{"click":function($event){_vm.activeQuestionIndex = index}}},[_c('div',{staticClass:"exam-question-card__header"},[_c('strong',[_vm._v(_vm._s(index + 1)+". "+_vm._s(_vm.getQuestionTypeLabel(question.question_type)))]),_vm._v(" "),(!_vm.isStructureLocked)?_c('el-button',{attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){$event.stopPropagation();return _vm.removeQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('question-form',{attrs:{"form":question,"question-type":question.question_type,"prop-prefix":("question_list." + index),"is-view-mode":_vm.isReadonly,"is-answer-locked":_vm.isAnswerLocked,"is-option-structure-locked":_vm.isOptionStructureLocked},on:{"validate-field":_vm.validateField,"uploading-change":function($event){_vm.uploading = $event}}})],1)})],2)],1)])]),_vm._v(" "),_c('el-dialog',{staticClass:"question-bank-dialog",attrs:{"title":"从题库选择题目","width":"72%","visible":_vm.questionDialogVisible},on:{"update:visible":function($event){_vm.questionDialogVisible=$event},"open":_vm.onQuestionDialogOpen}},[_c('div',{staticClass:"question-bank-toolbar"},[_c('el-input',{attrs:{"clearable":"","prefix-icon":"el-icon-search","placeholder":"搜索题目"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchQuestionBank($event)}},model:{value:(_vm.questionSearch.title),callback:function ($$v) {_vm.$set(_vm.questionSearch, "title", $$v)},expression:"questionSearch.title"}}),_vm._v(" "),_c('remote-select',{attrs:{"clearable":"","placeholder":"所有客户","query-request":_vm.getBasicCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.questionSearch.customerid),callback:function ($$v) {_vm.$set(_vm.questionSearch, "customerid", $$v)},expression:"questionSearch.customerid"}}),_vm._v(" "),_c('remote-select',{attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"所有知识库","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.questionSearch.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.questionSearch, "training_knowledge_id", $$v)},expression:"questionSearch.training_knowledge_id"}}),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","placeholder":"所有类型"},model:{value:(_vm.questionSearch.question_type),callback:function ($$v) {_vm.$set(_vm.questionSearch, "question_type", $$v)},expression:"questionSearch.question_type"}},_vm._l((_vm.questionOpts.questionTypeMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.searchQuestionBank}},[_vm._v("搜索\n      ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.resetQuestionSearch}},[_vm._v("重置")])],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.questionDialogLoading),expression:"questionDialogLoading"}],staticClass:"question-bank-list"},[_vm._l((_vm.questionBankList),function(row){return _c('div',{key:row.id,staticClass:"question-bank-item"},[_c('el-checkbox',{attrs:{"value":_vm.isBankQuestionSelected(row)},on:{"change":function (checked) { return _vm.toggleBankQuestion(row, checked); }}}),_vm._v(" "),_c('div',{staticClass:"question-bank-item__body"},[_c('div',{staticClass:"question-bank-item__meta"},[_c('span',{staticClass:"question-tag"},[_vm._v(_vm._s(_vm.getQuestionTypeLabel(_vm.getRowQuestionType(row))))]),_vm._v(" "),_c('span',[_vm._v("Q"+_vm._s(row.id))]),_vm._v(" "),(_vm.formatAccuracy(row))?_c('span',{staticClass:"accuracy-tag"},[_vm._v("正确率: "+_vm._s(_vm.formatAccuracy(row)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"question-bank-item__title"},[_vm._v(_vm._s(_vm.getRowQuestionTitle(row)))]),_vm._v(" "),_vm._l((_vm.getRowQuestionOptions(row)),function(option,index){return _c('div',{key:option.uuid || index,staticClass:"question-bank-item__option"},[_vm._v("\n            "+_vm._s(_vm.getOptionLetter(index))+". "+_vm._s(option.title)+"\n          ")])})],2)],1)}),_vm._v(" "),(!_vm.questionBankList.length && !_vm.questionDialogLoading)?_c('div',{staticClass:"question-bank-empty"},[_vm._v("\n        暂无题目\n      ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"question-bank-pagination"},[_c('span',[_vm._v("共 "+_vm._s(_vm.questionPagination.total)+" 条")]),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, jumper","current-page":_vm.questionPagination.current_page,"page-size":_vm.questionPagination.per_page,"total":_vm.questionPagination.total},on:{"current-change":_vm.handleQuestionPageChange}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"question-bank-footer"},[_c('span',[_vm._v("已选 "+_vm._s(_vm.selectedQuestionRows.length)+" 题")]),_vm._v(" "),_c('div',[_c('el-button',{on:{"click":function($event){_vm.questionDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.selectedQuestionRows.length},on:{"click":_vm.addSelectedQuestions}},[_vm._v("\n            添加至考试\n          ")])],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-examination.26033f3f67044b31c624.js